(function() {
  let state = {
    couleurActive: null,
    couleurChoisie: false,
    caissonCouleur: 'Blanc',
    caissonColorPrecise: '',
    poigneeActive: null,
    poigneeBasColonne: null,
    poigneeHaut: null,
    poigneeChoisie: false,
    etapeActuelle: 0,
    allCouleurs: [],
    produits: {},
    panier: [],
    loading: false,
    sensPorte: {}
  };
  // Expose le state pour le helper prix-conf-client.js (qui en a besoin
  // pour deriver couleur/caisson/poignee actifs lors des lookups Storefront).
  window.mooodState = state;
  // Init defensif (Etape E) : avant la suppression de chargerMetafields, cet
  // objet etait initialise par /collections/X?view=metafields. Maintenant
  // c'est mergeSfMetafields qui populate -- mais en cas de fallback legacy
  // products.json, mergeSfMetafields n'est pas appele. Initialisation ici
  // pour eviter "Cannot read property of undefined" sur les acces directs.
  window.mooodMetafields = window.mooodMetafields || {};
  // Delegation d'event pour le toggle accordeon "Coût de pose estimé" (cf.
  // buildCartHTML). On l'attache une seule fois sur document : le panier
  // se re-render a chaque modif (innerHTML), donc des listeners attaches
  // directement seraient perdus. Le delegate persiste. Replie par defaut.
  // Animation : max-height + opacity en fade-in (~300 ms). Au depliage, on
  // scrollIntoView le detail pour qu'il rentre dans le viewport sans
  // que l'utilisateur ait a scroller manuellement.
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-pose-toggle]');
    if (!trigger) return;
    e.preventDefault();
    const container = trigger.closest('[data-pose-container]');
    if (!container) return;
    const open = container.dataset.poseOpen === '1';
    container.dataset.poseOpen = open ? '0' : '1';
    const sum = container.querySelector('[data-pose-summary]');
    const det = container.querySelector('[data-pose-detail]');
    if (!det) return;
    if (open) {
      // FERMETURE : on fixe la hauteur courante puis collapse a 0.
      const h = det.scrollHeight;
      det.style.transition = 'max-height 0.28s ease-out, opacity 0.18s ease-out';
      det.style.overflow = 'hidden';
      det.style.maxHeight = h + 'px';
      det.offsetHeight; // reflow
      det.style.maxHeight = '0px';
      det.style.opacity = '0';
      setTimeout(function() {
        det.style.display = 'none';
        det.style.maxHeight = '';
        det.style.opacity = '';
        det.style.overflow = '';
        det.style.transition = '';
        if (sum) sum.style.display = '';
      }, 300);
    } else {
      // OUVERTURE : on display + anime max-height de 0 vers scrollHeight.
      if (sum) sum.style.display = 'none';
      det.style.display = '';
      det.style.overflow = 'hidden';
      det.style.maxHeight = '0px';
      det.style.opacity = '0';
      det.style.transition = 'max-height 0.32s cubic-bezier(.2,.9,.3,1), opacity 0.22s ease-out';
      det.offsetHeight; // reflow
      const target = det.scrollHeight;
      det.style.maxHeight = target + 'px';
      det.style.opacity = '1';
      // Au bout de l'anim : reset pour que le detail puisse grandir si re-render
      setTimeout(function() {
        det.style.maxHeight = '';
        det.style.overflow = '';
        det.style.transition = '';
      }, 340);
      // Scroll auto vers le detail. block:'nearest' ne scrolle que si necessaire.
      setTimeout(function() {
        try { det.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch(e) {}
      }, 60);
    }
  });
  // Helper local pour resoudre prix + variantId via Storefront API.
  // Fallback null si helper indispo (degradation gracieuse : retombe sur variant.price).
  function prixConfLookup(produit, opts) {
    if (window.mooodPrixConf && typeof window.mooodPrixConf.prixConf === 'function') {
      return window.mooodPrixConf.prixConf(produit, opts || {});
    }
    return Promise.resolve(null);
  }
  function prixConfBatchLookup(produits, opts) {
    if (window.mooodPrixConf && typeof window.mooodPrixConf.prixConfBatch === 'function') {
      return window.mooodPrixConf.prixConfBatch(produits, opts || {});
    }
    return Promise.resolve(new Map());
  }

  // === REFACTO STOREFRONT ETAPE B =============================================
  // Bascule de chargerCollection (et prefetch/restore) sur le helper
  // listProductsByCollection (Storefront API GraphQL) au lieu du legacy
  // /collections/{h}/products.json (13 MB par collection).
  //
  // Whitelist : seules les collections grosses ET dont le prix est resolu
  // via prixConfBatch (donc compatible avec variant shim) basculent. Les
  // autres (poignee-unit, etc.) restent en legacy products.json — petites
  // et necessitent le vrai variantId pour add-to-cart direct.
  //
  // Le helper ne retourne PAS les variants (cf. prix-conf-client.js : variants:[]).
  // On injecte un shim {id:0, price:priceRange.min, _shim:true} pour que le
  // legacy renderCollection continue de fonctionner. Le vrai variantId +
  // prix exact sont resolus juste apres render via prixConfBatchLookup
  // (deja en place pour les 3 collections cibles). Au click +/-, modifierPanier
  // re-resout via prixConfLookup (cache shared, instant en general).
  //
  // Etape C : retirer le shim + adapter renderCollection a la nouvelle shape (fait).
  // Etape E : suppression chargerMetafields + extension whitelist + variants (fait).
  // Etape F : suppression chargerTousLesProduits + chargerPageSuivante + bloc tronques (fait).
  //          fetchRetry conserve pour le fallback legacy /products.json de loadCollectionData.
  //          getVariantByColor / getVariantImage conserves : utilises en mode SF WITH_VARIANTS
  //          (poignee/joues/electro), dans chargerCouleurs, modifierPanier et restore.
  // Collections "complexes" : prix variable selon combo caisson+couleur+poignee.
  // Variants resolus a la demande via prixConfBatch/prixConfLookup.
  // Source de verite UNIQUE pour 4 chemins metier :
  //   1. Chargement Storefront sans variants (cf. loadCollectionData)
  //   2. Pre-fetch prixConfBatch avant sort prix exact (cf. renderCollection)
  //   3. Update DOM prix/variantId/image apres render (cf. renderCollection)
  //   4. Resolution prix/variantId/image au click +/- (cf. modifierPanier)
  // Quand on ajoute une future collection caisson+couleur+poignee, l'ajouter
  // ICI suffit pour activer les 4 chemins. Pre-refacto F, ces chemins avaient
  // 3 listes distinctes synchronisees a la main -> faible-profondeur avait
  // ete oubliee dans 2 d'entre elles (cf. fix 955eb6a).
  const SF_LIST_COLLECTIONS_NO_VARIANTS = new Set([
    'meuble-bas-unit',
    'meuble-haut-unit',
    'colonne-unit',
    'meuble-bas-faible-profondeur',
    // joues-et-fileurs : produits COULEUR-SEULE avec 137 couleurs. Resolus par
    // prixConfBatch (variantBySelectedOptions couleur-seule, cf. buildSelectedOptions)
    // = 1 variant/produit peu importe la couleur. Avant en WITH_VARIANTS avec
    // variants(first:30) -> couleurs >30e non chargees -> cartes grisees.
    'joues-et-fileurs-unit',
  ]);
  // Collections "simples" : variants charges via Storefront (first:30), ID
  // reel injecte directement. Necessaire car le panier de ces collections
  // ne passe pas par prixConfLookup. (Peu de variants -> first:30 suffit.)
  const SF_LIST_COLLECTIONS_WITH_VARIANTS = new Set([
    'poignee-unit',
    'electro-unit',
  ]);
  // Union : toutes les collections du configurateur qui basculent sur Storefront.
  const SF_LIST_COLLECTIONS = new Set([
    ...SF_LIST_COLLECTIONS_NO_VARIANTS,
    ...SF_LIST_COLLECTIONS_WITH_VARIANTS,
  ]);

  function adaptStorefrontProductsForLegacy(sfProducts /* , sfMetafields */) {
    return (sfProducts || []).map(function(p) {
      // Mode includeVariants (collections simples) : variants deja peuples par
      // le helper. featured_image est garde comme objet {src,alt}, on normalise
      // en string pour compat code restore qui assignait l'objet brut.
      if (p.variants && p.variants.length > 0) {
        var featSrcA = (p.featured_image && p.featured_image.src) || (typeof p.featured_image === 'string' ? p.featured_image : null);
        return Object.assign({}, p, { featured_image: featSrcA });
      }
      // Etape C : plus de shim. variants reste vide. Le helper lit
      // _firstVariantOpts pour resoudre la dim caisson (cf. findDimCaissonIdx
      // + computeDimCaissonValue dans prix-conf-client.js). Le renderer
      // utilise priceRange.minVariantPrice.amount comme prix initial puis
      // prixConfBatchLookup update le DOM avec le vrai prix + variantId.
      //
      // Normalisation : featured_image -> string URL (compat code restore
      // qui assigne directement produit.featured_image au panier).
      var featSrc = (p.featured_image && p.featured_image.src) || (typeof p.featured_image === 'string' ? p.featured_image : null);
      return Object.assign({}, p, {
        variants: [],
        featured_image: featSrc,
      });
    });
  }

  function mergeSfMetafields(sfm) {
    if (!sfm) return;
    window.mooodMetafields = window.mooodMetafields || {};
    for (var pid in sfm) {
      if (!Object.prototype.hasOwnProperty.call(sfm, pid)) continue;
      if (!Object.prototype.hasOwnProperty.call(window.mooodMetafields, pid)) {
        window.mooodMetafields[pid] = sfm[pid];
      }
    }
  }

  // Source unifiee pour charger la liste de produits d'une collection.
  // Retourne { products, source: 'sf'|'legacy', hasMore }.
  async function loadCollectionData(handle) {
    if (
      SF_LIST_COLLECTIONS.has(handle) &&
      window.mooodPrixConf &&
      typeof window.mooodPrixConf.listProductsByCollection === 'function'
    ) {
      try {
        var includeVariants = SF_LIST_COLLECTIONS_WITH_VARIANTS.has(handle);
        var sf = await window.mooodPrixConf.listProductsByCollection(handle, { includeVariants: includeVariants });
        mergeSfMetafields(sf && sf.metafields);
        return {
          products: adaptStorefrontProductsForLegacy(sf && sf.products, sf && sf.metafields),
          source: 'sf',
          hasMore: false, // listProductsByCollection charge jusqu'a 500 produits (5 pages x 100)
        };
      } catch (err) {
        console.warn('[loadCollectionData] fallback products.json pour', handle, ':', err && err.message);
      }
    }
    // Fallback ou collection hors whitelist
    var resp = await fetchRetry('/collections/' + handle + '/products.json?limit=20&page=1');
    if (!resp.ok) throw new Error('HTTP ' + resp.status + ' sur products.json');
    var data = await resp.json();
    var products = data.products || [];
    return { products: products, source: 'legacy', hasMore: products.length === 20 };
  }

  // === FIN REFACTO STOREFRONT ETAPE B =========================================

  // Retry avec backoff pour les fetchs lourds du storefront Shopify
  // (collections products.json fait ~13 MB, met 6-8s, et rate-limit
  // 429/500 frequents en charge). Sans retry, le configurateur reste
  // bloque sur "Chargement des ..." quand Shopify est en surcharge.
  // Strategy : 4 tentatives, backoff 1s/3s/7s, retry sur 429/500/502/503/504
  // ou erreur reseau.
  async function fetchRetry(url, opts) {
    opts = opts || {};
    const delays = [1000, 3000, 7000];
    let lastErr = null;
    for (let attempt = 0; attempt < 4; attempt++) {
      try {
        const res = await fetch(url, opts);
        if (res.ok) return res;
        // Retry sur 429 et 5xx
        if (res.status === 429 || (res.status >= 500 && res.status < 600)) {
          if (attempt < 3) {
            await new Promise(r => setTimeout(r, delays[attempt]));
            continue;
          }
        }
        // Autres codes (404 etc.) -> return tel quel, le caller decide
        return res;
      } catch (err) {
        lastErr = err;
        if (attempt < 3) {
          await new Promise(r => setTimeout(r, delays[attempt]));
          continue;
        }
        throw lastErr;
      }
    }
    if (lastErr) throw lastErr;
    throw new Error('fetchRetry epuise sans reponse');
  }

  function trackEvent(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...params });
    } catch(e) {}
  }

  const collections = window.mooodCollections || [];
  const categories = (window.mooodCategoriesCouleurs || []).sort((a,b) => a.ordre - b.ordre);

  function getTunnel() {
    const colsSansPoignee = collections.filter(c => c.handle !== 'poignee-unit');
    const needsPoigneeStep = state.poigneeBasColonne === 'Avec poignée' || state.poigneeHaut === 'Avec poignée';
    const cols = needsPoigneeStep
      ? [...colsSansPoignee, { handle: 'poignee-unit', title: 'Choisir votre poignée' }]
      : [...colsSansPoignee];
    return cols;
  }

  function formatPrice(price) {
    return parseFloat(price).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function getPoigneeForCollection(colHandle) {
    if (colHandle === 'meuble-haut-unit') return state.poigneeHaut || state.poigneeActive;
    return state.poigneeBasColonne || state.poigneeActive;
  }

  function getVariantByColor(product, colorName, poigneeOverride) {
    if (!product.variants) return null;
    const opts = product.options || [];
    const getOptName = o => typeof o === 'string' ? o : (o.name || '');
    const colorIdx = opts.findIndex(o => { const n = getOptName(o).toLowerCase(); return n.includes('couleur') || n.includes('color'); });
    const poigneeIdx = opts.findIndex(o => getOptName(o).toLowerCase().includes('poign'));
    const caissonIdx = opts.findIndex(o => getOptName(o).toLowerCase().includes('caisson'));
    const colorKey = `option${colorIdx + 1}`;
    const poigneeKey = `option${poigneeIdx + 1}`;
    const caissonKey = `option${caissonIdx + 1}`;
    const poigneeVal = poigneeOverride !== undefined ? poigneeOverride : state.poigneeActive;
    const caissonMap = { 'Blanc': 'Caisson blanc', 'Gris anthracite': 'Caisson gris foncé', 'Bois': 'Caisson couleur au choix', 'Couleur au choix': 'Caisson couleur au choix' };
    const caissonVal = state.caissonColorPrecise ? 'Caisson couleur au choix' : (caissonMap[state.caissonCouleur] || 'Caisson blanc');

    // Fonction générique : cherche la couleur dans toutes les options si colorIdx non trouvé
    function matchesColor(v) {
      const norm = s => (s || '').normalize('NFC');
      const cn = norm(colorName);
      if (colorIdx >= 0) return norm(v[colorKey]) === cn;
      return norm(v.option1) === cn || norm(v.option2) === cn || norm(v.option3) === cn;
    }

    if (poigneeIdx >= 0 && caissonIdx >= 0 && poigneeVal) {
      return product.variants.find(v => matchesColor(v) && v[poigneeKey] === poigneeVal && (v[caissonKey] || '').includes(caissonVal))
        || product.variants.find(v => matchesColor(v) && v[poigneeKey] === poigneeVal)
        || product.variants.find(v => matchesColor(v)) || null;
    }
    if (poigneeIdx >= 0 && poigneeVal) {
      return product.variants.find(v => matchesColor(v) && v[poigneeKey] === poigneeVal)
        || product.variants.find(v => matchesColor(v)) || null;
    }
    return product.variants.find(v => matchesColor(v)) || null;
  }

  function getVariantImage(product, variant, colorNameHint) {
    const colorToMatch = colorNameHint || variant?.option1 || variant?.option2 || variant?.option3;
    if (colorToMatch) {
      const norm = colorToMatch.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'_').replace(/^_+|_+$/g,'');
      const imgByName = product.images?.find(img => {
        const fnFull = (img.src||'').split('?')[0].split('/').pop();
        const couleurPart = fnFull.split('_-_')[0];
        const fn = couleurPart.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'_').replace(/^_+|_+$/g,'');
        return fn === norm;
      });
      if (imgByName) return imgByName.src;
    }
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (variant) {
      const featuredImg = product.images?.find(img => img.variant_ids && img.variant_ids.includes(variant.id));
      if (featuredImg) return featuredImg.src;
    }
    return product.images?.[0]?.src || '';
  }

  const handleOverrides = {
    'blanc-deco': 'blanc-melamine-mat',
    'beige-deco': 'beige-melamine-mat',
    'gris-deco': 'gris-melamine-mat',
    'taupe-deco': 'taupe-melamine-mat-deco',
    'bois-deco': 'bois-melamine-mat-deco',
    'anthracite-deco': 'anthracite-melamine-mat-deco',
    'vert-fonce-deco': 'vert-fonce-melamine-mat-deco',
    'vert-clair-deco': 'vert-clair-melamine-mat-deco',
    'bleu-clair-deco': 'bleu-clair-melamine-mat-deco',
    'terracotta-deco': 'terracotta-melamine-mat-deco'
  };

  function nomToHandle(nom) {
    const normalized = nom.toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return handleOverrides[normalized] || normalized;
  }

  // ─── Étape Sur-Mesure (Plan de travail / Crédence) ───────────────────────
  async function renderEtapeSurMesure(col) {
    const section = document.getElementById('moood-products-sections');
    if (!section) return;

    const config = (window.mooodSurMesure || []).find(s => s.etapeHandle === col.handle);
    if (!config) { renderEtapeProduit(); return; }
    if (config.type === 'barre') { renderEtapeBarreProduit(col); return; }
    if (config.type === 'niche') { renderEtapeNicheSurMesure(col); return; }
    if (config.type === 'caisson') { renderEtapeCaissonSurMesure(col); return; }
    if (config.type === 'facade') { renderEtapeFacadeSurMesure(col); return; }
    if (config.type === 'porte-derobee') { renderEtapePorteDerobeeSurMesure(col); return; }
    if (config.type === 'plinthe') { renderEtaplintheSurMesure(col); return; }
    if (config.type === 'niche-frigo' && window.mooodNicheFrigoRender) { window.mooodNicheFrigoRender(col); return; }
    if (config.type === 'colonne-lv' && window.mooodColonneLvRender) { window.mooodColonneLvRender(col); return; }
    let couleurs = [];
    try {
      const resp = await fetch(`/products/${config.handle}.json`);
      const data = (await resp.json()).product;
      const opts = (data.options || []).map(o => o.name);
      const colorIdx = opts.findIndex(o => ['couleur','coloris','color'].some(k => o.toLowerCase().includes(k)));
      if (colorIdx >= 0 && data.variants) {
        const seen = new Set();
        for (const v of data.variants) {
          const colorName = v[`option${colorIdx + 1}`];
          if (!colorName || seen.has(colorName)) continue;
          seen.add(colorName);
          const img = (data.images || []).find(i => i.variant_ids?.includes(v.id))?.src || '';
          couleurs.push({ name: colorName, image: img, swatchColor: '#e5e7eb', variantId: v.id, price: parseFloat(v.price) || 0 });
        }
      }
    } catch(e) { console.error('Erreur sur-mesure:', e); }

    const smState = {
      couleurActive: couleurs[0] || null,
      largeur: '',
      longueur: '',
      options: config.options.map(og => ({ nom: og.nom, active: og.choices[0] })),
      qtyOptions: (config.qtyOptions || []).map(o => ({ ...o, qty: 0 }))
    };

    function calcPrix() {
      if (!smState.largeur || !smState.longueur || !smState.couleurActive) return null;
      const l = parseFloat(smState.largeur);
      const L = parseFloat(smState.longueur);
      if (isNaN(l) || isNaN(L)) return null;
      if (l < config.largeurMin || l > config.largeurMax) return null;
      if (L < config.longueurMin || L > config.longueurMax) return null;
      const m2 = (l / 1000) * (L / 1000);
      const tiers = config.tiers || [];
      const tiersOk = tiers.length === 5 && tiers.every(v => v > 0);
      if (!tiersOk) return null;
      function getTierIdx(area) {
        const a = Math.round(area * 1000) / 1000;
        if (a <= 0.10) return 0; if (a <= 0.20) return 1;
        if (a <= 0.30) return 2; if (a <= 0.50) return 3; return 4;
      }
      const tierIdx = getTierIdx(m2);
      const prixM2 = tiers[tierIdx];
      let base = Math.round(m2 * prixM2 * 100) / 100;
      // Prix minimum appliqué à la base produit uniquement (avant options)
      const PRIX_MIN = 59.90;
      if (base < PRIX_MIN) base = PRIX_MIN;
      const extrasRadio = smState.options.reduce((s, og) => {
        if (og.active?.extraPerM2) return s + (og.active.extraPerM2 * m2);
        return s + (og.active?.extra || 0);
      }, 0);
      const extrasQty = smState.qtyOptions.reduce((s, o) => s + (o.qty * o.prixUnit), 0);
      let total = Math.round((base + extrasRadio + extrasQty) * 100) / 100;
      return total;
    }

    function updatePrixDisplay() {
      const prixCalc = calcPrix();
      const prixVal = section.querySelector('.moood-surmesure-prix-val');
      const placeholder = section.querySelector('.moood-surmesure-prix-placeholder');
      const addBtn = document.getElementById('sm-add-btn');
      if (prixCalc !== null) {
        if (prixVal) {
          prixVal.textContent = formatPrice(prixCalc);
        } else if (placeholder) {
          placeholder.outerHTML = `<div style="max-width:700px;margin:0 auto 20px;"><div class="moood-surmesure-prix-bloc" style="margin-bottom:0;padding:24px 28px;"><span class="moood-surmesure-prix-label" style="font-size:16px;">Prix estimé</span><span class="moood-surmesure-prix-val" style="font-size:32px;">${formatPrice(prixCalc)}</span></div></div>`;
        }
        if (addBtn) addBtn.disabled = false;
      } else {
        if (addBtn) addBtn.disabled = true;
      }
    }

    function renderSM() {
      const prix = calcPrix();
      section.innerHTML = `
        <div class="moood-surmesure-wrap">
          <h2 class="moood-section-titre">${config.titre}</h2>
          <div class="moood-surmesure-couleurs">
            <h3 style="font-size:16px;font-weight:600;margin:0 0 14px;">Choisir votre coloris</h3>
            <div class="moood-swatches-wrap" style="flex-wrap:wrap;gap:6px;max-width:100%;">
              ${couleurs.map(c => `
                <div class="moood-swatch-wrap ${smState.couleurActive?.name === c.name ? 'active' : ''}" data-sm-color="${c.name}" title="${c.name}" style="width:56px;height:56px;border-radius:50%;overflow:hidden;flex-shrink:0;cursor:pointer;border:2px solid ${smState.couleurActive?.name === c.name ? '#12433D' : 'transparent'};">
                  <div style="width:100%;height:100%;border-radius:50%;${c.image ? `background-image:url(${c.image});background-size:cover;background-position:center;` : `background:${c.swatchColor || '#e5e7eb'};`}"></div>
                </div>
              `).join('')}
            </div>
            ${smState.couleurActive ? `<div class="moood-couleur-nom" style="margin-top:8px;display:flex;align-items:center;gap:8px;">
              <div style="width:20px;height:20px;border-radius:50%;flex-shrink:0;${smState.couleurActive.image ? `background-image:url(${smState.couleurActive.image});background-size:cover;` : `background:#e5e7eb;`}"></div>
              ${smState.couleurActive.name}
            </div>` : ''}
          </div>
          <div class="moood-surmesure-dims">
            <div class="moood-dim-block">
              <div class="moood-dim-label">Largeur (mm)</div>
              <div class="moood-dim-hint">Min <strong>${config.largeurMin}</strong> · Max <strong>${config.largeurMax}</strong></div>
              <div class="moood-dim-input-wrap" id="sm-largeur-wrap">
                <input type="number" class="moood-dim-input" id="sm-largeur" placeholder="ex : ${config.largeurMax}" value="${smState.largeur}" min="${config.largeurMin}" max="${config.largeurMax}" />
                <span class="moood-dim-unit">mm</span>
              </div>
              <span class="moood-dim-error" id="sm-largeur-err" style="display:none;"></span>
            </div>
            <div class="moood-dim-block">
              <div class="moood-dim-label">Longueur (mm)</div>
              <div class="moood-dim-hint">Min <strong>${config.longueurMin}</strong> · Max <strong>${config.longueurMax}</strong></div>
              <div class="moood-dim-input-wrap" id="sm-longueur-wrap">
                <input type="number" class="moood-dim-input" id="sm-longueur" placeholder="ex : 3500" value="${smState.longueur}" min="${config.longueurMin}" max="${config.longueurMax}" />
                <span class="moood-dim-unit">mm</span>
              </div>
              <span class="moood-dim-error" id="sm-longueur-err" style="display:none;"></span>
            </div>
          </div>
          ${config.options.length ? `
          <div class="moood-surmesure-options">
            ${config.options.map((og, ogi) => `
              <div class="moood-option-group">
                <div class="moood-option-label">${og.nom}</div>
                ${og.choices.map((ch, chi) => `
                  <div class="moood-option-choice ${smState.options[ogi].active?.label === ch.label ? 'active' : ''}"
                       data-sm-option="${ogi}" data-sm-choice="${chi}">
                    <div class="moood-option-choice-left">
                      <div class="moood-option-radio"></div>
                      <span class="moood-option-choice-name">${ch.label}</span>
                    </div>
                    <span class="moood-option-choice-extra">${ch.extraPerM2 ? `(+${ch.extraPerM2.toFixed(2).replace('.', ',')} € / m²)` : (ch.extra === 0 ? '(inclus)' : `(+${ch.extra.toFixed(2).replace('.', ',')} €)`)}</span>
                  </div>
                `).join('')}
              </div>
            `).join('')}
          </div>` : ''}
          ${smState.qtyOptions.length ? (() => {
            const optsNormales = smState.qtyOptions.map((qo, qoi) => ({ qo, qoi })).filter(x => x.qo.groupe !== 'coupes');
            const optsCoupes = smState.qtyOptions.map((qo, qoi) => ({ qo, qoi })).filter(x => x.qo.groupe === 'coupes');
            const renderOpt = ({ qo, qoi }) => `
              <div class="moood-option-group">
                <div class="moood-option-label">${qo.nom}</div>
                <div style="display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border:1.5px solid #e5e7eb;border-radius:12px;background:#fbf3ef;gap:12px;">
                  ${qo.thumb ? `<img src="${qo.thumb}" alt="${qo.nom}" style="width:64px;height:64px;border-radius:8px;border:1.5px solid #12312b;background:#fff;object-fit:contain;padding:4px;flex-shrink:0;cursor:zoom-in;transition:transform 0.25s ease,box-shadow 0.25s ease;" onmouseover="this.style.transform='scale(2.2)';this.style.boxShadow='4px 4px 0 0 #DFAE3A';this.style.zIndex='10';this.style.position='relative';" onmouseout="this.style.transform='';this.style.boxShadow='';this.style.zIndex='';this.style.position='';">` : ''}
                  <span style="font-size:13px;color:#12312b;flex:1;">${qo.hint || ''}</span>
                  <div style="display:flex;align-items:center;gap:10px;flex-shrink:0;">
                    <button type="button" class="sm-qty-moins" data-sm-qty="${qoi}" style="width:28px;height:28px;border-radius:50%;border:1.5px solid #0f3f37;background:#fff;color:#0f3f37;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;">−</button>
                    <span class="sm-qty-num" data-sm-qty="${qoi}" style="font-size:15px;font-weight:600;color:#12312b;min-width:16px;text-align:center;">${qo.qty}</span>
                    <button type="button" class="sm-qty-plus" data-sm-qty="${qoi}" style="width:28px;height:28px;border-radius:50%;border:1.5px solid #0f3f37;background:#fff;color:#0f3f37;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;">+</button>
                  </div>
                </div>
              </div>
            `;
            return `
            <div class="moood-surmesure-options" style="margin-top:0;">
              ${optsNormales.map(renderOpt).join('')}
              ${optsCoupes.length ? `
                <div style="margin-top:8px;">
                  <div class="moood-option-label" style="font-size:14px;font-weight:700;color:#111827;margin-bottom:10px;">Coupes / découpes spéciales</div>
                  <div style="display:flex;align-items:flex-start;gap:10px;padding:12px 14px;margin-bottom:12px;background:#fff3e4;border:1.5px solid #C4622A;border-radius:12px;font-size:13px;font-weight:500;color:#12312b;line-height:1.45;">
                    <span style="flex-shrink:0;width:22px;height:22px;border-radius:50%;background:#C4622A;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:14px;margin-top:1px;">ℹ</span>
                    <span>Pour ces options, notre architecte aura besoin de détails supplémentaires. Il vous contactera après commande pour récupérer toutes les informations nécessaires à la réalisation.</span>
                  </div>
                  ${optsCoupes.map(renderOpt).join('')}
                </div>
              ` : ''}
            </div>`;
          })() : ''}
          <div style="max-width:700px;margin:0 auto 20px;">
            ${prix !== null ? `
            <div class="moood-surmesure-prix-bloc" style="margin-bottom:0;padding:24px 28px;">
              <span class="moood-surmesure-prix-label" style="font-size:16px;">Prix estimé</span>
              <span class="moood-surmesure-prix-val" style="font-size:32px;">${formatPrice(prix)}</span>
            </div>
            ` : `
            <div class="moood-surmesure-prix-placeholder" style="background:#f3f4f6;border-radius:16px;padding:20px;text-align:center;color:#9ca3af;">
              Saisissez vos dimensions pour voir le prix
            </div>
            `}
            <div style="font-size:13px;color:#12433D;text-align:center;margin-top:10px;font-weight:600;background:#f0f7f6;padding:10px 14px;border-radius:10px;">⚠ Prix minimum de 59,90 € pour ce produit sur mesure.</div>
          </div>
          <div style="max-width:700px;margin:0 auto;">
            <button class="moood-surmesure-btn-add" id="sm-add-btn" ${!prix ? 'disabled' : ''}>
              Ajouter au pack
            </button>
          </div>
        </div>
      `;

      section.querySelectorAll('[data-sm-color]').forEach(el => {
        el.addEventListener('click', () => {
          smState.couleurActive = couleurs.find(c => c.name === el.dataset.smColor);
          renderSM();
        });
      });

      let zoomEl = document.getElementById('moood-sm-zoom');
      if (!zoomEl) {
        zoomEl = document.createElement('div');
        zoomEl.id = 'moood-sm-zoom';
        zoomEl.className = 'moood-sm-zoom';
        document.body.appendChild(zoomEl);
      }
      let zoomTimer = null;
      section.querySelectorAll('[data-sm-color]').forEach(el => {
        const couleur = couleurs.find(c => c.name === el.dataset.smColor);
        if (!couleur?.image) return;
        el.addEventListener('mouseenter', () => { zoomEl.style.backgroundImage = `url(${couleur.image})`; zoomEl.style.display = 'block'; });
        el.addEventListener('mousemove', (e) => { zoomEl.style.left = e.clientX + 'px'; zoomEl.style.top = e.clientY + 'px'; });
        el.addEventListener('mouseleave', () => { zoomEl.style.display = 'none'; });
        el.addEventListener('touchstart', (e) => {
          const t = e.touches[0];
          zoomEl.style.backgroundImage = `url(${couleur.image})`;
          zoomEl.style.left = t.clientX + 'px';
          zoomEl.style.top = t.clientY + 'px';
          zoomEl.style.display = 'block';
          clearTimeout(zoomTimer);
          zoomTimer = setTimeout(() => { zoomEl.style.display = 'none'; }, 1500);
        }, { passive: true });
      });

      function checkSmDim(id, val, min, max) {
        const wrap = document.getElementById(id + '-wrap');
        const err = document.getElementById(id + '-err');
        if (!wrap || !err) return;
        const v = parseFloat(val);
        if (val === '' || isNaN(v)) {
          wrap.classList.remove('error');
          err.style.display = 'none';
          return;
        }
        if (v < min) {
          wrap.classList.add('error');
          err.textContent = `Trop petit : minimum ${min} mm`;
          err.style.display = 'block';
        } else if (v > max) {
          wrap.classList.add('error');
          err.textContent = `Trop grand : maximum ${max} mm`;
          err.style.display = 'block';
        } else {
          wrap.classList.remove('error');
          err.style.display = 'none';
        }
      }
      ['sm-largeur', 'sm-longueur'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('input', (e) => {
          if (id === 'sm-largeur') smState.largeur = e.target.value;
          else smState.longueur = e.target.value;
          if (id === 'sm-largeur') checkSmDim('sm-largeur', e.target.value, config.largeurMin, config.largeurMax);
          else checkSmDim('sm-longueur', e.target.value, config.longueurMin, config.longueurMax);
          updatePrixDisplay();
        });
      });

      section.querySelectorAll('[data-sm-option]').forEach(el => {
        el.addEventListener('click', () => {
          const ogi = parseInt(el.dataset.smOption);
          const chi = parseInt(el.dataset.smChoice);
          smState.options[ogi].active = config.options[ogi].choices[chi];
          renderSM();
        });
      });

      section.querySelectorAll('.sm-qty-plus').forEach(btn => {
        btn.addEventListener('click', () => {
          const qoi = parseInt(btn.dataset.smQty);
          smState.qtyOptions[qoi].qty++;
          const numEl = section.querySelector(`.sm-qty-num[data-sm-qty="${qoi}"]`);
          if (numEl) numEl.textContent = smState.qtyOptions[qoi].qty;
          updatePrixDisplay();
        });
      });
      section.querySelectorAll('.sm-qty-moins').forEach(btn => {
        btn.addEventListener('click', () => {
          const qoi = parseInt(btn.dataset.smQty);
          if (smState.qtyOptions[qoi].qty > 0) smState.qtyOptions[qoi].qty--;
          const numEl = section.querySelector(`.sm-qty-num[data-sm-qty="${qoi}"]`);
          if (numEl) numEl.textContent = smState.qtyOptions[qoi].qty;
          updatePrixDisplay();
        });
      });

      const addBtn = document.getElementById('sm-add-btn');
      if (addBtn) addBtn.addEventListener('click', () => {
        const prixFinal = calcPrix();
        if (!prixFinal || !smState.couleurActive || !smState.largeur || !smState.longueur) return;
        const radioDesc = smState.options.map(og => `${og.nom}: ${og.active.label}`).join(' | ');
        const qtyDesc = smState.qtyOptions.filter(o => o.qty > 0).map(o => `${o.nom}: ${o.qty}`).join(' | ');
        const desc = `${smState.largeur}×${smState.longueur}mm${radioDesc ? ' · ' + radioDesc : ''}${qtyDesc ? ' · ' + qtyDesc : ''}`;
        state.panier.push({
          productId: 'surmesure-' + config.handle,
          variantId: smState.couleurActive.variantId,
          name: config.titre + ' — ' + smState.couleurActive.name,
          color: desc,
          price: prixFinal,
          image: smState.couleurActive.image,
          qty: 1,
          collection: col.handle,
          surMesure: true,
          surMesureProps: {
            largeur: smState.largeur,
            longueur: smState.longueur,
            options: [
              ...smState.options.map(og => ({ nom: og.nom, valeur: og.active.label })),
              ...smState.qtyOptions.filter(o => o.qty > 0).map(o => ({ nom: o.nom, valeur: `${o.qty} pièce${o.qty > 1 ? 's' : ''}` }))
            ]
          }
        });
        renderPanier(smState.couleurActive.variantId);
        updateEtapeBarre(col.handle);
        document.querySelectorAll('.moood-etape').forEach(el => el.classList.remove('current'));
        document.querySelector(`.moood-etape[data-etape="${col.handle}"]`)?.classList.add('current');
        updateNavBar();
        if (addBtn) { addBtn.textContent = '✓ Ajouté au pack !'; setTimeout(() => { addBtn.textContent = 'Ajouter au pack'; }, 2000); }
      });

      updateNavBar();
    }

    renderSM();
  }

  // ─── Étape Façade Sur-Mesure ───────────────────────────────────────────────
  // ─── Tables de prix partagées ─────────────────────────────────────────────


    async function renderEtapeFacadeSurMesure(col) {
    const section = document.getElementById('moood-products-sections');
    if (!section) return;
    function detectFinFacade(name) {
      const t = (name || '').toLowerCase();
      if (t.includes('brillant')) return 'brillant';
      if (t.includes('deco'))     return 'melamine';
      if (/\bmat\b/.test(t))     return 'mat';
      return 'texture';
    }
    function getTarifFacade(fin, poignee) {
      const key = fin + '_' + (poignee === 'integree' ? 'int' : 'avec');
      if (key === 'brillant_int' || key === 'mat_int') return MOOOD_FT['laque_int'];
      return MOOOD_FT[key] || MOOOD_FT['melamine_avec'];
    }
      function findIdxF(arr, val) { for (let i = 0; i < arr.length; i++) if (arr[i] >= val) return i; return -1; }
    const r2F = n => Math.round((n + Number.EPSILON) * 100) / 100;
    const fmtF = n => r2F(n).toFixed(2).replace('.', ',');

    // Déterminer finition et poignée depuis couleur active
    const couleurActive = state.couleurActive;
    const poigneeActive = state.poigneeActive; // 'Avec poignée' ou 'Poignée intégrée'
    let finKey = detectFinFacade(couleurActive ? couleurActive.name : '');
    let poigneeKey = (poigneeActive === 'Poignée intégrée') ? 'integree' : 'avec';

    // Fetch variant ID
    let facadeVarId = null;
    let allVariants = [];
    try {
      const rp = await fetch('/products/facade-joue-fileur-plinthe-sur-mesure.js');
      const pd = await rp.json();
      allVariants = pd.variants || [];
      if (couleurActive) {
        const v = allVariants.find(v => v.option1 === couleurActive.name);
        if (v) facadeVarId = v.id;
      }
      if (!facadeVarId && allVariants.length) facadeVarId = allVariants[0].id;
    } catch(e) {}

    const fs = { H: '', L: '', type: null };
    const FACADE_TYPES = ['Façade', 'Joue', 'Fileur'];

    function calcFacade() {
      const tbl = getTarifFacade(finKey, poigneeKey);
      const H = parseInt(fs.H, 10), L = parseInt(fs.L, 10);
      if (!Number.isFinite(H) || !Number.isFinite(L)) return null;
      const maxH = tbl.H[tbl.H.length - 1];
      if (H < 138 || H > maxH || L < 100 || L > 1197) return null;
      const hi = findIdxF(tbl.H, H), li = findIdxF(tbl.L, L);
      if (hi < 0 || li < 0 || tbl.P[hi][li] == null) return null;
      let pTTC = r2F(tbl.P[hi][li] * MOOOD_TVA);
      // Prix minimum façade : 19,90€
      if (pTTC < 19.90) pTTC = 19.90;
      return { pTTC, tbl, hRef: tbl.H[hi], lRef: tbl.L[li] };
    }

    function renderFacade() {
      const res = calcFacade();
      const tbl = getTarifFacade(finKey, poigneeKey);
      const maxH = tbl.H[tbl.H.length - 1];

      section.innerHTML = `
        <div class="moood-surmesure-wrap">
          <h2 class="moood-section-titre">Façade sur mesure</h2>
          <div class="moood-option-group" style="margin-bottom:24px;">
            <div class="moood-option-label">Type d'élément</div>
            <div style="display:flex;gap:10px;flex-wrap:wrap;">
              ${FACADE_TYPES.map(t => `
                <div class="moood-option-choice${fs.type===t?' active':''}" data-facade-type="${t}" style="flex:1;min-width:100px;justify-content:center;">
                  <div class="moood-option-choice-left" style="justify-content:center;">
                    <div class="moood-option-radio"></div>
                    <span class="moood-option-choice-name">${t}</span>
                  </div>
                </div>`).join('')}
            </div>
          </div>
          <div class="moood-surmesure-dims">
            <div class="moood-dim-block">
              <div class="moood-dim-label">Hauteur (mm)</div>
              <div class="moood-dim-hint">Min 138 · Max ${maxH}</div>
              <div class="moood-dim-input-wrap" id="facade-H-wrap">
                <input type="number" class="moood-dim-input" id="facade-H" placeholder="ex : 598" value="${fs.H}">
                <span class="moood-dim-unit">mm</span>
              </div>
              <span class="moood-dim-error" id="facade-H-err" style="display:none;"></span>
              <span id="facade-H-hint" style="display:block;font-size:12px;margin-top:6px;min-height:16px;color:#6b7280;"></span>
            </div>
            <div class="moood-dim-block">
              <div class="moood-dim-label">Largeur (mm)</div>
              <div class="moood-dim-hint">Min 100 · Max 1197</div>
              <div class="moood-dim-input-wrap" id="facade-L-wrap">
                <input type="number" class="moood-dim-input" id="facade-L" placeholder="ex : 597" value="${fs.L}">
                <span class="moood-dim-unit">mm</span>
              </div>
              <span class="moood-dim-error" id="facade-L-err" style="display:none;"></span>
              <span id="facade-L-hint" style="display:block;font-size:12px;margin-top:6px;min-height:16px;color:#6b7280;"></span>
            </div>
          </div>
          <div style="max-width:700px;margin:0 auto 20px;">
            ${res ? `
            <div class="moood-surmesure-prix-bloc" style="padding:24px 28px;">
              <span class="moood-surmesure-prix-label" style="font-size:16px;">Prix TTC unitaire</span>
              <span class="moood-surmesure-prix-val" style="font-size:32px;">${fmtF(res.pTTC)} €</span>
            </div>
            ` : `
            <div style="background:#f3f4f6;border-radius:16px;padding:20px;text-align:center;color:#9ca3af;" id="facade-prix-placeholder">Saisissez vos dimensions pour voir le prix</div>
            `}
            <div style="font-size:13px;color:#12433D;text-align:center;margin-top:10px;font-weight:600;background:#f0f7f6;padding:10px 14px;border-radius:10px;">⚠ Prix minimum de 19,90 € pour ce produit sur mesure.</div>
          </div>
          <div style="max-width:700px;margin:0 auto;">
            <button class="moood-surmesure-btn-add" id="facade-add-btn" ${!res ? 'disabled' : ''}>Ajouter au pack</button>
          </div>
        </div>`;

      function updateHints(H, L, res) {
        const hHint = document.getElementById('facade-H-hint');
        const lHint = document.getElementById('facade-L-hint');
        if (hHint && res) hHint.textContent = H === res.hRef ? `Valeur exacte : ${res.hRef}mm` : `Tranche : ${res.hRef}mm`;
        if (lHint && res) lHint.textContent = L === res.lRef ? `Valeur exacte : ${res.lRef}mm` : `Tranche : ${res.lRef}mm`;
      }

      function updatePrix() {
        const res = calcFacade();
        const placeholder = document.getElementById('facade-prix-placeholder');
        const addBtn = document.getElementById('facade-add-btn');
        const prixBloc = section.querySelector('.moood-surmesure-prix-bloc');
        if (res) {
          updateHints(parseInt(fs.H), parseInt(fs.L), res);
          const html = `<div class="moood-surmesure-prix-bloc" style="padding:24px 28px;"><span class="moood-surmesure-prix-label" style="font-size:16px;">Prix TTC unitaire</span><span class="moood-surmesure-prix-val" style="font-size:32px;">${fmtF(res.pTTC)} €</span></div>`;
          if (prixBloc) prixBloc.outerHTML = html;
          else if (placeholder) placeholder.outerHTML = `<div style="max-width:700px;margin:0 auto 20px;">${html}</div>`;
          if (addBtn) addBtn.disabled = false;
        } else {
          if (prixBloc) prixBloc.outerHTML = `<div style="background:#f3f4f6;border-radius:16px;padding:20px;text-align:center;color:#9ca3af;margin-bottom:20px;" id="facade-prix-placeholder">Saisissez des dimensions valides</div>`;
          if (addBtn) addBtn.disabled = true;
        }
      }

      section.querySelectorAll('[data-facade-type]').forEach(el => {
        el.addEventListener('click', () => {
          fs.type = el.dataset.facadeType;
          section.querySelectorAll('[data-facade-type]').forEach(e => e.classList.toggle('active', e.dataset.facadeType === fs.type));
        });
      });

      function checkFacadeDim(id, val, min, max) {
        const wrap = document.getElementById(id + '-wrap');
        const err = document.getElementById(id + '-err');
        if (!wrap || !err) return;
        const v = parseFloat(val);
        if (val === '' || isNaN(v)) { wrap.classList.remove('error'); err.style.display = 'none'; return; }
        if (v < min) { wrap.classList.add('error'); err.textContent = `Trop petit : minimum ${min} mm`; err.style.display = 'block'; }
        else if (v > max) { wrap.classList.add('error'); err.textContent = `Trop grand : maximum ${max} mm`; err.style.display = 'block'; }
        else { wrap.classList.remove('error'); err.style.display = 'none'; }
      }
      ['facade-H','facade-L'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('input', e => {
          fs[id.replace('facade-','')] = e.target.value;
          if (id === 'facade-H') checkFacadeDim('facade-H', e.target.value, 138, maxH);
          else checkFacadeDim('facade-L', e.target.value, 100, 1197);
          updatePrix();
        });
      });

      const addBtn = document.getElementById('facade-add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', () => {
          const res = calcFacade();
          if (!res) return;
          const img = couleurActive && couleurActive.swatchImage ? couleurActive.swatchImage : '';
          state.panier.push({
            productId: 'surmesure-facade', variantId: facadeVarId,
            name: (fs.type || 'Façade') + ' sur mesure' + (couleurActive ? ' — ' + couleurActive.name : ''),
            color: `${fs.H}×${fs.L}mm · ${res.tbl.label}`,
            price: res.pTTC, image: img, qty: 1, collection: col.handle, surMesure: true,
            surMesureProps: { largeur: fs.L, longueur: fs.H, options: [
              { nom: 'Type', valeur: fs.type || 'Non précisé' },
              { nom: 'Couleur', valeur: couleurActive ? couleurActive.name : '' },
              { nom: 'Poignée', valeur: poigneeActive || '' },
              { nom: 'Dimensions', valeur: `${fs.H} × ${fs.L} mm` },
              { nom: 'Finition', valeur: res.tbl.label },
              { nom: 'Prix TTC unitaire', valeur: fmtF(res.pTTC) + ' €' }
            ]}
          });
          renderPanier(facadeVarId);
          updateEtapeBarre(col.handle);
          addBtn.textContent = '✓ Ajouté au pack !';
          setTimeout(() => { addBtn.textContent = 'Ajouter au pack'; }, 2000);
        });
      }
      updateNavBar();
    }

    renderFacade();
    updateEtapeBarre(col.handle);
    trackEvent('configurateur_etape', { etape: col.handle, numero: state.etapeActuelle + 1 });
  }

  // ─── Étape Plinthe / Étagère Sur-Mesure ────────────────────────────────────
  async function renderEtaplintheSurMesure(col) {
    var smConfig = (window.mooodSurMesure || []).find(function(s) { return s.etapeHandle === col.handle; });
    var titreProduit = smConfig ? smConfig.titre : 'Plinthe sur mesure';
    var handleProduit = smConfig ? smConfig.handle : 'plinthe-sur-mesure';
    const section = document.getElementById('moood-products-sections');
    if (!section) return;
    document.querySelectorAll('.moood-etape').forEach(el => el.classList.remove('current'));
    const etapeCourante = document.querySelector(`.moood-etape[data-etape="${col.handle}"]`);
    if (etapeCourante) { etapeCourante.classList.add('current'); etapeCourante.classList.add('active'); }
    if (state.poigneeChoisie) {
      ['moood-couleurs-section','moood-caisson-section','moood-poignee-section'].forEach(id => {
        const el = document.getElementById(id); if (el) el.style.display = 'none';
      });
    }

    function detectFinPl(name) {
      const t = (name || '').toLowerCase();
      if (t.includes('brillant')) return 'brillant';
      if (t.includes('deco')) return 'melamine';
      if (/\bmat\b/.test(t)) return 'mat';
      return 'texture';
    }
    function findIdxPl(arr, val) { for (let i = 0; i < arr.length; i++) if (arr[i] >= val) return i; return -1; }
    function getTarifPl(fin) {
      const key = fin + '_avec';
      return MOOOD_FT[key] || MOOOD_FT['melamine_avec'];
    }
    const r2Pl = n => Math.round((n + Number.EPSILON) * 100) / 100;
    const fmtPl = n => r2Pl(n).toFixed(2).replace('.', ',');

    const couleurActivePl = state.couleurActive;
    const finKey = detectFinPl(couleurActivePl ? couleurActivePl.name : '');
    const tblCur = getTarifPl(finKey);
    const finitionLabelPl = (tblCur.label || finKey).replace(/\s*\((avec\s*poignée|poignée\s*intégrée)\)/gi, '').trim();

    let plintheVarId = null;
    try {
      const rp = await fetch('/products/' + handleProduit + '.js');
      const pd = await rp.json();
      const variants = pd.variants || [];
      for (const v of variants) {
        if (couleurActivePl && v.option1 === couleurActivePl.name) { plintheVarId = v.id; break; }
      }
      if (!plintheVarId && variants.length) plintheVarId = variants[0].id;
    } catch(e) {}

    const ps = { H: '', L: '' };

    function calcPl() {
      const tbl = getTarifPl(finKey);
      const H = parseInt(ps.H, 10), L = parseInt(ps.L, 10);
      if (!Number.isFinite(H) || !Number.isFinite(L)) return null;
      const maxH = tbl.H[tbl.H.length - 1];
      if (H < 138 || H > maxH || L < 100 || L > 1197) return null;
      const hi = findIdxPl(tbl.H, H), li = findIdxPl(tbl.L, L);
      if (hi < 0 || li < 0 || tbl.P[hi][li] == null) return null;
      let pTTC = r2Pl(tbl.P[hi][li] * MOOOD_TVA);
      // Prix minimum plinthe : 19,90€
      if (pTTC < 19.90) pTTC = 19.90;
      return { pTTC, hRef: tbl.H[hi], lRef: tbl.L[li], label: tbl.label || finKey };
    }

    function renderPl() {
      const res = calcPl();
      const tbl = getTarifPl(finKey);
      const maxH = tbl.H[tbl.H.length - 1];
      section.innerHTML = `
        <div class="moood-surmesure-wrap">
          <h2 class="moood-section-titre">${titreProduit}</h2>
          
          <div class="moood-surmesure-dims">
            <div class="moood-dim-block">
              <div class="moood-dim-label">Largeur (mm)</div>
              <div class="moood-dim-hint">Min 138 · Max ${maxH}</div>
              <div class="moood-dim-input-wrap" id="pl-H-wrap"><input type="number" class="moood-dim-input" id="pl-H" placeholder="ex : 150" value="${ps.H}"><span class="moood-dim-unit">mm</span></div>
              <span class="moood-dim-error" id="pl-H-err" style="display:none;"></span>
              <span id="pl-H-hint" style="display:block;font-size:12px;margin-top:6px;min-height:16px;color:#6b7280;"></span>
            </div>
            <div class="moood-dim-block">
              <div class="moood-dim-label">Hauteur (mm)</div>
              <div class="moood-dim-hint">Min 100 · Max 1197</div>
              <div class="moood-dim-input-wrap" id="pl-L-wrap"><input type="number" class="moood-dim-input" id="pl-L" placeholder="ex : 900" value="${ps.L}"><span class="moood-dim-unit">mm</span></div>
              <span class="moood-dim-error" id="pl-L-err" style="display:none;"></span>
              <span id="pl-L-hint" style="display:block;font-size:12px;margin-top:6px;min-height:16px;color:#6b7280;"></span>
            </div>
          </div>
          <div style="max-width:700px;margin:0 auto 20px;">
            ${res ? `
            <div class="moood-surmesure-prix-bloc" style="padding:24px 28px;">
              <span class="moood-surmesure-prix-label" style="font-size:16px;">Prix TTC unitaire</span>
              <span class="moood-surmesure-prix-val" style="font-size:32px;">${fmtPl(res.pTTC)} €</span>
            </div>
            ` : `
            <div id="pl-prix-placeholder" style="background:#f3f4f6;border-radius:16px;padding:20px;text-align:center;color:#9ca3af;">Saisissez vos dimensions pour voir le prix</div>
            `}
            <div style="font-size:13px;color:#12433D;text-align:center;margin-top:10px;font-weight:600;background:#f0f7f6;padding:10px 14px;border-radius:10px;">⚠ Prix minimum de 19,90 € pour ce produit sur mesure.</div>
          </div>
          <div style="max-width:700px;margin:0 auto;"><button class="moood-surmesure-btn-add" id="pl-add-btn" ${!res ? 'disabled' : ''}>Ajouter au pack</button></div>
        </div>`;

      function updatePrixPl() {
        const res = calcPl();
        const prixBloc = section.querySelector('.moood-surmesure-prix-bloc');
        const placeholder = document.getElementById('pl-prix-placeholder');
        const addBtn = document.getElementById('pl-add-btn');
        const hHint = document.getElementById('pl-H-hint');
        const lHint = document.getElementById('pl-L-hint');
        if (res) {
          if (hHint) hHint.textContent = parseInt(ps.H) === res.hRef ? `Valeur exacte : ${res.hRef}mm` : `Tranche : ${res.hRef}mm`;
          if (lHint) lHint.textContent = parseInt(ps.L) === res.lRef ? `Valeur exacte : ${res.lRef}mm` : `Tranche : ${res.lRef}mm`;
          const html = `<div class="moood-surmesure-prix-bloc" style="padding:24px 28px;"><span class="moood-surmesure-prix-label" style="font-size:16px;">Prix TTC unitaire</span><span class="moood-surmesure-prix-val" style="font-size:32px;">${fmtPl(res.pTTC)} €</span></div>`;
          if (prixBloc) prixBloc.outerHTML = html;
          else if (placeholder) placeholder.outerHTML = `<div style="max-width:700px;margin:0 auto 20px;">${html}</div>`;
          if (addBtn) addBtn.disabled = false;
        } else {
          if (hHint) hHint.textContent = '';
          if (lHint) lHint.textContent = '';
          if (prixBloc) prixBloc.outerHTML = `<div id="pl-prix-placeholder" style="background:#f3f4f6;border-radius:16px;padding:20px;text-align:center;color:#9ca3af;margin-bottom:20px;">Saisissez des dimensions valides</div>`;
          if (addBtn) addBtn.disabled = true;
        }
      }

      function checkPlDim(id, val, min, max) {
        const wrap = document.getElementById(id + '-wrap');
        const err = document.getElementById(id + '-err');
        if (!wrap || !err) return;
        const v = parseFloat(val);
        if (val === '' || isNaN(v)) { wrap.classList.remove('error'); err.style.display = 'none'; return; }
        if (v < min) { wrap.classList.add('error'); err.textContent = `Trop petit : minimum ${min} mm`; err.style.display = 'block'; }
        else if (v > max) { wrap.classList.add('error'); err.textContent = `Trop grand : maximum ${max} mm`; err.style.display = 'block'; }
        else { wrap.classList.remove('error'); err.style.display = 'none'; }
      }
      ['pl-H','pl-L'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('input', e => {
          ps[id.replace('pl-','')] = e.target.value;
          if (id === 'pl-H') checkPlDim('pl-H', e.target.value, 138, maxH);
          else checkPlDim('pl-L', e.target.value, 100, 1197);
          updatePrixPl();
        });
      });

      const addBtn = document.getElementById('pl-add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', () => {
          const res = calcPl();
          if (!res) return;
          const tbl = getTarifPl(finKey);
          const img = couleurActivePl && couleurActivePl.swatchImage ? couleurActivePl.swatchImage : '';
          state.panier.push({
            productId: 'surmesure-' + handleProduit, variantId: plintheVarId,
            name: titreProduit + (couleurActivePl ? ' — ' + couleurActivePl.name : ''),
            color: `Largeur ${ps.H} × Hauteur ${ps.L} mm · ${finitionLabelPl}`,
            price: res.pTTC, image: img, qty: 1, collection: col.handle, surMesure: true,
            surMesureProps: { largeur: ps.L, longueur: ps.H, options: [
              { nom: 'Couleur', valeur: couleurActivePl ? couleurActivePl.name : '' },
              { nom: 'Dimensions', valeur: `Largeur ${ps.H} mm × Hauteur ${ps.L} mm` },
              { nom: 'Finition', valeur: finitionLabelPl },
              { nom: 'Prix TTC unitaire', valeur: fmtPl(res.pTTC) + ' €' }
            ]}
          });
          renderPanier(plintheVarId);
          updateEtapeBarre(col.handle);
          addBtn.textContent = '✓ Ajouté au pack !';
          setTimeout(() => { addBtn.textContent = 'Ajouter au pack'; }, 2000);
        });
      }
      updateNavBar();
    }

    renderPl();
    updateEtapeBarre(col.handle);
    trackEvent('configurateur_etape', { etape: col.handle, numero: state.etapeActuelle + 1 });
  }


// ─── Étape Porte dérobée Sur-Mesure ────────────────────────────────────────
  async function renderEtapePorteDerobeeSurMesure(col) {
    const section = document.getElementById('moood-products-sections');
    if (!section) return;
    document.querySelectorAll('.moood-etape').forEach(el => el.classList.remove('current'));
    const etapeCourante = document.querySelector(`.moood-etape[data-etape="${col.handle}"]`);
    if (etapeCourante) { etapeCourante.classList.add('current'); etapeCourante.classList.add('active'); }
    if (state.poigneeChoisie) {
      ['moood-couleurs-section','moood-caisson-section','moood-poignee-section'].forEach(id => {
        const el = document.getElementById(id); if (el) el.style.display = 'none';
      });
    }

    const TVA_PD = 1.2;
    const COEF_PD = 1.1;
    const PRIX_MIN_COMP = 19.90;

    function detectFinPD(name) {
      const t = (name || '').toLowerCase();
      if (t.indexOf('brillant') > -1) return 'brillant';
      if (t.indexOf('deco') > -1) return 'melamine';
      if (/\bmat\b/.test(t)) return 'mat';
      return 'texture';
    }
    function getTarifPD(fin, poignee) {
      let key = fin + '_' + (poignee === 'integree' ? 'int' : 'avec');
      if (key === 'brillant_int' || key === 'mat_int') key = 'laque_int';
      return MOOOD_FT[key] || MOOOD_FT['melamine_avec'];
    }
    function getFinLabelPD(fin, poignee) {
      const labels = { melamine: 'Mélaminé', texture: 'Bois texturé / Pierre / Métal', brillant: 'Laqué brillant', mat: 'Laqué ultra mat' };
      return (labels[fin] || fin) + (poignee === 'integree' ? ' (poignée intégrée)' : ' (avec poignée)');
    }
    function findIdxPD(arr, val) { for (let i = 0; i < arr.length; i++) if (arr[i] >= val) return i; return -1; }
    const r2PD = n => Math.round((n + Number.EPSILON) * 100) / 100;
    const fmtPD = n => r2PD(n).toFixed(2).replace('.', ',');

    function calcComponentDims(compKey, HT, HC, PC, LC) {
      switch (compKey) {
        case 'mg':
        case 'md': return { H: Math.max(0, HT - 19), L: PC };
        case 'tr': return { H: PC, L: LC };
        case 'porte': return { H: Math.max(0, HC - 2), L: Math.max(0, LC - 3) };
        case 'pl': return { H: Math.max(0, HT - HC - 2), L: Math.max(0, LC - 20) };
      }
      return { H: 0, L: 0 };
    }

    const couleurActivePD = state.couleurActive;
    const poigneeActivePD = state.poigneeBasColonne || state.poigneeActive;
    const finKey = detectFinPD(couleurActivePD ? couleurActivePD.name : '');
    const poigneeKey = (poigneeActivePD === 'Poignée intégrée') ? 'integree' : 'avec';
    const finLabel = getFinLabelPD(finKey, poigneeKey);
    const poigneeLabel = poigneeActivePD === 'Poignée intégrée' ? 'Poignée intégrée' : 'Avec poignée';

    let pdVarId = null;
    try {
      const rp = await fetch('/products/porte-derobee-sur-mesure.js');
      const pd = await rp.json();
      const variants = pd.variants || [];
      if (couleurActivePD) {
        const v = variants.find(v => v.option1 === couleurActivePD.name || v.option2 === couleurActivePD.name || v.option3 === couleurActivePD.name);
        if (v) pdVarId = v.id;
      }
      if (!pdVarId && variants.length) pdVarId = variants[0].id;
    } catch (e) {}

    const ps = { sens: 'Gauche', HT: '', HC: '', PC: '', LC: '', overrides: {} };
    let editingComp = null;

    const COMPS = [
      { key: 'porte', label: 'Porte avant' },
      { key: 'mg', label: 'Montant gauche' },
      { key: 'md', label: 'Montant droit' },
      { key: 'tr', label: 'Traverse haute' },
      { key: 'pl', label: 'Plinthe' }
    ];

    function getCompDims(compKey, HT, HC, PC, LC) {
      if (ps.overrides[compKey]) return ps.overrides[compKey];
      return calcComponentDims(compKey, HT, HC, PC, LC);
    }

    function calcPD() {
      const HT = parseInt(ps.HT, 10), HC = parseInt(ps.HC, 10), PC = parseInt(ps.PC, 10), LC = parseInt(ps.LC, 10);
      if (!HT || !HC || !PC || !LC) return null;
      const tbl = getTarifPD(finKey, poigneeKey);
      const maxH = tbl.H[tbl.H.length - 1];
      let totalBase = 0;
      const dims = {};
      for (const c of COMPS) {
        const d = getCompDims(c.key, HT, HC, PC, LC);
        dims[c.key] = d;
        if (d.H < 138 || d.H > maxH) return null;
        if (d.L < 100 || d.L > 1197) return null;
        const hi = findIdxPD(tbl.H, d.H), li = findIdxPD(tbl.L, d.L);
        if (hi < 0 || li < 0 || tbl.P[hi][li] == null) return null;
        let pTTC = r2PD(tbl.P[hi][li] * TVA_PD);
        if (pTTC < PRIX_MIN_COMP) pTTC = PRIX_MIN_COMP;
        totalBase += pTTC;
      }
      const totalFinal = r2PD(totalBase * COEF_PD);
      return { totalFinal, dims };
    }

    function renderCompRow(c, dims, isOverridden) {
      const idx = COMPS.findIndex(x => x.key === c.key) + 1;
      return `<div class="moood-pd-card${isOverridden ? ' moood-pd-card--overridden' : ''}">
        <div class="moood-pd-card__head">
          <span class="moood-pd-card__num">${idx}</span>
          <span class="moood-pd-card__label">${c.label}</span>
          ${isOverridden ? '<span class="moood-pd-card__tag">modifié</span>' : ''}
        </div>
        <div class="moood-pd-card__btnrow">
          <button type="button" class="moood-pd-card__btn" data-comp-toggle="${c.key}">${isOverridden ? '↺ Auto' : 'Modifier'}</button>
        </div>
        <div class="moood-pd-card__grid">
          <div class="moood-pd-card__field">
            <div class="moood-pd-card__lbl">Hauteur</div>
            <div class="moood-pd-card__inputwrap">
              <input type="number" class="moood-pd-card__input${!isOverridden ? ' moood-pd-card__input--ro' : ''}" data-comp-input-h="${c.key}" value="${dims.H}" ${!isOverridden ? 'readonly' : ''} />
              <span class="moood-pd-card__unit">mm</span>
            </div>
          </div>
          <div class="moood-pd-card__field">
            <div class="moood-pd-card__lbl">Largeur</div>
            <div class="moood-pd-card__inputwrap">
              <input type="number" class="moood-pd-card__input${!isOverridden ? ' moood-pd-card__input--ro' : ''}" data-comp-input-l="${c.key}" value="${dims.L}" ${!isOverridden ? 'readonly' : ''} />
              <span class="moood-pd-card__unit">mm</span>
            </div>
          </div>
        </div>
      </div>`;
    }

    function updateZones() {
      const res = calcPD();
      const compsZone = document.getElementById('pd-comps-zone');
      const prixZone = document.getElementById('pd-prix-zone');
      const addBtn = document.getElementById('pd-add-btn');
      if (res) {
        if (compsZone) {
          compsZone.innerHTML = `<div class="moood-pd-wrap">
            <div class="moood-pd-header">
              <span class="moood-pd-title">Composants calculés</span>
              ${Object.keys(ps.overrides).length ? `<button type="button" id="pd-reset-all" class="moood-pd-resetall">↺ Tout réinitialiser</button>` : ''}
            </div>
            <p class="moood-pd-subtitle">Clique sur Modifier pour ajuster une dimension manuellement.</p>
            <div class="moood-pd-cards-grid">
              ${COMPS.map(c => renderCompRow(c, res.dims[c.key], !!ps.overrides[c.key])).join('')}
            </div>
          </div>`;
          bindCompsListeners();
        }
        if (prixZone) prixZone.innerHTML = `<div class="moood-surmesure-prix-bloc" style="padding:24px 28px;"><span class="moood-surmesure-prix-label" style="font-size:16px;">Prix TTC unitaire</span><span class="moood-surmesure-prix-val" style="font-size:32px;">${fmtPD(res.totalFinal)} €</span></div>`;
        if (addBtn) addBtn.disabled = false;
      } else {
        if (compsZone) compsZone.innerHTML = '';
        if (prixZone) prixZone.innerHTML = `<div style="background:#f3f4f6;border-radius:16px;padding:20px;text-align:center;color:#9ca3af;">Saisis tes 4 dimensions de caisson pour voir le prix</div>`;
        if (addBtn) addBtn.disabled = true;
      }
    }

    function updatePrixOnly() {
      const res = calcPD();
      const prixZone = document.getElementById('pd-prix-zone');
      const addBtn = document.getElementById('pd-add-btn');
      if (res) {
        if (prixZone) prixZone.innerHTML = `<div class="moood-surmesure-prix-bloc" style="padding:24px 28px;"><span class="moood-surmesure-prix-label" style="font-size:16px;">Prix TTC unitaire</span><span class="moood-surmesure-prix-val" style="font-size:32px;">${fmtPD(res.totalFinal)} €</span></div>`;
        if (addBtn) addBtn.disabled = false;
      } else {
        if (prixZone) prixZone.innerHTML = `<div style="background:#fef2f2;border:1.5px solid #fca5a5;border-radius:16px;padding:20px;text-align:center;color:#dc2626;font-weight:600;">Dimensions hors limites (138–2498 mm en hauteur, 100–1197 mm en largeur)</div>`;
        if (addBtn) addBtn.disabled = true;
      }
    }

    function bindCompsListeners() {
      document.querySelectorAll('[data-comp-toggle]').forEach(btn => btn.addEventListener('click', () => {
        const key = btn.dataset.compToggle;
        if (ps.overrides[key]) {
          delete ps.overrides[key];
        } else {
          const HT = parseInt(ps.HT,10), HC = parseInt(ps.HC,10), PC = parseInt(ps.PC,10), LC = parseInt(ps.LC,10);
          ps.overrides[key] = calcComponentDims(key, HT, HC, PC, LC);
        }
        updateZones();
      }));
      const resetAllBtn = document.getElementById('pd-reset-all');
      if (resetAllBtn) resetAllBtn.addEventListener('click', () => {
        ps.overrides = {};
        updateZones();
      });
      document.querySelectorAll('[data-comp-input-h]').forEach(el => el.addEventListener('input', e => {
        const key = e.target.dataset.compInputH;
        if (!ps.overrides[key]) {
          const HT = parseInt(ps.HT,10), HC = parseInt(ps.HC,10), PC = parseInt(ps.PC,10), LC = parseInt(ps.LC,10);
          ps.overrides[key] = calcComponentDims(key, HT, HC, PC, LC);
        }
        ps.overrides[key].H = parseInt(e.target.value, 10) || 0;
        updatePrixOnly();
      }));
      document.querySelectorAll('[data-comp-input-l]').forEach(el => el.addEventListener('input', e => {
        const key = e.target.dataset.compInputL;
        if (!ps.overrides[key]) {
          const HT = parseInt(ps.HT,10), HC = parseInt(ps.HC,10), PC = parseInt(ps.PC,10), LC = parseInt(ps.LC,10);
          ps.overrides[key] = calcComponentDims(key, HT, HC, PC, LC);
        }
        ps.overrides[key].L = parseInt(e.target.value, 10) || 0;
        updatePrixOnly();
      }));
    }

    section.innerHTML = `
      <div class="moood-surmesure-wrap">
        <h2 class="moood-section-titre">Porte dérobée sur mesure</h2>
        <div class="moood-option-group" style="margin-bottom:24px;">
          <div class="moood-option-label">Sens d'ouverture</div>
          <div style="display:flex;gap:10px;flex-wrap:wrap;">
            <div class="moood-option-choice active" data-pd-sens="Gauche" style="flex:1;min-width:120px;">
              <div class="moood-option-choice-left"><div class="moood-option-radio"></div><span class="moood-option-choice-name">↖ Ouvrant gauche</span></div>
            </div>
            <div class="moood-option-choice" data-pd-sens="Droite" style="flex:1;min-width:120px;">
              <div class="moood-option-choice-left"><div class="moood-option-radio"></div><span class="moood-option-choice-name">↗ Ouvrant droite</span></div>
            </div>
          </div>
        </div>
        <div class="moood-option-label" style="max-width:700px;margin:0 auto 4px;">Tes dimensions de caisson</div>
        <p style="font-size:13px;color:#6b7280;max-width:700px;margin:0 auto 16px;">Mesure les caissons d'à côté pour avoir la même structure. Les 2 montants partent du sol jusqu'en haut.</p>
        <div class="moood-surmesure-dims" style="grid-template-columns:1fr 1fr;">
          <div class="moood-dim-block">
            <div class="moood-dim-label">Hauteur totale</div>
            <div class="moood-dim-hint">sol → haut (pied inclus) · Max <strong>2498</strong></div>
            <div class="moood-dim-input-wrap"><input type="number" class="moood-dim-input" id="pd-HT" placeholder="ex. 2150"><span class="moood-dim-unit">mm</span></div>
          </div>
          <div class="moood-dim-block">
            <div class="moood-dim-label">Hauteur du caisson</div>
            <div class="moood-dim-hint">caisson seul, sans le pied · Max <strong>2398</strong></div>
            <div class="moood-dim-input-wrap"><input type="number" class="moood-dim-input" id="pd-HC" placeholder="ex. 2000"><span class="moood-dim-unit">mm</span></div>
          </div>
          <div class="moood-dim-block">
            <div class="moood-dim-label">Profondeur du caisson</div>
            <div class="moood-dim-hint">même que le reste de la cuisine · Max <strong>1197</strong></div>
            <div class="moood-dim-input-wrap"><input type="number" class="moood-dim-input" id="pd-PC" placeholder="ex. 580"><span class="moood-dim-unit">mm</span></div>
          </div>
          <div class="moood-dim-block">
            <div class="moood-dim-label">Largeur du caisson</div>
            <div class="moood-dim-hint">largeur de l'emplacement · Max <strong>1197</strong></div>
            <div class="moood-dim-input-wrap"><input type="number" class="moood-dim-input" id="pd-LC" placeholder="ex. 600"><span class="moood-dim-unit">mm</span></div>
          </div>
        </div>
        <div id="pd-comps-zone"></div>
        <div id="pd-prix-zone" style="max-width:700px;margin:0 auto 20px;"></div>
        <div style="max-width:700px;margin:0 auto;"><button class="moood-surmesure-btn-add" id="pd-add-btn" disabled>Ajouter au pack</button></div>
      </div>`;

    section.querySelectorAll('[data-pd-sens]').forEach(el => el.addEventListener('click', () => {
      ps.sens = el.dataset.pdSens;
      section.querySelectorAll('[data-pd-sens]').forEach(b => b.classList.toggle('active', b.dataset.pdSens === ps.sens));
    }));

    ['pd-HT','pd-HC','pd-PC','pd-LC'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.addEventListener('input', e => {
        ps[id.replace('pd-','')] = e.target.value;
        updateZones();
      });
    });

    const addBtn = document.getElementById('pd-add-btn');
    if (addBtn) addBtn.addEventListener('click', () => {
      const r = calcPD();
      if (!r) return;
      const img = couleurActivePD && couleurActivePD.swatchImage ? couleurActivePD.swatchImage : '';
      const overrideList = Object.keys(ps.overrides);
      state.panier.push({
        productId: 'surmesure-porte-derobee', variantId: pdVarId,
        name: 'Porte dérobée sur mesure' + (couleurActivePD ? ' — ' + couleurActivePD.name : ''),
        color: `Ouverture ${ps.sens.toLowerCase()} · ${ps.HT}×${ps.HC}×${ps.PC}×${ps.LC}mm · ${finLabel}`,
        price: r.totalFinal, image: img, qty: 1, collection: col.handle, surMesure: true,
        poignee: poigneeLabel,
        surMesureProps: {
          largeur: ps.LC,
          longueur: ps.HT,
          options: [
            { nom: "Sens d'ouverture", valeur: ps.sens },
            { nom: 'Poignée', valeur: poigneeLabel },
            { nom: 'Finition', valeur: finLabel },
            { nom: 'Couleur', valeur: couleurActivePD ? couleurActivePD.name : '' },
            { nom: 'HT (caisson)', valeur: ps.HT + ' mm' },
            { nom: 'HC (caisson)', valeur: ps.HC + ' mm' },
            { nom: 'PC (caisson)', valeur: ps.PC + ' mm' },
            { nom: 'LC (caisson)', valeur: ps.LC + ' mm' },
            { nom: 'Porte (dimensions)', valeur: r.dims.porte.H + ' x ' + r.dims.porte.L + ' mm' + (ps.overrides.porte ? ' (modifié)' : '') },
            { nom: 'Montant gauche (dimensions)', valeur: r.dims.mg.H + ' x ' + r.dims.mg.L + ' mm' + (ps.overrides.mg ? ' (modifié)' : '') },
            { nom: 'Montant droit (dimensions)', valeur: r.dims.md.H + ' x ' + r.dims.md.L + ' mm' + (ps.overrides.md ? ' (modifié)' : '') },
            { nom: 'Traverse haute (dimensions)', valeur: r.dims.tr.H + ' x ' + r.dims.tr.L + ' mm' + (ps.overrides.tr ? ' (modifié)' : '') },
            { nom: 'Plinthe (dimensions)', valeur: r.dims.pl.H + ' x ' + r.dims.pl.L + ' mm' + (ps.overrides.pl ? ' (modifié)' : '') },
            ...(overrideList.length ? [{ nom: 'Composants modifiés', valeur: overrideList.length + ' / 5' }] : [])
          ]
        }
      });
      renderPanier(pdVarId);
      updateEtapeBarre(col.handle);
      addBtn.textContent = '✓ Ajouté au pack !';
      setTimeout(() => { addBtn.textContent = 'Ajouter au pack'; }, 2000);
    });

    updateZones();
    updateNavBar();
    updateEtapeBarre(col.handle);
    trackEvent('configurateur_etape', { etape: col.handle, numero: state.etapeActuelle + 1 });
  }
  
  // ─── Rendu d'un produit en barre (dimensions fixes) ───────────────────────
  async function renderEtapeBarreProduit(col) {
    const section = document.getElementById('moood-products-sections');
    if (!section) return;

    const config = (window.mooodSurMesure || []).find(s => s.etapeHandle === col.handle && s.type === 'barre');
    if (!config) return;

    document.querySelectorAll('.moood-etape').forEach(el => el.classList.remove('current'));
    const etapeCourante = document.querySelector(`.moood-etape[data-etape="${col.handle}"]`);
    if (etapeCourante) { etapeCourante.classList.add('current'); etapeCourante.classList.add('active'); }

    if (state.poigneeChoisie) {
      document.getElementById('moood-couleurs-section') && (document.getElementById('moood-couleurs-section').style.display = 'none');
      document.getElementById('moood-caisson-section') && (document.getElementById('moood-caisson-section').style.display = 'none');
      document.getElementById('moood-poignee-section') && (document.getElementById('moood-poignee-section').style.display = 'none');
    }

    section.innerHTML = `<h2 class="moood-section-titre">${config.titre}</h2><div class="moood-loading">Chargement…</div>`;
    updateNavBar();

    let product = null;
    try {
      const resp = await fetch(`/products/${config.handle}.json`);
      product = (await resp.json()).product;
    } catch(e) {
      section.innerHTML = `<h2 class="moood-section-titre">${config.titre}</h2><p style="color:#ef4444;">Erreur de chargement.</p>`;
      return;
    }
    if (!product || !product.variants?.length) {
      section.innerHTML = `<h2 class="moood-section-titre">${config.titre}</h2><p style="color:#9ca3af;">Produit introuvable.</p>`;
      return;
    }

    const opts = product.options || [];
    const colorIdx = opts.findIndex(o => ['couleur','coloris','color'].some(k => o.name.toLowerCase().includes(k)));

    const optionsValues = opts.map((opt, i) => {
      const vals = [...new Set(product.variants.map(v => v[`option${i+1}`]).filter(Boolean))];
      return { name: opt.name, values: vals };
    });

    const barreState = {
      options: opts.map((opt, i) => optionsValues[i].values[0]),
      couleurImage: ''
    };

    function getSelectedVariant() {
      return product.variants.find(v =>
        opts.every((opt, i) => v[`option${i+1}`] === barreState.options[i])
      ) || product.variants[0];
    }

    function getVariantImgByColor(colorVal) {
      const v = product.variants.find(vv => vv[`option${colorIdx+1}`] === colorVal);
      if (!v) return product.images?.[0]?.src || '';
      return (product.images || []).find(img => img.variant_ids?.includes(v.id))?.src || product.images?.[0]?.src || '';
    }

    function renderBarre() {
      const variant = getSelectedVariant();
      const prix = parseFloat(variant?.price || 0);
      const barreInfo = ({
        'plan-de-travail-en-barre': 'Largeur fixe 650 mm · Épaisseur fixe 38 mm',
        'credence-en-barre-epaisseur-10mm-largeur-65cm': 'Largeur fixe 650 mm · Épaisseur fixe 9 mm'
      })[config.handle] || 'Dimensions standard, prix fixe.';

      let couleursHtml = '';
      if (colorIdx >= 0) {
        const couleurs = optionsValues[colorIdx].values;
        couleursHtml = `
          <div class="moood-surmesure-couleurs">
            <h3 style="font-size:16px;font-weight:600;margin:0 0 14px;">Choisir votre coloris</h3>
            <div class="moood-swatches-wrap" style="flex-wrap:wrap;gap:6px;max-width:100%;">
              ${couleurs.map(c => {
                const cImg = getVariantImgByColor(c);
                const isActive = barreState.options[colorIdx] === c;
                return `<div class="moood-swatch-wrap" data-barre-color="${c}" title="${c}"
                  style="width:56px;height:56px;border-radius:50%;overflow:hidden;flex-shrink:0;cursor:pointer;border:2px solid ${isActive ? '#12433D' : 'transparent'};">
                  <div style="width:100%;height:100%;border-radius:50%;${cImg ? `background-image:url(${cImg});background-size:cover;background-position:center;` : 'background:#e5e7eb;'}"></div>
                </div>`;
              }).join('')}
            </div>
            <div style="margin-top:8px;font-size:13px;color:#6b7280;display:flex;align-items:center;gap:8px;">
              ${(() => { const cImg = getVariantImgByColor(barreState.options[colorIdx]); return `<div style="width:18px;height:18px;border-radius:50%;flex-shrink:0;${cImg?`background-image:url(${cImg});background-size:cover;`:'background:#e5e7eb;'}"></div>`; })()}
              ${barreState.options[colorIdx] || ''}
            </div>
          </div>`;
      }

      let optionsHtml = '';
      opts.forEach((opt, i) => {
        if (i === colorIdx) return;
        optionsHtml += `
          <div class="moood-option-group" style="max-width:700px;margin:0 auto 20px;">
            <div class="moood-option-label">${opt.name}</div>
            ${optionsValues[i].values.map(val => {
              const varBase = product.variants.find(v => opts.every((o, j) => {
                if (j === colorIdx) return v[`option${j+1}`] === barreState.options[colorIdx];
                if (j === i) return v[`option${j+1}`] === optionsValues[i].values[0];
                return v[`option${j+1}`] === barreState.options[j];
              }));
              const varThis = product.variants.find(v => opts.every((o, j) => {
                if (j === colorIdx) return v[`option${j+1}`] === barreState.options[colorIdx];
                if (j === i) return v[`option${j+1}`] === val;
                return v[`option${j+1}`] === barreState.options[j];
              }));
              const prixBase = parseFloat(varBase?.price || 0);
              const prixThis = parseFloat(varThis?.price || 0);
              const diff = Math.round((prixThis - prixBase) * 100) / 100;
              const diffLabel = diff === 0 ? '(inclus)' : `(+${diff.toFixed(2).replace('.', ',')} €)`;
              const isActive = barreState.options[i] === val;
              return `<div class="moood-option-choice ${isActive ? 'active' : ''}" data-barre-opt="${i}" data-barre-val="${val}">
                <div class="moood-option-choice-left">
                  <div class="moood-option-radio"></div>
                  <span class="moood-option-choice-name">${val}</span>
                </div>
                <span class="moood-option-choice-extra">${diffLabel}</span>
              </div>`;
            }).join('')}
          </div>`;
      });

      section.innerHTML = `
        <div class="moood-surmesure-wrap">
          <h2 class="moood-section-titre">${config.titre}</h2>
          <p style="font-size:14px;color:#6b7280;margin:-8px 0 24px;">${barreInfo}</p>
          ${couleursHtml}
          ${optionsHtml ? `<div class="moood-surmesure-options">${optionsHtml}</div>` : ''}
          <div style="max-width:700px;margin:0 auto 20px;">
            <div class="moood-surmesure-prix-bloc" style="padding:24px 28px;">
              <span class="moood-surmesure-prix-label" style="font-size:16px;">Prix</span>
              <span class="moood-surmesure-prix-val" style="font-size:32px;">${formatPrice(prix)}</span>
            </div>
          </div>
          <div style="max-width:700px;margin:0 auto;">
            <button class="moood-surmesure-btn-add" id="barre-add-btn">Ajouter au pack</button>
          </div>
        </div>
      `;

      section.querySelectorAll('[data-barre-color]').forEach(el => {
        el.addEventListener('click', () => {
          barreState.options[colorIdx] = el.dataset.barreColor;
          renderBarre();
        });
      });

      section.querySelectorAll('[data-barre-opt]').forEach(el => {
        el.addEventListener('click', () => {
          barreState.options[parseInt(el.dataset.barreOpt)] = el.dataset.barreVal;
          renderBarre();
        });
      });

      document.getElementById('barre-add-btn')?.addEventListener('click', () => {
        const v = getSelectedVariant();
        if (!v) return;
        const img = (product.images || []).find(i => i.variant_ids?.includes(v.id))?.src || product.images?.[0]?.src || '';
        const existing = state.panier.findIndex(i => i.variantId === v.id && i.collection === col.handle);
        if (existing >= 0) {
          state.panier[existing].qty++;
        } else {
          state.panier.push({
            productId: product.id,
            variantId: v.id,
            name: product.title + (barreState.options[colorIdx] ? ' — ' + barreState.options[colorIdx] : ''),
            color: barreState.options[colorIdx] || '',
            price: parseFloat(v.price),
            image: img,
            qty: 1,
            collection: col.handle,
            barreProps: opts.map((o, idx) => ({ nom: o.name, valeur: barreState.options[idx] })).filter(x => x.nom && !['couleur','coloris','color'].some(k => x.nom.toLowerCase().includes(k)))
          });
        }
        trackEvent('configurateur_ajout', { produit: product.title, collection: col.handle, prix: parseFloat(v.price) });
        updateEtapeBarre(col.handle);
        document.getElementById('moood-next-btn')?.classList.add('pulse');
        renderPanier(v.id);
        const btn = document.getElementById('barre-add-btn');
        if (btn) { btn.textContent = '✓ Ajouté au pack !'; setTimeout(() => { btn.textContent = 'Ajouter au pack'; }, 2000); }
      });

      updateNavBar();
    }

    renderBarre();
    updateEtapeBarre(col.handle);
    trackEvent('configurateur_etape', { etape: col.handle, numero: state.etapeActuelle + 1 });
  }

  // ─── Étape Niche Sur-Mesure ────────────────────────────────────────────────
  async function renderEtapeNicheSurMesure(col) {
    const section = document.getElementById('moood-products-sections');
    if (!section) return;
    document.querySelectorAll('.moood-etape').forEach(el => el.classList.remove('current'));
    const etapeCourante = document.querySelector(`.moood-etape[data-etape="${col.handle}"]`);
    if (etapeCourante) { etapeCourante.classList.add('current'); etapeCourante.classList.add('active'); }
    if (state.poigneeChoisie) {
      const cs2 = document.getElementById('moood-couleurs-section');
      const cs2c = document.getElementById('moood-caisson-section');
      const ps2 = document.getElementById('moood-poignee-section');
      if (cs2) cs2.style.display = 'none';
      if (cs2c) cs2c.style.display = 'none';
      if (ps2) ps2.style.display = 'none';
    }

    function detectFinNiche(name) {
      const t = (name || '').toLowerCase();
      if (t.includes('brillant')) return 'brillant';
      if (t.includes('deco')) return 'melamine';
      if (/\bmat\b/.test(t)) return 'laque_mat';
      return 'texture';
    }
    function findIdxN(arr, val) { for (let i = 0; i < arr.length; i++) if (arr[i] >= val) return i; return -1; }
    function lookupN(h, l, tbl) {
      const hi = findIdxN(tbl.H, h), li = findIdxN(tbl.L, l);
      if (hi < 0 || li < 0) return null;
      const v = tbl.P[hi][li];
      return v == null ? null : { ht: v, hRef: tbl.H[hi], lRef: tbl.L[li] };
    }
    const r2N = n => Math.round((n + Number.EPSILON) * 100) / 100;
    const fmtN = n => r2N(n).toFixed(2).replace('.', ',');

    const couleurActiveN = state.couleurActive;
    const finKey = detectFinNiche(couleurActiveN ? couleurActiveN.name : '');
    const ns = { H: '', L: '', P: '', E: '0' };

    let nicheVarId = null;
    try {
      const rp = await fetch('/products/niche-sur-mesure.js');
      const pd = await rp.json();
      const variants = pd.variants || [];
      for (const v of variants) {
        if (couleurActiveN && (v.title === couleurActiveN.name || v.option1 === couleurActiveN.name)) { nicheVarId = v.id; break; }
      }
      if (!nicheVarId && variants.length) nicheVarId = variants[0].id;
    } catch(e) {}

    function calcNiche() {
      const tbl = MOOOD_NT[finKey];
      const H = parseInt(ns.H, 10), L = parseInt(ns.L, 10), P = parseInt(ns.P, 10);
      if (!Number.isFinite(H)||!Number.isFinite(L)||!Number.isFinite(P)) return null;
      if (H<138||H>2498||L<138||L>1197||P<100||P>1197) return null;
      const EP = 18;
      const Lt = L - 2*EP; // largeur tablettes (entre joues)
      const Lf = L - 2*EP; // largeur fond (entre joues)
      const Hf = H - 2*EP; // hauteur fond (entre tablettes)
      if (Lt < 50 || Lf < 50 || Hf < 50) return null;
      const rJ = lookupN(H, P, tbl), rT = lookupN(Lt, P, tbl), rF = lookupN(Hf, Lf, tbl);
      if (!rJ||!rT||!rF) return null;
      const jouesTTC = r2N(rJ.ht*2*MOOOD_TVA), tabTTC = r2N(rT.ht*2*MOOOD_TVA), fondTTC = r2N(rF.ht*MOOOD_TVA);
      // Etagères : memes dimensions et meme prix unitaire que les tablettes
      // (Lt × P, lookup deja fait via rT). Lecture nb depuis ns.E (default 0).
      const nbE = (function(){var v=parseInt(ns.E,10);return Number.isFinite(v)&&v>0?v:0;})();
      const etagUnitTTC = r2N(rT.ht*MOOOD_TVA);
      const etagTTC = r2N(etagUnitTTC*nbE);
      let total = r2N(jouesTTC+tabTTC+fondTTC+etagTTC);
      // Prix minimum niche : 59,90€
      const minApplique = total < 59.90;
      if (minApplique) total = 59.90;
      return { total, jouesTTC, tabTTC, fondTTC, etagTTC, etagUnitTTC, nbE, rJ, rT, rF, Lt, Hf, minApplique };
    }

    function renderNiche() {
      const res = calcNiche();
      const tbl = MOOOD_NT[finKey];
      section.innerHTML = `
        <div class="moood-surmesure-wrap">
          <h2 class="moood-section-titre">Niche sur mesure</h2>
          
          <p style="font-size:13px;color:#6b7280;margin:-8px 0 24px;">Composition : 2 joues (H×P) + 2 tablettes (L×P) + 1 fond (H×L)</p>
          <div class="moood-surmesure-dims">
            <div class="moood-dim-block">
              <div class="moood-dim-label">Hauteur (mm)</div>
              <div class="moood-dim-hint">Min 138 · Max 2498</div>
              <div class="moood-dim-input-wrap" id="niche-H-wrap"><input type="number" class="moood-dim-input" id="niche-H" placeholder="ex : 400" value="${ns.H}"><span class="moood-dim-unit">mm</span></div>
              <span class="moood-dim-error" id="niche-H-err" style="display:none;"></span>
            </div>
            <div class="moood-dim-block">
              <div class="moood-dim-label">Largeur (mm)</div>
              <div class="moood-dim-hint">Min 138 · Max 1197</div>
              <div class="moood-dim-input-wrap" id="niche-L-wrap"><input type="number" class="moood-dim-input" id="niche-L" placeholder="ex : 600" value="${ns.L}"><span class="moood-dim-unit">mm</span></div>
              <span class="moood-dim-error" id="niche-L-err" style="display:none;"></span>
            </div>
            <div class="moood-dim-block">
              <div class="moood-dim-label">Profondeur (mm)</div>
              <div class="moood-dim-hint">Min 100 · Max 1197</div>
              <div class="moood-dim-input-wrap" id="niche-P-wrap"><input type="number" class="moood-dim-input" id="niche-P" placeholder="ex : 350" value="${ns.P}"><span class="moood-dim-unit">mm</span></div>
              <span class="moood-dim-error" id="niche-P-err" style="display:none;"></span>
            </div>
          </div>
          <div style="max-width:340px;margin:24px auto 32px;">
            <div class="moood-dim-block">
              <div class="moood-dim-label">Nombre d'étagères</div>
              <div class="moood-dim-hint">Optionnel · même finition · largeur intérieure × profondeur</div>
              <div class="moood-dim-input-wrap" id="niche-E-wrap"><input type="number" class="moood-dim-input" id="niche-E" placeholder="ex : 0" value="${ns.E}" min="0" step="1"><span class="moood-dim-unit">étag.</span></div>
              <span class="moood-dim-error" id="niche-E-err" style="display:none;"></span>
            </div>
          </div>
          <div style="max-width:700px;margin:0 auto 20px;">
            ${res ? `
            <div class="moood-surmesure-prix-bloc" style="flex-direction:column;gap:10px;padding:24px 28px;">
              <div style="width:100%;display:flex;justify-content:space-between;align-items:center;">
                <span style="font-size:16px;opacity:0.85;">Prix TTC estimé</span>
                <span style="font-size:32px;font-weight:700;">${fmtN(res.total)} €</span>
              </div>
              <div style="width:100%;font-size:12px;opacity:0.7;display:flex;flex-direction:column;gap:3px;">
                <div>2 joues (H×P) : ${ns.H}×${ns.P}mm — 2 × ${fmtN(r2N(res.rJ.ht*MOOOD_TVA))} € = ${fmtN(res.jouesTTC)} €</div>
                <div>2 tablettes (L×P) : ${res.Lt}×${ns.P}mm — 2 × ${fmtN(r2N(res.rT.ht*MOOOD_TVA))} € = ${fmtN(res.tabTTC)} €</div>
                <div>1 fond (H×L) : ${res.Hf}×${res.Lt}mm — ${fmtN(res.fondTTC)} €</div>
                ${res.nbE > 0 ? `<div>${res.nbE} étagère${res.nbE>1?'s':''} (L×P) : ${res.Lt}×${ns.P}mm — ${res.nbE} × ${fmtN(res.etagUnitTTC)} € = ${fmtN(res.etagTTC)} €</div>` : ''}
              </div>
            </div>
            ` : `
            <div id="niche-prix-zone" style="background:#f3f4f6;border-radius:16px;padding:20px;text-align:center;color:#9ca3af;">Saisissez vos 3 dimensions pour voir le prix</div>
            `}
            <div style="font-size:13px;color:#12433D;text-align:center;margin-top:10px;font-weight:600;background:#f0f7f6;padding:10px 14px;border-radius:10px;">⚠ Prix minimum de 59,90 € pour ce produit sur mesure.</div>
          </div>
          <div style="max-width:700px;margin:0 auto;"><button class="moood-surmesure-btn-add" id="niche-add-btn" ${!res ? 'disabled' : ''}>Ajouter au pack</button></div>
        </div>`;

      const NICHE_LIMITS = { 'niche-H': [138, 2498], 'niche-L': [138, 1197], 'niche-P': [100, 1197] };
      function checkNicheDim(id, val) {
        const wrap = document.getElementById(id + '-wrap');
        const err = document.getElementById(id + '-err');
        if (!wrap || !err) return;
        const [min, max] = NICHE_LIMITS[id];
        const v = parseFloat(val);
        if (val === '' || isNaN(v)) { wrap.classList.remove('error'); err.style.display = 'none'; return; }
        if (v < min) { wrap.classList.add('error'); err.textContent = `Trop petit : minimum ${min} mm`; err.style.display = 'block'; }
        else if (v > max) { wrap.classList.add('error'); err.textContent = `Trop grand : maximum ${max} mm`; err.style.display = 'block'; }
        else { wrap.classList.remove('error'); err.style.display = 'none'; }
      }
      function rerenderPrix() {
        const res = calcNiche();
        const tbl = MOOOD_NT[finKey];
        const prixBloc = section.querySelector('.moood-surmesure-prix-bloc');
        const placeholder = document.getElementById('niche-prix-zone');
        const addBtn = document.getElementById('niche-add-btn');
        if (res) {
          const html = `<div class="moood-surmesure-prix-bloc" style="flex-direction:column;gap:10px;padding:24px 28px;">
            <div style="width:100%;display:flex;justify-content:space-between;align-items:center;">
              <span style="font-size:16px;opacity:0.85;">Prix TTC estimé</span>
              <span style="font-size:32px;font-weight:700;">${fmtN(res.total)} €</span>
            </div>
            <div style="width:100%;font-size:12px;opacity:0.7;display:flex;flex-direction:column;gap:3px;">
              <div>2 joues (H×P) : 2 × ${fmtN(r2N(res.rJ.ht*MOOOD_TVA))} € = ${fmtN(res.jouesTTC)} €</div>
              <div>2 tablettes (L×P) : 2 × ${fmtN(r2N(res.rT.ht*MOOOD_TVA))} € = ${fmtN(res.tabTTC)} €</div>
              <div>1 fond (H×L) : ${fmtN(res.fondTTC)} €</div>
              ${res.nbE > 0 ? `<div>${res.nbE} étagère${res.nbE>1?'s':''} (L×P) : ${res.nbE} × ${fmtN(res.etagUnitTTC)} € = ${fmtN(res.etagTTC)} €</div>` : ''}
            </div>
          </div>`;
          if (prixBloc) prixBloc.outerHTML = html;
          else if (placeholder) placeholder.outerHTML = `<div style="max-width:700px;margin:0 auto 20px;">${html}</div>`;
          else {
            const addBtnEl = document.getElementById('niche-add-btn');
            if (addBtnEl) addBtnEl.insertAdjacentHTML('beforebegin', `<div style="max-width:700px;margin:0 auto 20px;">${html}</div>`);
          }
          if (addBtn) addBtn.disabled = false;
        } else {
          if (prixBloc) prixBloc.outerHTML = `<div style="background:#f3f4f6;border-radius:16px;padding:20px;text-align:center;color:#9ca3af;margin-bottom:20px;">Saisissez vos 3 dimensions pour voir le prix</div>`;
          if (addBtn) addBtn.disabled = true;
        }
      }
      ['niche-H','niche-L','niche-P'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('input', e => {
          ns[id.replace('niche-','')] = e.target.value;
          checkNicheDim(id, e.target.value);
          rerenderPrix();
        });
      });
      // Etage input : sanitization (>= 0 entier), refuse negatif ou non-numerique
      const elE = document.getElementById('niche-E');
      if (elE) elE.addEventListener('input', () => {
        const v = parseInt(elE.value, 10);
        if (!Number.isFinite(v) || v < 0) { elE.value = '0'; }
        ns.E = elE.value;
        rerenderPrix();
      });
      const addBtn = document.getElementById('niche-add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', () => {
          const res = calcNiche();
          if (!res) return;
          const img = couleurActiveN && couleurActiveN.swatchImage ? couleurActiveN.swatchImage : '';
          // Construction options : on stocke les valeurs BRUTES ici. Le label
          // affiche au panier ("Joues : 300 × 300 mm") est integre par
          // FIELD_BUILDERS['niche-sur-mesure'] dans moo-pack-chain.js (Etape 2).
          // Etagères : ajoutees uniquement si nbE > 0.
          const nicheOptions = [
            { nom: 'Couleur', valeur: couleurActiveN ? couleurActiveN.name : '' },
            { nom: 'Dimensions globales', valeur: `${ns.H} × ${ns.L} × ${ns.P} mm` },
            { nom: 'Finition', valeur: tbl.label },
            { nom: '2 joues (cotes usine)', valeur: `${ns.H} × ${ns.P} mm` },
            { nom: '2 tablettes (cotes usine)', valeur: `${res.Lt} × ${ns.P} mm` },
            { nom: '1 fond (cotes usine)', valeur: `${res.Hf} × ${res.Lt} mm` },
            { nom: 'Prix sur mesure', valeur: fmtN(res.total) + ' €' }
          ];
          if (res.nbE > 0) {
            nicheOptions.push({ nom: 'Nombre d’étagères', valeur: String(res.nbE) });
            nicheOptions.push({ nom: 'Étagères', valeur: `${res.Lt} × ${ns.P} mm — ${res.nbE} × ${fmtN(res.etagUnitTTC)} € = ${fmtN(res.etagTTC)} €` });
          }
          state.panier.push({
            productId: 'surmesure-niche', variantId: nicheVarId,
            name: 'Niche sur mesure' + (couleurActiveN ? ' — ' + couleurActiveN.name : ''),
            color: `${ns.H}×${ns.L}×${ns.P}mm — Joues (×2) ${ns.H}×${ns.P} / Tablettes (×2) ${res.Lt}×${ns.P} / Fond (×1) ${res.Hf}×${res.Lt}mm${res.nbE>0?` / Étagères (×${res.nbE}) ${res.Lt}×${ns.P}`:''} · ${tbl.label}`,
            price: res.total, image: img, qty: 1, collection: col.handle, surMesure: true,
            surMesureProps: { largeur: ns.L, longueur: ns.H, options: nicheOptions }
          });
          renderPanier(nicheVarId);
          updateEtapeBarre(col.handle);
          addBtn.textContent = '✓ Ajouté au pack !';
          setTimeout(() => { addBtn.textContent = 'Ajouter au pack'; }, 2000);
        });
      }
      updateNavBar();
    }

    renderNiche();
    updateEtapeBarre(col.handle);
    trackEvent('configurateur_etape', { etape: col.handle, numero: state.etapeActuelle + 1 });
  }

  // ─── Étape Meuble Sur-Mesure ───────────────────────────────────────────────
  async function renderEtapeCaissonSurMesure(col) {
    const section = document.getElementById('moood-products-sections');
    if (!section) return;
    document.querySelectorAll('.moood-etape').forEach(el => el.classList.remove('current'));
    const etapeCourante = document.querySelector(`.moood-etape[data-etape="${col.handle}"]`);
    if (etapeCourante) { etapeCourante.classList.add('current'); etapeCourante.classList.add('active'); }
    if (state.poigneeChoisie) {
      const cs2 = document.getElementById('moood-couleurs-section');
      const cs2c = document.getElementById('moood-caisson-section');
      const ps2 = document.getElementById('moood-poignee-section');
      if (cs2) cs2.style.display = 'none';
      if (cs2c) cs2c.style.display = 'none';
      if (ps2) ps2.style.display = 'none';
    }

    const CM_UTILITIES = {
      A:[{code:'A-1-1P',label:'Placard 1 porte'},{code:'A-1-2P',label:'Placard 2 portes'},{code:'A-2',label:'Épicier'},{code:'A-3-1P',label:'Placard + tiroir — 1 porte'},{code:'A-3-2P',label:'Placard + tiroir — 2 portes'},{code:'A-4-2C',label:'2 Casseroliers'},{code:'A-4-3C',label:'3 Casseroliers'},{code:'A-5-1P',label:'Évier 1 porte'},{code:'A-5-2P',label:'Évier 2 portes'}],
      B:[{code:'B-11-1PB',label:'Placard 1 porte (h.max 700mm)'},{code:'B-11-2PB',label:'Placard 2 portes (h.max 700mm)'},{code:'B-11-1PH',label:'Placard 1 porte (h.max 900mm)'},{code:'B-11-2PH',label:'Placard 2 portes (h.max 900mm)'},{code:'B-12-1PB',label:'Abattant 1 porte (h.max 700mm)'},{code:'B-12-2PB',label:'Abattant 2 portes (h.max 700mm)'},{code:'B-12-2PH',label:'Abattant 2 portes (h.max 900mm)'}],
      C:[{code:'C-21-1P',label:'Placard 1 porte'},{code:'C-21-2P',label:'Placard 2 portes'},{code:'C-22-1P',label:'Casserolier'},{code:'C-23-6T-1P',label:'6 tiroirs cachés — 1 porte'},{code:'C-23-6T-2P',label:'6 tiroirs cachés — 2 portes'},{code:'C-23-3T-2P',label:'3 tiroirs cachés — 2 portes'},{code:'C-24-FM',label:'Four + micro-onde'},{code:'C-24-F',label:'Four'},{code:'C-25-1P',label:'Frigo / congélateur — 1 porte'},{code:'C-25-2P',label:'Frigo / congélateur — 2 portes'}],
    };
    const CM_DIMS = {'A-1':{minW:150,maxW:1200,minH:300,maxH:700,minP:300,maxP:580},'A-2':{minW:150,maxW:450,minH:700,maxH:700,minP:580,maxP:580},'A-3':{minW:200,maxW:1200,minH:400,maxH:700,minP:580,maxP:580},'A-4':{minW:200,maxW:1200,minH:400,maxH:700,minP:580,maxP:580},'A-5':{minW:440,maxW:1200,minH:700,maxH:700,minP:580,maxP:580},'B-11':{minW:200,maxW:1200,minH:300,maxH:900,minP:200,maxP:330},'B-12':{minW:200,maxW:900,minH:300,maxH:900,minP:200,maxP:330},'C-21':{minW:300,maxW:600,minH:1800,maxH:2300,minP:300,maxP:580},'C-22':{minW:300,maxW:600,minH:1800,maxH:2300,minP:300,maxP:580},'C-23':{minW:300,maxW:600,minH:1800,maxH:2300,minP:300,maxP:580},'C-24':{minW:600,maxW:600,minH:1600,maxH:2300,minP:580,maxP:580},'C-25':{minW:600,maxW:600,minH:1600,maxH:2300,minP:580,maxP:580}};
    // modèles de référence : même table que la fiche caisson-sur-mesure (largeur ET hauteur pour les colonnes), 2026-10-23
    const CM_MAP = {"A-1-1P":[{"max":300,"h":"meuble-bas-de-rangement-1-porte-30-cm"},{"max":350,"h":"meuble-bas-de-rangement-1-porte-35-cm"},{"max":400,"h":"meuble-bas-de-rangement-1-porte-40cm-1"},{"max":450,"h":"meuble-bas-de-rangement-1-porte-45cm-1"},{"max":500,"h":"meuble-bas-de-rangement-1-porte-50cm-1"},{"max":600,"h":"meuble-bas-de-rangement-1-porte-60cm-1"},{"max":700,"h":"meuble-bas-de-rangement-1-porte-70cm-1"}],"A-1-2P":[{"max":600,"h":"meuble-bas-de-rangement-2-portes-60cm-1"},{"max":700,"h":"meuble-bas-de-rangement-2-portes-70cm-2"},{"max":800,"h":"meuble-bas-de-rangement-2-portes-80cm-1"},{"max":900,"h":"meuble-bas-de-rangement-2-portes-90cm-1"},{"max":1000,"h":"meuble-bas-de-rangement-2-portes-100cm-1"},{"max":1200,"h":"meuble-bas-de-rangement-2-portes-120cm-1"}],"A-2":[{"max":300,"h":"meuble-bas-epicier-30cm-1"},{"max":350,"h":"meuble-bas-epicier-35cm-1"},{"max":450,"h":"meuble-bas-epicier-40cm-1"}],"A-3-1P":[{"max":300,"h":"meuble-bas-1-porte-1-tiroir-30cm-1"},{"max":350,"h":"meuble-bas-1-porte-1-tiroir-35cm-1"},{"max":400,"h":"meuble-bas-1-porte-1-tiroir-40cm-1"},{"max":450,"h":"meuble-bas-1-porte-1-tiroir-largeur-45cm"},{"max":500,"h":"meuble-bas-1-porte-1-tiroir-50cm-1"},{"max":600,"h":"meuble-bas-1-porte-1-tiroir-60cm-1"},{"max":700,"h":"meuble-bas-1-porte-1-tiroir-70cm-1"}],"A-3-2P":[{"max":600,"h":"meuble-bas-2-portes-1-tiroir-60cm"},{"max":700,"h":"meuble-bas-2-portes-1-tiroir-70cm-1"},{"max":800,"h":"meuble-bas-2-portes-1-tiroir-80cm-1"},{"max":900,"h":"meuble-bas-2-portes-1-tiroir-90cm-1"},{"max":1000,"h":"meuble-bas-2-portes-1-tiroir-100cm-1"},{"max":1200,"h":"meuble-bas-2-portes-1-tiroir-120cm-1"}],"A-4-2C":[{"max":300,"h":"meuble-bas-2-casseroliers-30cm-1"},{"max":350,"h":"meuble-bas-2-casseroliers-35cm-2"},{"max":400,"h":"meuble-bas-2-casseroliers-40cm-1"},{"max":450,"h":"meuble-bas-2-casseroliers-45cm"},{"max":500,"h":"meuble-bas-2-casseroliers-50cm-1"},{"max":600,"h":"meuble-bas-2-casseroliers-60cm-1"},{"max":700,"h":"meuble-bas-2-casseroliers-2-tiroirs-70cm"},{"max":800,"h":"meuble-bas-2-casseroliers-2-tiroirs-80cm"},{"max":900,"h":"meuble-bas-2-casseroliers-2-tiroirs-90cm"},{"max":1000,"h":"meuble-bas-2-casseroliers-2-tiroirs-100cm"},{"max":1200,"h":"meuble-bas-2-casseroliers-2-tiroirs-120cm"}],"A-4-3C":[{"max":300,"h":"meuble-bas-3-casseroliers-30-cm"},{"max":350,"h":"meuble-bas-3-casseroliers-35cm-1"},{"max":400,"h":"meuble-bas-3-casseroliers-40cm-1"},{"max":450,"h":"meuble-bas-3-casseroliers-45cm-1"},{"max":500,"h":"meuble-bas-3-casseroliers-50cm-1"},{"max":600,"h":"meuble-bas-3-casseroliers-60cm-1"},{"max":700,"h":"meuble-bas-3-casseroliers-70cm-2"},{"max":800,"h":"meuble-bas-3-casseroliers-80cm-2"},{"max":900,"h":"meuble-bas-3-casseroliers-90cm-1"},{"max":1000,"h":"meuble-bas-3-casseroliers-100cm-1"},{"max":1200,"h":"meuble-bas-3-casseroliers-120cm-1"}],"A-5-1P":[{"max":450,"h":"meuble-bas-evier-1-porte-45cm-1"},{"max":500,"h":"meuble-bas-evier-1-porte-50cm-1"},{"max":600,"h":"meuble-bas-evier-1-porte-60cm-1"},{"max":700,"h":"meuble-bas-evier-1-porte-70cm-1"}],"A-5-2P":[{"max":600,"h":"meuble-bas-evier-2-portes-60cm-1"},{"max":700,"h":"meuble-bas-evier-2-portes-70cm-1"},{"max":800,"h":"meuble-bas-evier-2-portes-80cm-1"},{"max":900,"h":"meuble-bas-evier-2-portes-90cm-1"},{"max":1000,"h":"meuble-bas-evier-2-portes-100cm-1"},{"max":1200,"h":"meuble-bas-evier-2-portes-120cm-1"}],"B-11-1PB":[{"max":300,"h":"meuble-haut-1-porte-hauteur-70cm-largeur-caisson-30-cm"},{"max":350,"h":"meuble-haut-1-porte-hauteur-70cm-largeur-caisson-35-cm"},{"max":400,"h":"meuble-haut-1-porte-hauteur-70cm-largeur-caisson-40-cm"},{"max":450,"h":"meuble-haut-1-porte-hauteur-70cm-largeur-caisson-45-cm"},{"max":500,"h":"meuble-haut-1-porte-hauteur-70cm-largeur-caisson-50cm"},{"max":600,"h":"meuble-haut-1-porte-hauteur-70cm-largeur-caisson-60cm"}],"B-11-2PB":[{"max":600,"h":"meuble-haut-2-portes-hauteur-70cm-largeur-caisson-60cm"},{"max":700,"h":"meuble-haut-2-portes-hauteur-70cm-largeur-caisson-70cm"},{"max":800,"h":"meuble-haut-2-portes-hauteur-70cm-largeur-caisson-80cm"},{"max":900,"h":"meuble-haut-2-portes-hauteur-70cm-largeur-caisson-90cm"},{"max":1000,"h":"meuble-haut-2-portes-hauteur-70cm-largeur-caisson-100cm"}],"B-11-1PH":[{"max":300,"h":"meuble-haut-1-porte-hauteur-30cm"},{"max":350,"h":"meuble-haut-1-porte-hauteur-35cm-1"},{"max":400,"h":"meuble-haut-1-porte-hauteur-40cm"},{"max":450,"h":"meuble-haut-1-porte-hauteur-45cm"},{"max":500,"h":"meuble-haut-1-porte-hauteur-50cm"},{"max":600,"h":"meuble-haut-1-porte-hauteur-60cm"}],"B-11-2PH":[{"max":600,"h":"meuble-haut-2-portes-hauteur-90cm-largeur-60cm"},{"max":700,"h":"meuble-haut-2-portes-hauteur-90cm-largeur-70cm"},{"max":800,"h":"meuble-haut-2-portes-hauteur-90cm-largeur-80cm"},{"max":900,"h":"meuble-haut-2-portes-hauteur-90cm-largeur-90cm"},{"max":1000,"h":"meuble-haut-2-portes-hauteur-90cm-largeur-100cm"}],"B-12-1PB":[{"max":600,"h":"meuble-haut-abattant-1-porte-hauteur-50cm-largeur-60cm"},{"max":800,"h":"meuble-haut-abattant-1-porte-hauteur-50cm-largeur-80cm"},{"max":900,"h":"meuble-haut-abattant-1-porte-hauteur-50cm-largeur-90cm"}],"B-12-2PB":[{"max":600,"h":"meuble-haut-abattant-2-portes-hauteur-70cm-largeur-60cm"},{"max":800,"h":"meuble-haut-abattant-2-portes-hauteur-70cm-largeur-80cm"},{"max":900,"h":"meuble-haut-abattant-2-portes-hauteur-70cm-largeur-90cm"}],"B-12-2PH":[{"max":600,"h":"meuble-haut-abattant-2-portes-hauteur-90cm-largeur-60cm"},{"max":800,"h":"meuble-haut-abattant-2-portes-hauteur-90cm-largeur-80cm"},{"max":900,"h":"meuble-haut-abattant-2-portes-hauteur-90cm-largeur-90cm"}],"C-21-1P":[{"max":400,"maxH":2300,"h":"colonne-1-porte-etageres-interieures-largeur-40cm-hauteur-200cm"},{"max":600,"maxH":2150,"h":"colonne-1-porte-etageres-interieures-220cm"},{"max":600,"maxH":2300,"h":"colonne-1-porte-etageres-interieures-largeur-60cm-hauteur-220cm"}],"C-21-2P":[{"max":400,"maxH":2150,"h":"colonne-2-portes-etageres-interieures-largeur-40cm-hauteur-200cm"},{"max":400,"maxH":2300,"h":"colonne-2-portes-etageres-interieures-largeur-40cm-hauteur-220cm"},{"max":600,"maxH":2150,"h":"colonne-2-portes-etageres-interieures-largeur-60cm-hauteur-200cm"},{"max":600,"maxH":2300,"h":"colonne-2-portes-etageres-interieures-largeur-60cm-hauteur-220cm"}],"C-22-1P":[{"max":400,"maxH":2150,"h":"colonne-1-porte-2-casseroliers-l40-h200"},{"max":400,"maxH":2300,"h":"colonne-1-porte-2-casseroliers-l40-h220"},{"max":600,"maxH":2150,"h":"colonne-1-porte-2-casseroliers-l60-h200"},{"max":600,"maxH":2300,"h":"colonne-1-porte-2-casseroliers-l60-h220"}],"C-23-6T-1P":[{"max":400,"maxH":2150,"h":"colonne-1-porte-6-tiroirs-interieurs-largeur-40cm-hauteur-200cm"},{"max":400,"maxH":2300,"h":"colonne-1-porte-6-tiroirs-interieurs-largeur-40cm-hauteur-220cm"},{"max":600,"maxH":2150,"h":"colonne-1-porte-6-tiroirs-interieurs-largeur-60cm-hauteur-200cm"},{"max":600,"maxH":2300,"h":"colonne-1-porte-6-tiroirs-interieurs-largeur-60cm-hauteur-220cm"}],"C-23-6T-2P":[{"max":400,"maxH":2150,"h":"colonne-2-portes-6-tiroirs-interieurs-largeur-40cm-hauteur-200cm"},{"max":400,"maxH":2300,"h":"colonne-2-portes-6-tiroirs-interieurs-largeur-40cm-hauteur-220cm"},{"max":600,"maxH":2150,"h":"colonne-2-portes-6-tiroirs-interieurs-largeur-60cm-hauteur-200cm"},{"max":600,"maxH":2300,"h":"colonne-2-portes-6-tiroirs-interieurs-largeur-60cm-hauteur-220cm"}],"C-23-3T-2P":[{"max":400,"maxH":2150,"h":"colonne-2-portes-3-tiroirs-interieurs-l40-h200"},{"max":400,"maxH":2300,"h":"colonne-2-portes-3-tiroirs-interieurs-l40-h220"},{"max":600,"maxH":2150,"h":"colonne-2-portes-3-tiroirs-interieurs-l60-h200"},{"max":600,"maxH":2300,"h":"colonne-2-portes-3-tiroirs-interieurs-l60-h220"}],"C-24-FM":[{"max":600,"maxH":2150,"h":"colonne-four-et-micro-onde-2-portes-h200"},{"max":600,"maxH":2300,"h":"colonne-four-et-micro-onde-2-portes-h220"}],"C-24-F":[{"max":600,"maxH":2150,"h":"colonne-four-2-portes-l60-h200"},{"max":600,"maxH":2300,"h":"colonne-four-2-portes-l60-h220"}],"C-25-1P":[{"max":600,"maxH":2150,"h":"colonne-refrigerateur-1-porte-l60-h200"},{"max":600,"maxH":2300,"h":"colonne-refrigerateur-1-porte-l60-h220"}],"C-25-2P":[{"max":600,"maxH":2150,"h":"colonne-refrigerateur-2-portes-l60-h200"},{"max":600,"maxH":2300,"h":"colonne-refrigerateur-2-portes-l60-h220"}]};

    const couleurActiveC = state.couleurActive;
    function getPoigneeForCaissonType() {
      return cs.type === 'B' ? state.poigneeHaut : state.poigneeBasColonne;
    }
    const poigneeActiveC = null; // sera résolu dynamiquement
    const CM_SENS_CODES = ['A-1-1P','A-3-1P','A-5-1P','B-11-1PB','B-11-1PH','C-21-1P','C-23-6T-1P','C-25-1P'];
    const cs = { type: null, utility: null, larg: '', haut: '', prof: '', prix: null, refTitle: '', sens: 'Non applicable' };

    // Fetch caisson variant ID (couleur + poignée)
    let caissonVarId = null;
    try {
      const rp = await fetch('/products/caisson-sur-mesure.js');
      const pd = await rp.json();
      const variants = pd.variants || [];
      for (const v of variants) {
        if (couleurActiveC && poigneeActiveC && v.option1 === couleurActiveC.name && v.option2 === poigneeActiveC) { caissonVarId = v.id; break; }
      }
      if (!caissonVarId && couleurActiveC) { for (const v of variants) { if (v.option1 === couleurActiveC.name) { caissonVarId = v.id; break; } } }
      if (!caissonVarId && variants.length) caissonVarId = variants[0].id;
    } catch(e) {}

    // copie exacte de _gorgeAluSuppCents (assets/meuble-config.js, fiche caisson-sur-mesure) : supplément Gorge alu en centimes
    function cmGorgeAluSuppCents(largeur_mm, utility, type) { var lc = Math.round(largeur_mm / 10); if (lc < 15) lc = 15; if (lc > 120) lc = 120; if (type === 'C') { return (lc <= 40 ? 100 : 150) * 100; } var BAREME = [[30,40],[35,45],[40,50],[45,55],[50,60],[60,65],[70,70],[80,75],[90,80],[100,85],[120,90]]; var supp = 90; for (var i = 0; i < BAREME.length; i++) { if (lc <= BAREME[i][0]) { supp = BAREME[i][1]; break; } } if (utility && utility.indexOf('A-4') === 0) { var x = supp * 1.5; var floor = Math.floor(x); var target = floor + 0.90; if (x > target + 0.0001) target = floor + 1.90; supp = target; } return Math.round(supp * 100); }
    function cmDimKey(code) { const p = code.split('-'); return p[0]+'-'+p[1]; }
    function cmRefHandle(code, larg, haut) { const e = CM_MAP[code]; if (!e) return null; for (const x of e) { if (!(larg > x.max) && !(x.maxH && haut && haut > x.maxH)) return x.h; } return null; }
    function cmFindVariant(product) {
      if (!product||!product.variants) return null;
      const opts = product.options||[];
      const pi = opts.findIndex(o=>o.name.toLowerCase().includes('poign'));
      const poigneeSearch = ['Push pull', 'Gorge alu', 'Gorge'].includes(getPoigneeForCaissonType()) ? 'Avec poignée' : getPoigneeForCaissonType();
      const colorName = couleurActiveC ? couleurActiveC.name : null;
      // Cherche dans toutes les options (option1, option2, option3)
      function variantMatchesColor(v) {
        if (!colorName) return false;
        return v.option1===colorName||v.option2===colorName||v.option3===colorName;
      }
      let fb = null;
      for (const v of product.variants) {
        if (variantMatchesColor(v) && pi>=0 && v[`option${pi+1}`]===poigneeSearch) return v;
        if (variantMatchesColor(v) && !fb) fb=v;
        if (!fb) fb=v;
      }
      return fb;
    }

    let cmTimer = null;
    function cmSetFieldError(id, msg) {
      const wrap = section.querySelector(`#${id}`)?.closest('.moood-dim-input-wrap');
      const block = section.querySelector(`#${id}`)?.closest('.moood-dim-block');
      const hint = block?.querySelector('.moood-dim-hint');
      let err = block?.querySelector('.moood-dim-error');
      if (wrap) wrap.classList.toggle('error', !!msg);
      if (hint) {
        const dk = cs.utility ? cmDimKey(cs.utility) : null;
        const d = dk ? CM_DIMS[dk] : null;
        if (d) {
          if (id === 'cm-larg') hint.textContent = `Min ${d.minW} · Max ${d.maxW}`;
          else if (id === 'cm-haut') hint.textContent = `Min ${d.minH} · Max ${d.maxH}`;
          else if (id === 'cm-prof') hint.textContent = `Min ${d.minP} · Max ${d.maxP}`;
        }
      }
      if (msg) {
        if (!err && block) {
          err = document.createElement('span');
          err.className = 'moood-dim-error';
          block.appendChild(err);
        }
        if (err) {
          err.textContent = msg.replace(/^⚠\s*/, '');
          err.style.display = 'block';
        }
      } else if (err) {
        err.style.display = 'none';
      }
    }
    function cmClearErrors() {
      ['cm-larg','cm-haut','cm-prof'].forEach(id => cmSetFieldError(id, null));
      const dk = cmDimKey(cs.utility); const d = CM_DIMS[dk];
      if (!d) return;
      const hints = [
        [d.minW, d.maxW, 'cm-larg'], [d.minH, d.maxH, 'cm-haut'], [d.minP, d.maxP, 'cm-prof']
      ];
      hints.forEach(([min, max, id]) => {
        const hint = section.querySelector(`#${id}`)?.closest('.moood-dim-block')?.querySelector('.moood-dim-hint');
        if (hint) hint.textContent = `Min ${min} · Max ${max}`;
      });
    }
    async function cmUpdate() {
      const larg = parseInt(cs.larg,10), haut = parseInt(cs.haut,10), prof = parseInt(cs.prof,10);
      if (!cs.utility||!larg||!haut||!prof) return;
      const dk = cmDimKey(cs.utility); const d = CM_DIMS[dk]; if (!d) return;
      cmClearErrors();
      let hasError = false;
      if (larg && (larg<d.minW||larg>d.maxW)) { cmSetFieldError('cm-larg', `⚠ Entre ${d.minW} et ${d.maxW} mm`); hasError = true; }
      if (haut && (haut<d.minH||haut>d.maxH)) { cmSetFieldError('cm-haut', `⚠ Entre ${d.minH} et ${d.maxH} mm`); hasError = true; }
      if (prof && (prof<d.minP||prof>d.maxP)) { cmSetFieldError('cm-prof', `⚠ Entre ${d.minP} et ${d.maxP} mm`); hasError = true; }
      if (hasError) { cmShowRecap(null, null); return; }
      const handle = cmRefHandle(cs.utility, larg, haut); if (!handle) { cmShowRecap(null,'Largeur hors gamme pour ce type de caisson'); return; }
      cmShowRecap(null,'Calcul en cours…');
      try {
        const r = await fetch('/products/'+handle+'.js');
        const product = await r.json();
        const v = cmFindVariant(product); if (!v) { cmShowRecap(null,'Couleur non disponible'); return; }
const caissonMulti = state.caissonCouleur === 'Gris anthracite' ? 1.10 : (state.caissonCouleur === 'Bois' || state.caissonCouleur === 'Couleur au choix' || state.caissonColorPrecise) ? 1.30 : 1.00;
const poigneeEffective = getPoigneeForCaissonType();
// Push pull : supplément de la fiche (10 € x 1,5, colonne 20 € x 1,5) ; meuble haut « Gorge » = Gorge alu sur la fiche
const pushPullExtra = poigneeEffective === 'Push pull' ? Math.round((cs.type === 'C' ? 2000 : 1000) * 1.5) : 0;
// Gorge alu (2026-10-23) : même supplément que la fiche caisson-sur-mesure (meuble-config.js, _gorgeAluSuppCents x 1,5)
const gorgeAluExtra = (poigneeEffective === 'Gorge alu' || poigneeEffective === 'Gorge') ? Math.round(cmGorgeAluSuppCents(larg, cs.utility, cs.type) * 1.5) : 0;
const poigneeSearch = (poigneeEffective === 'Push pull' || poigneeEffective === 'Gorge alu' || poigneeEffective === 'Gorge') ? 'Avec poignée' : poigneeEffective;
let prixBase = parseFloat(v.price);
if (couleurActiveC && window.mooodPrix30cm && window.mooodAnchor30) {
  const key = couleurActiveC.name + '|' + poigneeSearch;
  const prixRef = window.mooodPrix30cm[key] || window.mooodPrix30cm[couleurActiveC.name + '|Avec poignée'];
  if (prixRef) {
    const ratio = prixRef / window.mooodAnchor30;
    prixBase = Math.round(parseFloat(product.variants[0].price) * ratio);
  }
}
let prixCentimes = Math.round(prixBase * 1.5 * caissonMulti);
        // Prix minimum caisson : 99,90€ (sur la base, avant push pull)
        // (2026-10-23) plus de minimum de 99,90 € : la fiche caisson-sur-mesure n'en a pas, le panier facturait le prix d'ici
        prixCentimes += pushPullExtra + gorgeAluExtra;
        cs.prix = prixCentimes / 100;
        cs.refTitle = product.title;
        cs.refImg = couleurActiveC?.swatchImage || getVariantImage(product, v, null);
        cmShowRecap(cs.prix, null, product.title, cs.refImg);
      } catch(e) { cmShowRecap(null,'Erreur de chargement'); }
    }
    function cmSchedule() { clearTimeout(cmTimer); cmTimer = setTimeout(cmUpdate, 400); }

    function cmShowRecap(prix, msg, refName, refImg) {
      const recapEl = section.querySelector('#caisson-recap');
      const addBtn = section.querySelector('#caisson-add-btn');
      if (!recapEl) return;
      if (prix !== null) {
        const poigneeActive = getPoigneeForCaissonType();
        const pushLabel = poigneeActive === 'Push pull' ? ' <span style="font-size:11px;opacity:0.7;">(Push pull +' + (cs.type === 'C' ? '30,00' : '15,00') + ' €)</span>' : (poigneeActive === 'Gorge alu' || poigneeActive === 'Gorge') ? ' <span style="font-size:11px;opacity:0.7;">(Gorge alu comprise)</span>' : '';
        recapEl.innerHTML = `<div style="background:#12433D;color:#fff;border-radius:16px;padding:20px 24px;display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;flex-wrap:wrap;gap:12px;">
          <div style="display:flex;align-items:center;gap:14px;flex:1;min-width:0;">
            ${refImg ? `<img src="${refImg}" alt="${refName||''}" style="width:70px;height:70px;object-fit:cover;border-radius:10px;flex-shrink:0;border:1px solid rgba(255,255,255,0.2);">` : ''}
            <div><div style="font-size:12px;opacity:0.8;margin-bottom:4px;">Modèle de référence</div><div style="font-weight:600;font-size:14px;">${refName||'—'}</div><div style="font-size:11px;opacity:0.7;margin-top:2px;">Prix référence + 50 %</div></div>
          </div>
          <div style="text-align:right;flex-shrink:0;"><div style="font-size:12px;opacity:0.8;">Votre prix sur mesure</div><div style="font-size:28px;font-weight:700;">${formatPrice(prix)}${pushLabel}</div></div>
        </div>`;
        if (addBtn) addBtn.disabled = false;
      } else {
        recapEl.innerHTML = msg ? `<div style="background:#f3f4f6;border-radius:12px;padding:14px;text-align:center;color:#9ca3af;margin-bottom:16px;font-size:13px;">${msg}</div>` : '';
        if (addBtn) addBtn.disabled = true;
      }
    }

    function renderCaisson() {
      const utils = cs.type ? (CM_UTILITIES[cs.type]||[]) : [];
      const dk = cs.utility ? cmDimKey(cs.utility) : null;
      const d = dk ? CM_DIMS[dk] : null;
      const typeLabels = { A:'Meuble Bas', B:'Meuble Haut', C:'Colonne' };

      section.innerHTML = `
        <div class="moood-surmesure-wrap">
          <h2 class="moood-section-titre">Meuble sur mesure</h2>
          
          <div class="moood-option-group">
            <div class="moood-option-label">1 — Type de meuble</div>
            <div style="display:flex;gap:10px;flex-wrap:wrap;">
              ${[['A','Meuble Bas'],['B','Meuble Haut'],['C','Colonne']].map(([k,l])=>`
                <div class="moood-option-choice${cs.type===k?' active':''}" data-cm-type="${k}" style="flex:1;min-width:120px;">
                  <div class="moood-option-choice-left"><div class="moood-option-radio"></div><span class="moood-option-choice-name">${l}</span></div>
                </div>`).join('')}
            </div>
          </div>
          ${cs.type ? `<div class="moood-option-group">
            <div class="moood-option-label">2 — Type de caisson</div>
            <div style="display:flex;flex-wrap:wrap;gap:8px;">
              ${utils.map(u=>`<div class="moood-option-choice${cs.utility===u.code?' active':''}" data-cm-util="${u.code}" style="flex:1;min-width:180px;">
                <div class="moood-option-choice-left"><div class="moood-option-radio"></div><span class="moood-option-choice-name" style="font-size:13px;">${u.label}</span></div>
              </div>`).join('')}
            </div>
          </div>` : ''}
          ${cs.utility && d ? `<div class="moood-surmesure-dims" style="max-width:100%;margin-left:0;margin-right:0;">
            <div class="moood-dim-block">
              <div class="moood-dim-label">Largeur (mm)</div>
              <div class="moood-dim-hint">Min ${d.minW} · Max ${d.maxW}</div>
              <div class="moood-dim-input-wrap"><input type="number" class="moood-dim-input" id="cm-larg" placeholder="ex : 600" value="${cs.larg}" ${d.minW===d.maxW?`readonly`:''}><span class="moood-dim-unit">mm</span></div>
            </div>
            <div class="moood-dim-block">
              <div class="moood-dim-label">Hauteur (mm)</div>
              <div class="moood-dim-hint">Min ${d.minH} · Max ${d.maxH}</div>
              <div class="moood-dim-input-wrap"><input type="number" class="moood-dim-input" id="cm-haut" placeholder="ex : 700" value="${cs.haut}" ${d.minH===d.maxH?`readonly`:''}><span class="moood-dim-unit">mm</span></div>
            </div>
            <div class="moood-dim-block">
              <div class="moood-dim-label">Profondeur (mm)</div>
              <div class="moood-dim-hint">Min ${d.minP} · Max ${d.maxP}</div>
              <div class="moood-dim-input-wrap"><input type="number" class="moood-dim-input" id="cm-prof" placeholder="ex : 580" value="${cs.prof}" ${d.minP===d.maxP?`readonly`:''}><span class="moood-dim-unit">mm</span></div>
            </div>
          </div>
          ${CM_SENS_CODES.indexOf(cs.utility) > -1 ? `<div class="moood-option-group" id="cm-sens-group">
            <div class="moood-option-label">Sens d'ouverture de la porte</div>
            <div style="display:flex;gap:10px;flex-wrap:wrap;">
              <div class="moood-option-choice${cs.sens==='Gauche'?' active':''}" data-cm-sens="Gauche" style="flex:1;min-width:120px;">
                <div class="moood-option-choice-left"><div class="moood-option-radio"></div><span class="moood-option-choice-name">↖ Ouvrant gauche</span></div>
              </div>
              <div class="moood-option-choice${cs.sens==='Droite'?' active':''}" data-cm-sens="Droite" style="flex:1;min-width:120px;">
                <div class="moood-option-choice-left"><div class="moood-option-radio"></div><span class="moood-option-choice-name">↗ Ouvrant droite</span></div>
              </div>
            </div>
          </div>` : ''}
          <div id="caisson-recap"></div>
          <div style="max-width:100%;"><button class="moood-surmesure-btn-add" id="caisson-add-btn" disabled>Ajouter au pack</button></div>` : ''}
        </div>`;

      // Auto-fill fixed dims
      if (d) {
        if (d.minW===d.maxW) { cs.larg=String(d.minW); const el=section.querySelector('#cm-larg'); if(el)el.value=d.minW; }
        if (d.minH===d.maxH) { cs.haut=String(d.minH); const el=section.querySelector('#cm-haut'); if(el)el.value=d.minH; }
        if (d.minP===d.maxP) { cs.prof=String(d.minP); const el=section.querySelector('#cm-prof'); if(el)el.value=d.minP; }
        if (d.minW===d.maxW && d.minH===d.maxH && d.minP===d.maxP) cmSchedule();
      }

      section.querySelectorAll('[data-cm-type]').forEach(el => el.addEventListener('click', () => {
        cs.type=el.dataset.cmType; cs.utility=null; cs.larg=''; cs.haut=''; cs.prof=''; cs.prix=null;
        renderCaisson();
      }));
      section.querySelectorAll('[data-cm-util]').forEach(el => el.addEventListener('click', () => {
        cs.utility=el.dataset.cmUtil; cs.larg=''; cs.haut=''; cs.prof=''; cs.prix=null; cs.sens='Non applicable';
        renderCaisson();
      }));
      section.querySelectorAll('[data-cm-sens]').forEach(el => el.addEventListener('click', () => {
        cs.sens=el.dataset.cmSens;
        section.querySelectorAll('[data-cm-sens]').forEach(b=>b.classList.toggle('active',b.dataset.cmSens===cs.sens));
      }));
      [['cm-larg','larg'],['cm-haut','haut'],['cm-prof','prof']].forEach(([id,key]) => {
        const el = section.querySelector('#'+id);
        if (el && !el.readOnly) el.addEventListener('input', e => { cs[key]=e.target.value; cmSchedule(); });
      });

      const addBtn = section.querySelector('#caisson-add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', () => {
          if (!cs.prix || !cs.utility) return;
          const typeLabel = typeLabels[cs.type]||cs.type;
          const utilLabel = (CM_UTILITIES[cs.type]||[]).find(u=>u.code===cs.utility)?.label||cs.utility;
          const img = couleurActiveC && couleurActiveC.swatchImage ? couleurActiveC.swatchImage : '';
          state.panier.push({
            productId: 'surmesure-caisson', variantId: caissonVarId,
            name: `Meuble sur mesure — ${couleurActiveC?couleurActiveC.name:''}`,
            color: `${typeLabel} · ${utilLabel} · L=${cs.larg}mm H=${cs.haut}mm P=${cs.prof}mm`,
            price: cs.prix, image: img, qty: 1, collection: col.handle, surMesure: true,
            poignee: getPoigneeForCaissonType(), caissonCouleur: state.caissonCouleur,
            surMesureProps: { largeur: cs.larg, longueur: cs.haut, options: [
              { nom: 'Type', valeur: typeLabel },
              { nom: 'Configuration', valeur: utilLabel },
              { nom: 'Couleur', valeur: couleurActiveC?couleurActiveC.name:'' },
              { nom: 'Couleur caisson', valeur: state.caissonCouleur || 'Blanc' },
              { nom: 'Poignée', valeur: getPoigneeForCaissonType()||'' },
              { nom: 'Dimensions', valeur: `L=${cs.larg}mm H=${cs.haut}mm P=${cs.prof}mm` },
              { nom: 'Sens ouverture', valeur: cs.sens },
              { nom: 'Modèle de référence', valeur: cs.refTitle },
              { nom: 'Prix sur mesure', valeur: formatPrice(cs.prix) }
            ]}
          });
          renderPanier(caissonVarId);
          updateEtapeBarre(col.handle);
          document.getElementById('moood-next-btn')?.classList.add('pulse');
          addBtn.textContent = '✓ Ajouté au pack !';
          setTimeout(() => {
            addBtn.textContent = 'Ajouter au pack';
            cs.utility=null; cs.larg=''; cs.haut=''; cs.prof=''; cs.prix=null;
            renderCaisson();
          }, 2000);
        });
      }
      updateNavBar();
    }

    renderCaisson();
    updateEtapeBarre(col.handle);
    trackEvent('configurateur_etape', { etape: col.handle, numero: state.etapeActuelle + 1 });
  }

  // ─── Rendu de l'étape produit courante ────────────────────────────────────
  function renderEtapeProduit() {
    const tunnel = getTunnel();
    const col = tunnel[state.etapeActuelle];
    const section = document.getElementById('moood-products-sections');
    if (!section || !col) return;

    document.querySelectorAll('.moood-etape').forEach(el => el.classList.remove('current'));
    const etapeCourante = document.querySelector(`.moood-etape[data-etape="${col.handle}"]`);
    if (etapeCourante) {
      etapeCourante.classList.add('current');
      etapeCourante.classList.add('active');
    }

    if (state.poigneeChoisie) {
      const coulSec = document.getElementById('moood-couleurs-section');
      const caissonSec = document.getElementById('moood-caisson-section');
      const poigSec = document.getElementById('moood-poignee-section');
      if (coulSec) coulSec.style.display = 'none';
      if (caissonSec) caissonSec.style.display = 'none';
      if (poigSec) poigSec.style.display = 'none';
    }

    const isSurMesure = (window.mooodSurMesure || []).some(s => s.etapeHandle === col.handle);
    if (isSurMesure) { renderEtapeSurMesure(col); return; }
    document.getElementById('moood-next-btn')?.classList.remove('pulse');
    section.innerHTML = `
      <div class="moood-collection-section" data-collection="${col.handle}">
        <h2 class="moood-collection-titre">${col.title} <span id="moood-nb-produits-${col.handle}" style="font-size:14px;font-weight:500;color:#9ca3af;"></span></h2>
        <div id="moood-filtres-${col.handle}" class="moood-filtres-wrap"></div>
        <div id="moood-loading-bar-${col.handle}" style="display:flex;align-items:center;gap:10px;padding:12px 16px;background:#f0f7f6;border-radius:12px;margin-bottom:16px;font-size:14px;color:#12433D;font-weight:600;">
          <div style="width:16px;height:16px;border:2px solid #b8d3cf;border-top-color:#12433D;border-radius:50%;animation:moood-spin 0.7s linear infinite;flex-shrink:0;"></div>
          <span>Chargement des ${col.title.toLowerCase()}…</span>
        </div>
        <div class="moood-products-grid">
          ${[1,2,3,4,5,6].map(() => `<div class="moood-skeleton"><div class="moood-skeleton-img"></div><div class="moood-skeleton-body"><div class="moood-skeleton-line"></div><div class="moood-skeleton-line short"></div></div></div>`).join('')}
        </div>
      </div>
    `;

    updateNavBar();
    chargerCollection(col).then(() => { renderFiltres(col); updateNavBar(); });
    updateEtapeBarre(col.handle);
    trackEvent('configurateur_etape', { etape: col.handle, numero: state.etapeActuelle + 1 });

    const colSuivante = tunnel[state.etapeActuelle + 1];
    if (colSuivante && !state.produits[colSuivante.handle]) {
      const isSuivanteSurMesure = (window.mooodSurMesure || []).some(s => s.etapeHandle === colSuivante.handle);
      if (!isSuivanteSurMesure) {
        // Prefetch via loadCollectionData (Storefront API pour les
        // collections whitelist, fallback products.json).
        loadCollectionData(colSuivante.handle)
          .then(loaded => {
            state.produits[colSuivante.handle] = loaded.products;
            state.produitsPage = state.produitsPage || {};
            state.produitsPage[colSuivante.handle] = { page: loaded.source === 'sf' ? 999 : 1, hasMore: loaded.hasMore };
          })
          .catch(() => {});
      }
    }
  }

  function updateNavBar() {
    const tunnel = getTunnel();
    const isLast = state.etapeActuelle >= tunnel.length - 1;
    const col = tunnel[state.etapeActuelle];
    const totalEtapes = 2 + tunnel.length;
    const etapeNum = 3 + state.etapeActuelle;
    let nav = document.getElementById('moood-tunnel-nav');
    if (!nav) {
      nav = document.createElement('div');
      nav.id = 'moood-tunnel-nav';
      nav.className = 'moood-tunnel-nav';
      document.body.appendChild(nav);
    }
    const qty = state.panier.reduce((s, i) => s + i.qty, 0);
    const total = state.panier.reduce((s, i) => s + i.price * i.qty, 0);
    const totalFmt = formatPrice(total);
    nav.innerHTML = `
      <div class="moood-tunnel-nav-info">
        ${col ? `<strong>Étape ${etapeNum}/${totalEtapes}</strong> — ${col.title}` : ''}
      </div>
      <div class="moood-tunnel-nav-info" style="text-align:center;">
        ${qty > 0 ? `<strong style="color:#12433D;">${totalFmt}</strong> · ${qty} produit${qty > 1 ? 's' : ''}` : '<span style="color:#9ca3af;">Panier vide</span>'}
      </div>
      <div class="moood-tunnel-nav-btns">
        <button class="moood-btn-share" id="moood-partager-btn" title="Partager">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
          Partager
        </button>
        <button class="moood-btn-save" id="moood-save-btn-nav" title="Sauvegarder ma configuration">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
          Sauvegarder
        </button>
        <button class="moood-btn-save" id="moood-historique-btn-nav" title="Historique des configurations">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          Historique
        </button>
        <button class="moood-btn-save" id="moood-reset-btn-nav" title="Réinitialiser la configuration" style="border-color:#ef4444;color:#ef4444;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
          Réinitialiser
        </button>
        ${state.etapeActuelle > 0 ? `<button class="moood-btn-prev" id="moood-prev-btn">← Retour</button>` : ''}
        <button class="moood-btn-next" id="moood-next-btn">${isLast ? 'Terminer ✓' : 'Étape suivante →'}</button>
      </div>
    `;
    document.getElementById('moood-btn-pdf-cart')?.addEventListener('click', genererPDF);
    document.getElementById('moood-partager-btn')?.addEventListener('click', ouvrirPartager);
    document.getElementById('moood-save-btn-nav')?.addEventListener('click', ouvrirSaveNom);
    document.getElementById('moood-reset-btn-nav')?.addEventListener('click', function() {
      let confirmOverlay = document.getElementById('moood-confirm-overlay');
      if (!confirmOverlay) {
        confirmOverlay = document.createElement('div');
        confirmOverlay.id = 'moood-confirm-overlay';
        confirmOverlay.className = 'moood-confirm-overlay';
        confirmOverlay.innerHTML = `
          <div class="moood-confirm-modal">
            <div class="moood-confirm-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
            </div>
            <div class="moood-confirm-title">Réinitialiser la configuration ?</div>
            <div class="moood-confirm-text">Toute votre sélection sera perdue et vous repartirez de zéro.</div>
            <div class="moood-confirm-btns">
              <button class="moood-confirm-cancel" id="moood-confirm-cancel">Annuler</button>
              <button class="moood-confirm-ok" id="moood-confirm-ok">Réinitialiser</button>
            </div>
          </div>
        `;
        document.body.appendChild(confirmOverlay);
        confirmOverlay.addEventListener('click', e => { if (e.target === confirmOverlay) confirmOverlay.classList.remove('open'); });
      }
      document.getElementById('moood-confirm-cancel').onclick = () => confirmOverlay.classList.remove('open');
      document.getElementById('moood-confirm-ok').onclick = () => {
        confirmOverlay.classList.remove('open');
        state.couleurActive = null;
        state.couleurChoisie = false;
        state.caissonCouleur = 'Blanc';
        state.poigneeActive = null;
        state.poigneeBasColonne = null;
        state.poigneeHaut = null;
        state.poigneeChoisie = false;
        state.etapeActuelle = 0;
        state.panier = [];
        state.filtresActifs = {};
        state.pageVisuelle = {};
        state.sensPorte = {};
        try { localStorage.removeItem('moood_config'); } catch(e) {}
        history.replaceState(null, '', window.location.pathname);
        document.getElementById('moood-caisson-section') && (document.getElementById('moood-caisson-section').style.display = 'none');
        document.getElementById('moood-poignee-section').style.display = 'none';
        document.getElementById('moood-valider-config') && (document.getElementById('moood-valider-config').style.display = 'none');
        const rappelBarReset = document.getElementById('moood-rappel-bar');
        if (rappelBarReset) { rappelBarReset.innerHTML = ''; rappelBarReset.classList.remove('visible'); }
        document.getElementById('moood-couleur-required')?.classList.remove('hidden');
        document.getElementById('moood-products-sections').innerHTML = '';
        document.getElementById('moood-products-sections')?.classList.add('moood-products-locked');
        document.getElementById('moood-couleur-nom').innerHTML = '';
        document.querySelectorAll('.moood-poignee-btn').forEach(btn => btn.classList.remove('active'));
        document.querySelectorAll('.moood-etape').forEach((el, i) => { if (i > 0) el.classList.remove('active'); });
        document.getElementById('moood-etapes-fill').style.width = '0%';
        renderSwatches();
        renderPopup();
        renderPanier();
        updateNavBar();
        document.querySelector('.moood-configurateur')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      confirmOverlay.classList.add('open');
    });
    document.getElementById('moood-historique-btn-nav')?.addEventListener('click', ouvrirHistorique);
    document.getElementById('moood-next-btn')?.addEventListener('click', window._mooodNext);
    document.getElementById('moood-prev-btn')?.addEventListener('click', window._mooodPrev);
  }

  window._mooodNext = function() {
    const tunnel = getTunnel();
    if (state.etapeActuelle < tunnel.length - 1) {
      state.etapeActuelle++;
      renderEtapeProduit();
      document.querySelector('.moood-configurateur')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      renderRecap();
    }
  };

  window._mooodPrev = function() {
    if (state.etapeActuelle > 0) {
      state.etapeActuelle--;
      renderEtapeProduit();
      document.querySelector('.moood-configurateur')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  function renderRecap() {
    const section = document.getElementById('moood-products-sections');
    if (!section) return;
    const total = state.panier.reduce((s, i) => s + i.price * i.qty, 0);
    section.innerHTML = `
      <div style="text-align:center;padding:40px 20px;">
        <div style="background:#FFF8F2;border-radius:16px;padding:16px 20px;margin-bottom:28px;text-align:center;">
          <div style="font-size:14px;color:#6b7280;margin-bottom:6px;">Vous avez une question ? N'hésitez pas à nous appeler au</div>
          <a href="tel:0474946588" style="font-size:20px;font-weight:700;color:#12433D;text-decoration:none;">04 74 94 65 88</a>
          <div style="font-size:13px;color:#9ca3af;margin-top:4px;">Nous nous ferons un plaisir de vous répondre</div>
        </div>
        <div style="width:64px;height:64px;background:#e8f4f2;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px;">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#12433D" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
        </div>
        <h2 style="font-size:26px;font-weight:700;color:#12433D;margin:0 0 10px;">Votre configuration est prête !</h2>
        <p style="font-size:15px;color:#6b7280;margin:0 0 8px;">Total estimé : <strong style="color:#12433D;font-size:18px;">${formatPrice(total)}</strong></p>
        <p style="font-size:13px;color:#9ca3af;margin:0 0 40px;">Vous pouvez ajouter votre sélection au panier, la sauvegarder ou la partager.</p>
        <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:14px;max-width:500px;margin:0 auto 32px;">
          <button id="recap-btn-atc" style="grid-column:1/-1;padding:16px;border-radius:50px;border:none;background:#12433D;color:#fff;font-size:16px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            Ajouter au panier
          </button>
          <button id="recap-btn-pdf" style="padding:14px;border-radius:50px;border:1.5px solid #12433D;background:transparent;color:#12433D;font-size:14px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            Télécharger PDF
          </button>
          <button id="recap-btn-save" style="padding:14px;border-radius:50px;border:1.5px solid #12433D;background:transparent;color:#12433D;font-size:14px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/></svg>
            Sauvegarder
          </button>
          <button id="recap-btn-whatsapp" style="padding:14px;border-radius:50px;border:1.5px solid #25D366;background:transparent;color:#25D366;font-size:14px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            Partager WhatsApp
          </button>
          <button id="recap-btn-copy" style="padding:14px;border-radius:50px;border:1.5px solid #9ca3af;background:transparent;color:#6b7280;font-size:14px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
            Copier le lien
          </button>
        </div>
        <div style="display:flex;gap:10px;justify-content:center;margin-bottom:16px;">
          <button id="recap-btn-historique" style="padding:10px 16px;border-radius:50px;border:1.5px solid #9ca3af;background:transparent;color:#6b7280;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;gap:6px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            Historique
          </button>
          <button id="recap-btn-reset" style="padding:10px 16px;border-radius:50px;border:1.5px solid #ef4444;background:transparent;color:#ef4444;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;gap:6px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
            Réinitialiser
          </button>
        </div>
        <button id="recap-btn-modifier" style="font-size:13px;color:#9ca3af;background:none;border:none;cursor:pointer;text-decoration:underline;">← Modifier ma configuration</button>
      </div>

      <div style="max-width:700px;margin:0 auto;text-align:left;">
        <h3 style="font-size:18px;font-weight:700;color:#12433D;margin:0 0 16px;">Récapitulatif de votre sélection</h3>
        ${(() => {
          const tunnel = getTunnel();
          let recapHtml = '';
          recapHtml += `<div style="background:#f0f7f6;border-radius:14px;padding:16px 20px;margin-bottom:12px;">`;
          const toutesLesCouleurs = [...new Set(state.panier.filter(i => i.color && !i.surMesure && i.collection !== 'poignee-unit').map(i => i.color))];
          if (toutesLesCouleurs.length > 0) {
            recapHtml += `<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:8px;"><span style="font-size:13px;color:#6b7280;">Coloris :</span>`;
            recapHtml += toutesLesCouleurs.map(colorName => {
              const swatch = state.allCouleurs.find(s => s.name === colorName);
              const swatchStyle = swatch?.swatchImage ? `background-image:url(${swatch.swatchImage});background-size:cover;` : `background:${swatch?.swatchColor||'#e5e7eb'};`;
              return `<span style="display:inline-flex;align-items:center;gap:10px;"><span style="display:inline-block;width:18px;height:18px;border-radius:50%;${swatchStyle}flex-shrink:0;"></span><span style="font-size:13px;font-weight:700;color:#111827;">${colorName}</span></span>`;
            }).join('<span style="color:#d1d5db;padding:0 6px;">·</span>');
            recapHtml += `</div>`;
          }
          if (state.poigneeActive) {
            recapHtml += `<div style="display:flex;align-items:center;gap:6px;"><span style="font-size:13px;color:#6b7280;">Poignée :</span><span style="font-size:13px;font-weight:700;color:#111827;">${state.poigneeActive}</span></div>`;
          }
          recapHtml += `</div>`;
          const itemsSansSM = state.panier.filter(i => !i.surMesure && i.collection !== 'poignee-unit');
          const itemsPoignees = state.panier.filter(i => i.collection === 'poignee-unit');
          const itemsSurMesure = state.panier.filter(i => i.surMesure);
          const couleursOrder = [...new Set(itemsSansSM.map(i => i.color || 'Sans couleur'))];
          for (const color of couleursOrder) {
            const itemsCouleur = itemsSansSM.filter(i => (i.color || 'Sans couleur') === color);
            const swatch = state.allCouleurs.find(s => s.name === color);
            const swatchStyle = swatch?.swatchImage ? `background-image:url(${swatch.swatchImage});background-size:cover;` : `background:${swatch?.swatchColor||'#e5e7eb'};`;
            recapHtml += `<div style="margin-bottom:20px;"><div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;"><span style="display:inline-block;width:18px;height:18px;border-radius:50%;${swatchStyle}flex-shrink:0;"></span><span style="font-size:14px;font-weight:700;color:#12433D;">${color}</span></div>`;
            const byCol = {};
            for (const item of itemsCouleur) {
              if (!byCol[item.collection]) byCol[item.collection] = [];
              byCol[item.collection].push(item);
            }
            for (const [colHandle, items] of Object.entries(byCol)) {
              const colObj = tunnel.find(c => c.handle === colHandle);
              const colTitle = colObj?.title || colHandle;
              const colTotal = items.reduce((s, i) => s + i.price * i.qty, 0);
              const colQty = items.reduce((s, i) => s + i.qty, 0);
              recapHtml += `<div style="border:1.5px solid #e5e7eb;border-radius:14px;overflow:hidden;margin-bottom:10px;"><div style="background:#f9fafb;padding:10px 16px;display:flex;justify-content:space-between;align-items:center;"><span style="font-size:12px;font-weight:700;color:#12433D;text-transform:uppercase;letter-spacing:0.06em;">${colTitle}</span><span style="font-size:12px;color:#9ca3af;">${colQty} article${colQty>1?'s':''} · ${formatPrice(colTotal)}</span></div>`;
              const itemsTries = [...items].sort((a, b) => { if (a.name < b.name) return -1; if (a.name > b.name) return 1; if (a.sens === 'gauche' && b.sens === 'droite') return -1; if (a.sens === 'droite' && b.sens === 'gauche') return 1; return 0; });
              for (const item of itemsTries) {
                recapHtml += `<div style="display:flex;align-items:center;gap:12px;padding:10px 16px;border-top:1px solid #f3f4f6;"><img src="${item.image}" style="width:48px;height:48px;border-radius:8px;object-fit:cover;flex-shrink:0;" /><div style="flex:1;min-width:0;"><div style="font-size:13px;font-weight:600;color:#111827;">${item.name}</div>${item.sens ? `<div style="font-size:11px;color:#12433D;font-weight:600;">↔ Ouverture ${item.sens}</div>` : ''}</div><div style="text-align:right;flex-shrink:0;"><div style="font-size:11px;color:#9ca3af;">${formatPrice(item.price)} × ${item.qty}</div><div style="font-size:13px;font-weight:700;color:#12433D;">${formatPrice(item.price * item.qty)}</div></div></div>`;
              }
              recapHtml += `</div>`;
            }
            recapHtml += `</div>`;
          }
          if (itemsPoignees.length > 0) {
            recapHtml += `<div style="border:1.5px solid #e5e7eb;border-radius:14px;overflow:hidden;margin-bottom:10px;"><div style="background:#f9fafb;padding:10px 16px;"><span style="font-size:12px;font-weight:700;color:#12433D;text-transform:uppercase;letter-spacing:0.06em;">Poignées</span></div>`;
            for (const item of itemsPoignees) {
              recapHtml += `<div style="display:flex;align-items:center;gap:12px;padding:10px 16px;border-top:1px solid #f3f4f6;"><img src="${item.image}" style="width:48px;height:48px;border-radius:8px;object-fit:cover;flex-shrink:0;" /><div style="flex:1;min-width:0;"><div style="font-size:13px;font-weight:600;color:#111827;">${item.name}</div></div><div style="text-align:right;flex-shrink:0;"><div style="font-size:13px;font-weight:700;color:#12433D;">${formatPrice(item.price * item.qty)}</div><div style="font-size:11px;color:#9ca3af;">×${item.qty}</div></div></div>`;
            }
            recapHtml += `</div>`;
          }
          if (itemsSurMesure.length > 0) {
            recapHtml += `<div style="border:1.5px solid #e5e7eb;border-radius:14px;overflow:hidden;margin-bottom:10px;"><div style="background:#f9fafb;padding:10px 16px;"><span style="font-size:12px;font-weight:700;color:#12433D;text-transform:uppercase;letter-spacing:0.06em;">Sur-mesure</span></div>`;
            for (const item of itemsSurMesure) {
              recapHtml += `<div style="display:flex;align-items:center;gap:12px;padding:10px 16px;border-top:1px solid #f3f4f6;"><img src="${item.image}" style="width:48px;height:48px;border-radius:8px;object-fit:cover;flex-shrink:0;" /><div style="flex:1;min-width:0;"><div style="font-size:13px;font-weight:600;color:#111827;">${item.name}</div><div style="font-size:11px;color:#6b7280;">${item.color}</div></div><div style="text-align:right;flex-shrink:0;"><div style="font-size:13px;font-weight:700;color:#12433D;">${formatPrice(item.price * item.qty)}</div><div style="font-size:11px;color:#9ca3af;">×${item.qty}</div></div></div>`;
            }
            recapHtml += `</div>`;
          }
          const total = state.panier.reduce((s, i) => s + i.price * i.qty, 0);
          const totalQty = state.panier.reduce((s, i) => s + i.qty, 0);
          recapHtml += `<div style="display:flex;justify-content:space-between;align-items:center;padding:16px 0;border-top:2px solid #12433D;margin-top:4px;"><span style="font-size:16px;font-weight:700;color:#12433D;">Total (${totalQty} article${totalQty>1?'s':''})</span><span style="font-size:22px;font-weight:700;color:#12433D;">${formatPrice(total)}</span></div>`;
          return recapHtml;
        })()}
      </div>
    `;

    document.getElementById('recap-btn-atc')?.addEventListener('click', ajouterAuPanier);
    document.getElementById('recap-btn-pdf')?.addEventListener('click', genererPDF);
    document.getElementById('recap-btn-save')?.addEventListener('click', ouvrirSaveNom);
    document.getElementById('recap-btn-modifier')?.addEventListener('click', () => {
      document.getElementById('moood-couleurs-section')?.style && (document.getElementById('moood-couleurs-section').style.display = '');
      document.getElementById('moood-caisson-section')?.style && (document.getElementById('moood-caisson-section').style.display = 'block');
      document.getElementById('moood-poignee-section')?.style && (document.getElementById('moood-poignee-section').style.display = 'block');
      document.getElementById('moood-valider-config') && (document.getElementById('moood-valider-config').style.display = 'block');
      const tunnel = getTunnel();
      state.etapeActuelle = tunnel.length - 1;
      renderEtapeProduit();
    });
    document.getElementById('recap-btn-historique')?.addEventListener('click', ouvrirHistorique);
    document.getElementById('recap-btn-reset')?.addEventListener('click', () => { document.getElementById('moood-reset-btn-nav')?.click(); });
    document.getElementById('recap-btn-whatsapp')?.addEventListener('click', async function() {
      const config = { cl: state.couleurActive?.name || '', pg: state.poigneeActive || '', p: state.panier.map(i => ({ v: i.variantId, q: i.qty, c: i.collection })) };
      const longUrl = window.location.origin + window.location.pathname + '?config=' + encodeURIComponent(btoa(JSON.stringify(config)));
      const total = state.panier.reduce((s, i) => s + i.price * i.qty, 0);
      let urlWa = longUrl;
      try { const resp = await fetch('https://is.gd/create.php?format=json&url=' + encodeURIComponent(longUrl)); const data = await resp.json(); if (data.shorturl) urlWa = data.shorturl; } catch(e) {}
      const msg = 'Voici ma configuration cuisine moood' + (total > 0 ? ' (' + formatPrice(total) + ')' : '') + ' :\n' + urlWa;
      window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank');
    });
    document.getElementById('recap-btn-copy')?.addEventListener('click', async function() {
      const btn = document.getElementById('recap-btn-copy');
      const config = { cl: state.couleurActive?.name || '', pg: state.poigneeActive || '', p: state.panier.map(i => ({ v: i.variantId, q: i.qty, c: i.collection })) };
      const longUrl = window.location.origin + window.location.pathname + '?config=' + encodeURIComponent(btoa(JSON.stringify(config)));
      let urlToCopy = longUrl;
      try { const resp = await fetch('https://is.gd/create.php?format=json&url=' + encodeURIComponent(longUrl)); const data = await resp.json(); if (data.shorturl) urlToCopy = data.shorturl; } catch(e) {}
      navigator.clipboard.writeText(urlToCopy).then(() => {
        if (btn) { btn.style.borderColor = '#12433D'; btn.style.color = '#12433D'; btn.textContent = '✓ Copié !'; setTimeout(() => { btn.style.borderColor = ''; btn.style.color = ''; btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg> Copier le lien'; }, 2000); }
      });
    });
    document.getElementById('moood-couleurs-section')?.style && (document.getElementById('moood-couleurs-section').style.display = 'none');
    document.getElementById('moood-caisson-section')?.style && (document.getElementById('moood-caisson-section').style.display = 'none');
    document.getElementById('moood-poignee-section')?.style && (document.getElementById('moood-poignee-section').style.display = 'none');
    document.querySelector('.moood-configurateur')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ─── Config filtres par collection ────────────────────────────────────────
  const FILTRES_PAR_COLLECTION = {
    'colonne-unit': [
      { label: 'Largeur',    metafield: 'largeur_de_caisson' },
      { label: 'Profondeur', metafield: 'profondeur_de_caisson' },
      { label: 'Hauteur',    metafield: 'hauteur_de_caisson' },
      { label: 'Utilité',    metafield: 'type_de_meuble' }
    ],
    'poignee-unit': [
      { label: 'Longueur',   metafield: 'longueur_des_poignees' },
      { label: 'Matière',    metafield: 'matiere_des_poignees' }
    ],
    'meuble-bas-unit': [
      { label: 'Largeur',    metafield: 'largeur_de_caisson' },
      { label: 'Profondeur', metafield: 'profondeur_de_caisson' },
      { label: 'Hauteur',    metafield: 'hauteur_de_caisson' },
      { label: 'Utilité',    metafield: 'type_de_meuble' }
    ],
    'meuble-bas-faible-profondeur': [
      { label: 'Largeur',    metafield: 'largeur_de_caisson' },
      { label: 'Profondeur', metafield: 'profondeur_de_caisson' },
      { label: 'Hauteur',    metafield: 'hauteur_de_caisson' },
      { label: 'Utilité',    metafield: 'type_de_meuble' }
    ],
    'meuble-haut-unit': [
      { label: 'Largeur',    metafield: 'largeur_de_caisson' },
      { label: 'Profondeur', metafield: 'profondeur_de_caisson' },
      { label: 'Hauteur',    metafield: 'hauteur_de_caisson' },
      { label: 'Utilité',    metafield: 'type_de_meuble' }
    ],
    'joues-et-fileurs-unit': [
      { label: 'Type',       metafield: 'joue_et_fileur' }
    ],
    'electro-unit': [
      { label: 'Type', metafield: 'type_d_electro' }
    ]
  };

  state.filtresActifs = {};

  // chargerMetafields supprime Etape E : remplace par mergeSfMetafields appele
  // par loadCollectionData. Les metafields sont desormais inclus dans la
  // response Storefront (~ 0 cout supplementaire). Le template
  // templates/collection.metafields.liquid est aussi supprime.
  // window.mooodMetafields est initialise en parallele par chargerCollection
  // -> mergeSfMetafields pour les collections SF (toutes les collections du
  // configurateur sont dans SF_LIST_COLLECTIONS depuis Etape E).

  async function chargerCouleurs() {
    if (!collections.length) return;
    try {
      const colsAvecCouleur = collections.filter(c => c.handle !== 'poignee-unit');
      if (!colsAvecCouleur.length) return;
      const resp = await fetch(`/collections/${colsAvecCouleur[0].handle}/products.json?limit=1`);
      const data = await resp.json();
      const produit = data.products?.[0];
      if (!produit) return;
      const optIdx = produit.options.findIndex(o => o.name.toLowerCase().includes('couleur') || o.name.toLowerCase().includes('color'));
      if (optIdx < 0) return;
      const seen = new Set();
      const couleurs = [];
      for (const variant of produit.variants || []) {
        const colorName = variant[`option${optIdx + 1}`];
        if (!colorName || seen.has(colorName)) continue;
        seen.add(colorName);
        couleurs.push({ name: colorName, swatchImage: '', swatchColor: '#e5e7eb' });
      }
      state.allCouleurs = couleurs;
      renderSwatches();
      renderPopup();
      // Images de pastilles : servies en priorite par window.mooodCouleurImages
      // (map handle->image generee cote Liquid, 0 requete). Avant : 1 fetch
      // /collections/{handle}.json PAR couleur (137) -> throttling storefront
      // apres ~100 requetes -> pastilles vides pour les couleurs de fin de liste.
      // Fallback fetch uniquement pour les couleurs absentes de la map.
      const imgMap = window.mooodCouleurImages || {};
      const manquantes = [];
      for (const couleur of couleurs) {
        const handle = nomToHandle(couleur.name);
        const img = imgMap[handle];
        if (img) { couleur.swatchImage = img; updateSwatchImage(couleur.name, img); }
        else manquantes.push(couleur);
      }
      const batchSize = 10;
      for (let i = 0; i < manquantes.length; i += batchSize) {
        const batch = manquantes.slice(i, i + batchSize);
        await Promise.all(batch.map(async (couleur) => {
          const handle = nomToHandle(couleur.name);
          try {
            const r = await fetch(`/collections/${handle}.json`);
            if (r.ok) {
              const d = await r.json();
              const img = d.collection?.image?.src;
              if (img) { couleur.swatchImage = img; updateSwatchImage(couleur.name, img); }
            }
          } catch(e) {}
        }));
      }
    } catch(e) { console.error('Erreur couleurs:', e); }
  }

  function updateSwatchImage(colorName, imgUrl) {
    document.querySelectorAll(`.moood-swatch-wrap[data-color="${colorName}"]`).forEach(el => {
      const inner = el.querySelector('div');
      if (inner) { inner.style.backgroundImage = `url(${imgUrl})`; inner.style.backgroundSize = 'cover'; }
    });
    document.querySelectorAll(`.moood-popup-swatch-item[data-color="${colorName}"] .moood-swatch`).forEach(el => {
      el.style.backgroundImage = `url(${imgUrl})`; el.style.backgroundSize = 'cover';
    });
  }

  function renderSwatches() {
    const wrap = document.getElementById('moood-swatches-preview');
    if (!wrap) return;
    const categoriesDeco = (window.mooodCategoriesCouleurs || []).sort((a, b) => a.ordre - b.ordre);
    const couleursPrioritaires = [];
    for (const cat of categoriesDeco) {
      for (const nomCouleur of cat.couleurs) {
        const c = state.allCouleurs.find(x => x.name === nomCouleur);
        if (c && !couleursPrioritaires.includes(c)) couleursPrioritaires.push(c);
      }
    }
    const autresCouleurs = state.allCouleurs.filter(c => !couleursPrioritaires.includes(c));
    const toutesOrdo = [...couleursPrioritaires, ...autresCouleurs];
    const maxSwatches = window.innerWidth <= 900 ? 4 : 8;
    const preview = toutesOrdo.slice(0, maxSwatches);
    const rest = toutesOrdo.length - maxSwatches;
    let html = preview.map(c => `
      <div class="moood-swatch-wrap ${state.couleurActive?.name === c.name ? 'active' : ''}" data-color="${c.name}" title="${c.name}" style="width:44px;height:44px;border-radius:50%;overflow:hidden;flex-shrink:0;cursor:pointer;border:2px solid ${state.couleurActive?.name === c.name ? '#12433D' : 'transparent'};transition:transform 0.2s,border-color 0.2s;">
        <div style="width:100%;height:100%;border-radius:50%;${c.swatchImage ? `background-image:url(${c.swatchImage});background-size:cover;background-position:center;` : `background:${c.swatchColor};`}"></div>
      </div>
    `).join('');
    if (rest > 0) html += `<span class="moood-swatch-plus" id="moood-open-popup">+ ${rest} choix</span>`;
    wrap.innerHTML = html;
    wrap.querySelectorAll('.moood-swatch-wrap').forEach(el => {
      el.addEventListener('click', () => {
        const c = state.allCouleurs.find(x => x.name === el.dataset.color);
        if (c) selectCouleur(c);
      });
    });
    document.getElementById('moood-open-popup')?.addEventListener('click', ouvrirPopup);
  }

  function renderPopup() {
    const content = document.getElementById('moood-popup-content');
    if (!content) return;
    const categorized = {};
    const autresCouleurs = [];
    state.allCouleurs.forEach(c => {
      let found = false;
      for (const cat of categories) {
        if (cat.couleurs.some(cc => cc === c.name || cc === c.name.replace(/\s+/g, ' ').trim())) {
          if (!categorized[cat.nom]) categorized[cat.nom] = { ordre: cat.ordre, couleurs: [] };
          categorized[cat.nom].couleurs.push(c); found = true; break;
        }
      }
      if (!found) autresCouleurs.push(c);
    });
    let html = '';
    for (const [nom, {couleurs}] of Object.entries(categorized).sort((a,b) => a[1].ordre - b[1].ordre)) {
      html += `<div class="moood-popup-category"><div class="moood-popup-cat-title">${nom}</div><div class="moood-popup-swatches">
        ${couleurs.map(c => `<div class="moood-popup-swatch-item ${state.couleurActive?.name === c.name ? 'active' : ''}" data-color="${c.name}">
          <span class="moood-swatch" style="display:block;${c.swatchImage ? `background-image:url(${c.swatchImage});background-size:cover;` : `background:${c.swatchColor};`}"></span>
          <span>${c.name}</span></div>`).join('')}
      </div></div>`;
    }
    if (autresCouleurs.length) {
      html += `<div class="moood-popup-category"><div class="moood-popup-cat-title">Autres</div><div class="moood-popup-swatches">
        ${autresCouleurs.map(c => `<div class="moood-popup-swatch-item ${state.couleurActive?.name === c.name ? 'active' : ''}" data-color="${c.name}">
          <span class="moood-swatch" style="display:block;${c.swatchImage ? `background-image:url(${c.swatchImage});background-size:cover;` : `background:${c.swatchColor};`}"></span>
          <span>${c.name}</span></div>`).join('')}
      </div></div>`;
    }
    content.innerHTML = html;
    content.querySelectorAll('.moood-popup-swatch-item').forEach(el => {
      el.addEventListener('click', () => {
        const c = state.allCouleurs.find(x => x.name === el.dataset.color);
        if (c) { selectCouleur(c); fermerPopup(); }
      });
    });
  }

  // Pastille caisson, source unique reutilisee par updateRappel (barre haute)
  // ET par buildCartHTML (items du panier configurateur). Logique :
  // - Blanc / Gris anthracite -> couleurs fixes
  // - Sinon (Bois legacy, "Couleur au choix", ou nom de couleur precise) :
  //   on tente de matcher le label dans state.allCouleurs (cas "Couleur au choix"
  //   avec couleur precise selectionnee -> caissonCouleur = nom de la couleur)
  //   pour reutiliser son swatchImage ou swatchColor. Sinon fallback teinte bois.
  function caissonPastilleBg(label) {
    if (label === 'Blanc') return 'background:#fff;border:1.5px solid #d1d5db';
    if (label === 'Gris anthracite') return 'background:#3d3d3d';
    const precise = (state.allCouleurs || []).find(c => c.name === label);
    if (precise?.swatchImage) return `background-image:url(${precise.swatchImage});background-size:cover;background-position:center`;
    if (precise?.swatchColor) return `background:${precise.swatchColor}`;
    return 'background:#c4996c';
  }

  function updateRappel() {
    const bar = document.getElementById('moood-rappel-bar');
    if (!bar) return;
    const parts = [];
    if (state.couleurActive) {
      const sw = state.couleurActive;
      const swStyle = sw.swatchImage ? `background-image:url(${sw.swatchImage});background-size:cover;` : 'background:#e5e7eb;';
      parts.push(`<span style="display:inline-flex;align-items:center;gap:5px;"><span style="display:inline-block;width:13px;height:13px;border-radius:50%;${swStyle}flex-shrink:0;clip-path:circle(50%);"></span><span>Façade : <strong>${sw.name}</strong></span></span>`);
    }
    if (state.caissonCouleur) {
      const bg = caissonPastilleBg(state.caissonCouleur);
      parts.push(`<span style="display:inline-flex;align-items:center;gap:5px;"><span style="display:inline-block;width:13px;height:13px;border-radius:50%;${bg};flex-shrink:0;"></span><span>Caisson : <strong>${state.caissonCouleur}</strong></span></span>`);
    }
    if (state.poigneeBasColonne) {
      parts.push(`<span>Poignée bas : <strong>${state.poigneeBasColonne}</strong></span>`);
    }
    if (state.poigneeHaut) {
      parts.push(`<span>Poignée haut : <strong>${state.poigneeHaut}</strong></span>`);
    }
    if (parts.length > 0) {
      bar.innerHTML = parts.join('<span class="moood-rappel-sep">·</span>');
      bar.classList.add('visible');
    } else {
      bar.classList.remove('visible');
    }
  }

  async function selectCouleur(couleur, explicit = true) {
    state.couleurActive = couleur;
    if (explicit) state.couleurChoisie = true;
    if (explicit) trackEvent('configurateur_couleur', { couleur: couleur.name });
    const couleurNomEl = document.getElementById('moood-couleur-nom');
    if (couleurNomEl) {
      const swatchStyle = couleur.swatchImage
        ? `background-image:url(${couleur.swatchImage});background-size:cover;`
        : `background:${couleur.swatchColor || '#e5e7eb'};`;
      couleurNomEl.innerHTML = `<span style="display:inline-block;width:18px;height:18px;border-radius:50%;${swatchStyle}vertical-align:middle;margin-right:6px;clip-path:circle(50%);flex-shrink:0;"></span>${couleur.name}`;
    }
    renderSwatches(); renderPopup();
    updateEtapeBarre('personnalisation');
    updateRappel();
    if (state.couleurChoisie) {
      document.getElementById('moood-caisson-section').style.display = 'block';
      document.getElementById('moood-poignee-section').style.display = 'block';
      const reqText = document.getElementById('moood-required-text');
      if (reqText && !state.poigneeChoisie) reqText.textContent = 'Choisissez maintenant votre type de poignée';
    }
    if (state.couleurChoisie && state.poigneeChoisie) {
      const tunnel = getTunnel();
      const col = tunnel[state.etapeActuelle];
      if (col && state.produits[col.handle]) renderCollection(col);
    }
  }

  async function selectPoignee(valeur, type) {
    if (type === 'haut') {
      state.poigneeHaut = valeur;
    } else {
      state.poigneeBasColonne = valeur;
    }
    document.querySelectorAll(`.moood-poignee-btn[data-poignee-type="${type}"]`).forEach(btn => btn.classList.toggle('active', btn.dataset.poignee === valeur));
    if (!state.poigneeBasColonne || !state.poigneeHaut) return;
    state.poigneeActive = state.poigneeBasColonne;
    state.poigneeChoisie = true;
    trackEvent('configurateur_poignee', { poignee_bas: state.poigneeBasColonne, poignee_haut: state.poigneeHaut });
    state.etapeActuelle = 0;
    updateEtapeBarre('personnalisation');
    document.getElementById('moood-couleur-required')?.classList.add('hidden');
    document.getElementById('moood-products-sections')?.classList.remove('moood-products-locked');
    document.getElementById('moood-valider-config') && (document.getElementById('moood-valider-config').style.display = 'block');
    updateRappel();
  }

  const PRODUITS_PAR_PAGE = 60;
  state.pageVisuelle = state.pageVisuelle || {};

  async function chargerCollection(col) {
    try {
      // Etape E : chargerMetafields supprime. loadCollectionData ->
      // mergeSfMetafields populate desormais window.mooodMetafields en
      // mode SF (toutes les collections du configurateur).
      if (!state.produits[col.handle]) {
        const loaded = await loadCollectionData(col.handle);
        state.produits[col.handle] = loaded.products;
        state.produitsPage = state.produitsPage || {};
        state.produitsPage[col.handle] = { page: loaded.source === 'sf' ? 999 : 1, hasMore: loaded.hasMore };
        if (loaded.source === 'sf') {
          console.log('[chargerCollection]', col.handle, '→ sf:', loaded.products.length, 'produits');
        }
        renderFiltres(col);
      }
      renderCollection(col);
    } catch(e) { console.error('Erreur collection:', col.handle, e); }
  }

  // Etape F : chargerTousLesProduits + chargerPageSuivante supprimes.
  // Le helper Storefront (Etape A) charge tout en 1 fois (jusqu'a 500 produits),
  // donc plus aucun besoin de pagination par fetch. La pagination visuelle
  // (PRODUITS_PAR_PAGE) reste dans renderCollection.

  function appliquerFiltres(produits, colHandle) {
    const filtresActifs = state.filtresActifs[colHandle] || {};
    const hasFiltres = Object.values(filtresActifs).some(v => v);
    if (!hasFiltres) return produits;
    const meta = window.mooodMetafields || {};
    return produits.filter(p => {
      const pm = meta[p.id] || meta[String(p.id)] || {};
      for (const [metafield, valeur] of Object.entries(filtresActifs)) {
        if (!valeur) continue;
        const val = pm[metafield];
        const valArr = Array.isArray(val) ? val : (val ? [val] : []);
        if (!valArr.includes(valeur)) return false;
      }
      return true;
    });
  }

  function renderFiltres(col) {
    const wrap = document.getElementById(`moood-filtres-${col.handle}`);
    if (!wrap) return;
    const filtresDispo = FILTRES_PAR_COLLECTION[col.handle] || [];
    const filtresActifs = state.filtresActifs[col.handle] || {};
    const pageInfo = (state.produitsPage || {})[col.handle] || {};
    const toutCharge = !pageInfo.hasMore;
    const triActif = (state.triActif || {})[col.handle] || 'alpha';
    const showLargeur = ['meuble-bas-unit', 'meuble-bas-faible-profondeur', 'meuble-haut-unit', 'colonne-unit'].includes(col.handle);
    const triOptions = [
      { value: 'alpha', label: 'Ordre alphabétique' },
      { value: 'prix-asc', label: 'Prix croissant' },
      { value: 'prix-desc', label: 'Prix décroissant' },
      ...(showLargeur ? [
        { value: 'larg-asc', label: 'Largeur croissante' },
        { value: 'larg-desc', label: 'Largeur décroissante' }
      ] : [])
    ];
    wrap.innerHTML = `
      <div class="moood-filtres">
        ${filtresDispo.map(f => {
          const valeurs = getValeursFiltre(col.handle, f.metafield);
          return `<div class="moood-filtre-group">
            <select class="moood-filtre-select ${filtresActifs[f.metafield] ? 'actif' : ''}" data-metafield="${f.metafield}" data-collection="${col.handle}">
              <option value="">${f.label}${!toutCharge ? ' …' : ''}</option>
              ${valeurs.map(v => `<option value="${v}" ${filtresActifs[f.metafield] === v ? 'selected' : ''}>${v}</option>`).join('')}
            </select>
          </div>`;
        }).join('')}
        <div class="moood-filtre-group">
          <select class="moood-filtre-select ${triActif !== 'alpha' ? 'actif' : ''}" data-tri="${col.handle}">
            ${triOptions.map(o => `<option value="${o.value}" ${triActif === o.value ? 'selected' : ''}>${o.label}</option>`).join('')}
          </select>
        </div>
        ${Object.values(filtresActifs).some(v => v) ? `<button class="moood-filtres-reset">✕ Effacer</button>` : ''}
      </div>
    `;
    wrap.querySelectorAll('.moood-filtre-select').forEach(select => {
      select.addEventListener('change', async () => {
        if (select.dataset.tri) {
          if (!state.triActif) state.triActif = {};
          state.triActif[col.handle] = select.value;
          renderCollection(col);
          renderFiltres(col);
          return;
        }
        const metafield = select.dataset.metafield;
        const valeur = select.value;
        if (!state.filtresActifs[col.handle]) state.filtresActifs[col.handle] = {};
        state.filtresActifs[col.handle][metafield] = valeur;
        state.pageVisuelle = state.pageVisuelle || {};
        state.pageVisuelle[col.handle] = 1;
        // Etape F : bloc 'if (pageInfo.hasMore) await chargerTousLesProduits'
        // supprime. En mode SF (toutes collections du configurateur), hasMore
        // est toujours false donc cette branche etait morte.
        renderCollection(col);
        renderFiltres(col);
        updateNavBar();
      });
    });
    wrap.querySelector('.moood-filtres-reset')?.addEventListener('click', () => {
      state.filtresActifs[col.handle] = {};
      state.pageVisuelle = state.pageVisuelle || {};
      state.pageVisuelle[col.handle] = 1;
      renderCollection(col);
      renderFiltres(col);
      updateNavBar();
    });
  }

  function getValeursFiltre(colHandle, metafield) {
    const meta = window.mooodMetafields || {};
    const produits = state.produits[colHandle] || [];
    const valeurs = new Set();
    for (const p of produits) {
      const pm = meta[p.id] || meta[String(p.id)] || {};
      const val = pm[metafield];
      if (val) {
        const arr = Array.isArray(val) ? val : [val];
        arr.forEach(v => { if (v) valeurs.add(v); });
      }
    }
    const FALLBACK = {
      'longueur_des_poignees': ['0 à 50mm','51 à 100mm','101 à 150mm','151 à 200mm','201 à 250mm'],
      'matiere_des_poignees': ['Bois','Métal'],
      'joue_et_fileur': ['Joue et fileur pour meuble bas','Joue et fileur pour meuble haut','Joue et fileur pour colonne','Joue et fileur pour îlot','Façade pour lave vaisselle']
    };
    if (FALLBACK[metafield]) FALLBACK[metafield].forEach(v => valeurs.add(v));
    return [...valeurs].sort((a, b) => {
      const numA = parseFloat(a.replace(/[^0-9.]/g, ''));
      const numB = parseFloat(b.replace(/[^0-9.]/g, ''));
      if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
      return a.localeCompare(b, 'fr');
    });
  }

  async function renderCollection(col, produitsOverride) {
    const container = document.querySelector(`.moood-collection-section[data-collection="${col.handle}"] .moood-products-grid`);
    if (!container) return;
    document.getElementById(`moood-loading-bar-${col.handle}`)?.remove();
    const produitsFiltres = (produitsOverride || state.produits[col.handle] || []).filter(p => !p.tags?.includes('masquer-configurateur'));
    const source = appliquerFiltres(produitsFiltres, col.handle);
    const poigneeCol = getPoigneeForCollection(col.handle);
    const colorName = state.couleurActive?.name;
    const isNoColor = col.handle === 'poignee-unit' || (source.length > 0 && !(source[0].options || []).some(o => {
      const n = (o.name || '').toLowerCase();
      return n.includes('couleur') || n.includes('color');
    }));
    const triActifCol = (state.triActif || {})[col.handle] || 'alpha';
    const getLargeurProd = p => {
      const m = (window.mooodMetafields || {})[p.id] || {};
      const v = Array.isArray(m.largeur_de_caisson) ? m.largeur_de_caisson[0] : m.largeur_de_caisson;
      if (v) { const x = String(v).match(/(\d+)/); if (x) return parseInt(x[1], 10); }
      const t = (p.title || '').match(/larg(?:eur|\.)?\s*(\d+)\s*cm/i);
      return t ? parseInt(t[1], 10) : 9999;
    };

    // Etape D : pre-fetch prixConfBatch AVANT le sort si tri prix actif sur
    // une collection SF (variants vide) avec couleur selectionnee. Garantit
    // un ordre strictement correct : le prix utilise est celui de la combo
    // (caisson + couleur + poignee) actuellement choisie, pas le proxy
    // priceRange.min de l'Etape C. Sans couleur ou hors whitelist : tri base
    // sur priceRange.min comme avant (acceptable, couleur pas encore choisie).
    const isPriceSort = triActifCol === 'prix-asc' || triActifCol === 'prix-desc';
    const isSfCol = SF_LIST_COLLECTIONS.has(col.handle) && source.length > 0 && (!source[0].variants || source[0].variants.length === 0);
    let prixResolusForSort = null;
    if (isPriceSort && isSfCol && colorName) {
      try {
        const map = await prixConfBatchLookup(source, { collection: col.handle });
        prixResolusForSort = new Map();
        map.forEach((r, handle) => {
          if (r && typeof r.priceCents === 'number') prixResolusForSort.set(handle, r.priceCents);
        });
      } catch (e) {
        console.warn('[renderCollection] prefetch sort prix failed:', e);
      }
    }

    // Etape C+D : getPrixProd lit le prix resolu (Map prefetch ci-dessus) si
    // dispo, sinon variant.price (legacy), sinon priceRange.min (proxy SF).
    const getPrixProd = p => {
      if (prixResolusForSort && prixResolusForSort.has(p.handle)) {
        return prixResolusForSort.get(p.handle) / 100;
      }
      if (p.variants && p.variants.length > 0) {
        const v = (colorName && !isNoColor) ? getVariantByColor(p, colorName, poigneeCol) : p.variants[0];
        if (v) return parseFloat(v.price || 0);
      }
      return parseFloat(p.priceRange?.minVariantPrice?.amount || 0);
    };
    const produits = source.slice().sort((a, b) => {
      switch (triActifCol) {
        case 'prix-asc': return getPrixProd(a) - getPrixProd(b);
        case 'prix-desc': return getPrixProd(b) - getPrixProd(a);
        case 'larg-asc': return getLargeurProd(a) - getLargeurProd(b);
        case 'larg-desc': return getLargeurProd(b) - getLargeurProd(a);
        default: return (a.title || '').localeCompare(b.title || '', 'fr');
      }
    });
    // Etape C : produitsMap simplifie. En mode SF (variants vide), on flag
    // sfMode=true. La carte est enabled meme sans variant resolu : le DOM
    // sera mis a jour par prixConfBatchLookup juste apres le render initial
    // (vrai prix + vrai variantId data attribute). Au click +, modifierPanier
    // appelle prixConfLookup qui re-resout (cache hit en general).
    const produitsMap = produits.map(p => {
      const sfMode = !p.variants || p.variants.length === 0;
      let variant = null;
      let truncated = false;
      let needsFetch = false;
      if (!sfMode) {
        variant = (colorName && !isNoColor) ? getVariantByColor(p, colorName, poigneeCol) : p.variants[0];
        truncated = p.variants.length >= 250;
        needsFetch = !!(colorName && !isNoColor && truncated && !variant);
        if (!variant && truncated && !needsFetch) variant = p.variants[0];
      }
      return { produit: p, variant, hasColor: sfMode || !!variant || needsFetch, needsFetch, sfMode };
    });

    // Etape F : bloc fetch /products/{handle}.js (produits "tronques")
    // supprime. En mode SF avec WITH_VARIANTS (poignee/joues/electro),
    // variants(first:30) est deja suffisant. En mode SF NO_VARIANTS
    // (meuble-bas/haut/colonne), prixConfBatchLookup resout via
    // variantBySelectedOptions.image{url} (Etape C2). En mode fallback
    // legacy products.json (exceptionnel), pas de produits avec >250
    // variants pour les collections du configurateur, donc
    // needsFetch reste false en pratique.
    const nbEl = document.getElementById(`moood-nb-produits-${col.handle}`);
    const pageInfo2 = (state.produitsPage || {})[col.handle] || {};
    const hasFiltres = Object.values(state.filtresActifs[col.handle] || {}).some(v => v);
    if (nbEl) {
      if (hasFiltres) nbEl.textContent = `(${produitsMap.length} résultat${produitsMap.length > 1 ? 's' : ''})`;
      else if (pageInfo2.hasMore) nbEl.textContent = '';
      else nbEl.textContent = `(${produitsMap.length})`;
    }
    const pageVis = (state.pageVisuelle || {})[col.handle] || 1;
    const produitsAffiches = produitsMap.slice(0, pageVis * PRODUITS_PAR_PAGE);
    const hasMoreVisuel = produitsMap.length > produitsAffiches.length;
    if (!produitsAffiches.length) {
      container.innerHTML = '<p style="color:#9ca3af;font-size:14px;">Aucun produit disponible.</p>';
    } else {
      container.innerHTML = produitsAffiches.map(({ produit, variant, hasColor, needsFetch, sfMode }) => {
        const img = getVariantImage(produit, variant, colorName);
        // Prix : variant.price (legacy) > priceRange.min (SF) > 0
        let price;
        if (variant) price = formatPrice(variant.price);
        else if (needsFetch) price = '— €';
        else if (sfMode) price = formatPrice(produit.priceRange?.minVariantPrice?.amount || 0);
        else price = formatPrice(produit.variants?.[0]?.price || 0);
        // VariantId : variant.id (legacy) > 0 (SF, sera ecrase par prixConfBatch
        // au prochain tick). Au click +, modifierPanier resout via prixConfLookup
        // donc variantId=0 n'est jamais envoye a /cart/add directement.
        const variantId = variant?.id || produit.variants?.[0]?.id || 0;
        // Etape C : en mode SF, qty badge depend du panier RESOLU par
        // productId (pas variantId, qui est instable avant prixConfBatch).
        const panierQty = sfMode
          ? state.panier.filter(i => i.productId === produit.id).reduce((s, i) => s + i.qty, 0)
          : getPanierQty(variantId);
        return `<div class="moood-product-card ${!hasColor ? 'disabled' : ''}" data-product-id="${produit.id}" data-variant-id="${variantId}" data-collection="${col.handle}">
          <a href="/products/${produit.handle}" target="_blank" rel="noopener" style="display:block;text-decoration:none;color:inherit;">
            <div class="moood-product-img-wrap">
              ${(() => { const badge = (window.mooodMetafields[produit.id] || {}).badge_custom; return badge ? `<div style="position:absolute;top:10px;right:10px;background:#12433D;color:#fff;font-size:10px;font-weight:700;padding:4px 10px;border-radius:20px;z-index:2;">${badge}</div>` : ''; })()}
              ${(() => {
                const isLowDepth = (produit.tags || []).some(t => String(t).toLowerCase() === 'faible-profondeur');
                if (!isLowDepth) return '';
                // Pastille top-right par defaut. Si badge_custom (top:10px right:10px)
                // est present, on decale verticalement sous lui (top:42px) pour eviter
                // le chevauchement. La bulle qty est en top-left donc jamais concernee.
                const hasCustomBadge = !!(window.mooodMetafields[produit.id] || {}).badge_custom;
                const topPos = hasCustomBadge ? '42px' : '10px';
                return `<div style="position:absolute;top:${topPos};right:10px;background:#C4622A;color:#fff;font-size:10px;font-weight:700;padding:4px 10px;border-radius:100px;border:1.5px solid #12312b;box-shadow:2px 2px 0 #12312b;text-transform:uppercase;letter-spacing:0.4px;transform:rotate(-2deg);z-index:2;line-height:1.2;white-space:nowrap;">Faible profondeur ✦</div>`;
              })()}
              <img src="${img}" alt="${produit.title}" loading="lazy" />
              <div class="moood-qty-badge">${panierQty}</div>
            </div>
          </a>
          <div class="moood-product-body">
            <a href="/products/${produit.handle}" target="_blank" rel="noopener" style="text-decoration:none;color:inherit;">
              <div class="moood-product-name">${produit.title}</div>
            </a>
            <div class="moood-product-price">${price}</div>
            ${(() => {
              const meta = (window.mooodMetafields || {})[produit.id] || {};
              const dims = [];
              const largeur = Array.isArray(meta.largeur_de_caisson) ? meta.largeur_de_caisson[0] : meta.largeur_de_caisson;
              const hauteur = Array.isArray(meta.hauteur_de_caisson) ? meta.hauteur_de_caisson[0] : meta.hauteur_de_caisson;
              const profondeur = Array.isArray(meta.profondeur_de_caisson) ? meta.profondeur_de_caisson[0] : meta.profondeur_de_caisson;
              if (largeur) dims.push(largeur.replace(/^Largeur de /i, 'Larg. '));
              if (hauteur) dims.push(hauteur.replace(/^Hauteur de /i, 'Haut. '));
              if (profondeur) dims.push(profondeur.replace(/^Profondeur de /i, 'Prof. '));
              return dims.length ? `<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:8px;">${dims.map(d => `<span style="font-size:10px;font-weight:600;color:#12433D;background:#e8f4f2;padding:3px 8px;border-radius:20px;">${d}</span>`).join('')}</div>` : '';
            })()}
            ${SF_LIST_COLLECTIONS_NO_VARIANTS.has(col.handle) && produit.tags?.includes('sens-porte') ? `
            <div style="display:flex;flex-direction:column;gap:5px;margin-top:6px;">
              <div style="display:flex;align-items:center;gap:5px;">
                <img src="https://cdn.shopify.com/s/files/1/0970/2427/8860/files/ouverture-gauche.png?v=1773744151" class="moood-sens-img" style="width:36px;height:24px;object-fit:contain;opacity:0.7;flex-shrink:0;" />
                <span class="moood-sens-label" style="font-size:10px;color:#6b7280;width:85px;flex-shrink:0;white-space:nowrap;">Ouvrant gauche</span>
                <button class="moood-qty-btn btn-moins-gauche" data-variant-id="${variantId}" aria-label="Retirer gauche">−</button>
                <span class="moood-qty-num-gauche" style="font-size:14px;font-weight:600;color:#111827;min-width:16px;text-align:center;">${getSensQty(variantId, 'gauche')}</span>
                <button class="moood-qty-btn btn-plus-gauche" data-variant-id="${variantId}" aria-label="Ajouter gauche">+</button>
              </div>
              <div style="display:flex;align-items:center;gap:5px;">
                <img src="https://cdn.shopify.com/s/files/1/0970/2427/8860/files/ouverture-droite.png?v=1773744151" class="moood-sens-img" style="width:36px;height:24px;object-fit:contain;opacity:0.7;flex-shrink:0;" />
                <span class="moood-sens-label" style="font-size:10px;color:#6b7280;width:85px;flex-shrink:0;white-space:nowrap;">Ouvrant droite</span>
                <button class="moood-qty-btn btn-moins-droite" data-variant-id="${variantId}" aria-label="Retirer droite">−</button>
                <span class="moood-qty-num-droite" style="font-size:14px;font-weight:600;color:#111827;min-width:16px;text-align:center;">${getSensQty(variantId, 'droite')}</span>
                <button class="moood-qty-btn btn-plus-droite" data-variant-id="${variantId}" aria-label="Ajouter droite">+</button>
              </div>
            </div>
            ` : `
            <div class="moood-qty-controls">
              <button class="moood-qty-btn btn-moins" aria-label="Retirer">−</button>
              <span class="moood-qty-num">${panierQty}</span>
              <button class="moood-qty-btn btn-plus" aria-label="Ajouter">+</button>
            </div>
            `}
          </div>
        </div>`;
      }).join('');
    }
    container.querySelectorAll('.moood-product-card').forEach(card => {
      const variantId = parseInt(card.dataset.variantId);
      const productId = parseInt(card.dataset.productId);
      const collection = card.dataset.collection;
      const produit = state.produits[collection]?.find(p => p.id === productId);
      if (!produit) return;
      const isSensCol = SF_LIST_COLLECTIONS_NO_VARIANTS.has(collection) && produit.tags?.includes('sens-porte');
      const pulseUpdate = () => {
        const qtyCol = state.panier.filter(i => i.collection === collection).reduce((s, i) => s + i.qty, 0);
        if (qtyCol > 0) updateEtapeBarre(collection);
        document.getElementById('moood-next-btn')?.classList.toggle('pulse', qtyCol > 0);
      };
      if (isSensCol) {
        card.querySelector('.btn-plus-droite')?.addEventListener('click', () => { modifierPanier(produit, variantId, collection, 1, 'droite'); pulseUpdate(); });
        card.querySelector('.btn-moins-droite')?.addEventListener('click', () => { modifierPanier(produit, variantId, collection, -1, 'droite'); pulseUpdate(); });
        card.querySelector('.btn-plus-gauche')?.addEventListener('click', () => { modifierPanier(produit, variantId, collection, 1, 'gauche'); pulseUpdate(); });
        card.querySelector('.btn-moins-gauche')?.addEventListener('click', () => { modifierPanier(produit, variantId, collection, -1, 'gauche'); pulseUpdate(); });
      } else {
        card.querySelector('.btn-plus')?.addEventListener('click', () => { modifierPanier(produit, variantId, collection, 1); pulseUpdate(); });
        card.querySelector('.btn-moins')?.addEventListener('click', () => modifierPanier(produit, variantId, collection, -1));
      }
    });

    // ============================================================================
    // [SOURCE UNIQUE PRIX] : pour les collections de SF_LIST_COLLECTIONS_NO_VARIANTS,
    // on resout prix + variantId + image via Storefront API en 1 batch pour
    // toutes les cards visibles, puis on met a jour le DOM. Ca couvre :
    //   - les variants accessibles (≤250) : prix natif Shopify identique
    //   - les variants >250 (chenes / brillants / texturees) : prix exact via
    //     variantBySelectedOptions, plus de reconstruction par ratio
    //   - le bug line_price=0 sur ajout panier d'un variant non accessible
    //     (le variantId resolved est valide cote Shopify backend)
    //   - le swap d'image variant selon couleur (Etape C2)
    // ============================================================================
    if (SF_LIST_COLLECTIONS_NO_VARIANTS.has(col.handle) && produitsAffiches.length > 0) {
      // Libelle adaptatif de la pastille "indisponible" :
      //   - meuble-haut + Gorge   -> "Non disponible en gorge"
      //   - meuble-haut + Push pull -> "Non disponible en push pull"
      //   - bas/colonne + Push pull -> "Non disponible en push pull"
      //   - sinon (combo non trouvee pour une raison autre) -> "Combinaison indisponible"
      // Permet d'ajouter de nouvelles poignees sans modifier le grisage.
      const labelIndispo = (function() {
        // joues/fileurs : produits couleur-seule, ne dependent PAS de la poignee.
        if (col.handle === 'joues-et-fileurs-unit') return 'Couleur indisponible';
        if (col.handle === 'meuble-haut-unit') {
          if (state.poigneeHaut === 'Gorge') return 'Non disponible en gorge';
          if (state.poigneeHaut === 'Push pull') return 'Non disponible en push pull';
        } else if (state.poigneeBasColonne === 'Push pull') {
          return 'Non disponible en push pull';
        } else if (state.poigneeBasColonne === 'Gorge alu') {
          return 'Non disponible en gorge alu';
        }
        return 'Combinaison indisponible';
      })();
      prixConfBatchLookup(produitsAffiches.map(x => x.produit), { collection: col.handle }).then(map => {
        produitsAffiches.forEach(({ produit }) => {
          const r = map.get(produit.handle);
          const card = container.querySelector('.moood-product-card[data-product-id="' + produit.id + '"]');
          if (!card) return;
          if (!r) {
            // Variant inexistant pour la combo actuelle (typiquement : Push pull
            // pour un produit qui n'a pas ce variant cote Shopify). On grise et
            // on affiche un message d'explication. Le grisage CSS rend la carte
            // non cliquable (pointer-events:none), donc l'ajout au panier est
            // bloque cote UI. modifierPanier a une seconde garde au cas ou.
            card.classList.add('push-pull-unavailable');
            const imgWrap = card.querySelector('.moood-product-img-wrap');
            if (imgWrap && !card.querySelector('.moood-product-pp-msg')) {
              const msg = document.createElement('div');
              msg.className = 'moood-product-pp-msg';
              msg.textContent = labelIndispo;
              imgWrap.appendChild(msg);
            }
            return;
          }
          // Combo disponible : retire l'eventuel grisage d'un render precedent.
          card.classList.remove('push-pull-unavailable');
          const oldMsg = card.querySelector('.moood-product-pp-msg');
          if (oldMsg) oldMsg.remove();
          const priceEl = card.querySelector('.moood-product-price');
          if (priceEl) priceEl.textContent = formatPrice(r.priceCents / 100);
          if (r.variantId) {
            card.dataset.variantId = r.variantId;
            card.dataset.variantIdResolved = '1';
          }
          // Etape C2 : swap image variant. variantBySelectedOptions retourne
          // image.url -> on l'applique sur l'<img> de la carte. Si null
          // (variant sans image associee), on garde la featuredImage.
          if (r.imageUrl) {
            const imgEl = card.querySelector('.moood-product-img-wrap img');
            if (imgEl) imgEl.src = r.imageUrl;
          }
        });
        // Reorganisation : les cartes grisees (push-pull-unavailable) sont
        // sorties du grid principal et placees dans un wrap dedie POSITIONNE
        // APRES le bouton "Voir plus". Comme ca :
        //   - container = uniquement les produits selectionnables (paginates
        //     par PRODUITS_PAR_PAGE, ordre du tri actif intact)
        //   - "Voir plus" charge la suite des selectionnables
        //   - sous le bouton : tous les grisees d'un coup (pas paginees)
        // Le grayWrap reproduit la classe .moood-products-grid pour conserver
        // la mise en grille (colonnes responsives, gap, etc.).
        const unavailableCards = container.querySelectorAll('.moood-product-card.push-pull-unavailable');
        if (unavailableCards.length > 0) {
          let grayWrap = document.getElementById('moood-grayed-' + col.handle);
          const charger = document.getElementById('moood-charger-plus-' + col.handle);
          if (!grayWrap) {
            grayWrap = document.createElement('div');
            grayWrap.id = 'moood-grayed-' + col.handle;
            grayWrap.className = 'moood-products-grid';
            grayWrap.style.marginTop = '24px';
            if (charger && charger.parentElement) {
              charger.parentElement.insertBefore(grayWrap, charger.nextSibling);
            } else {
              container.parentElement.appendChild(grayWrap);
            }
          }
          // 2026-10-23 : « Voir plus » re-rend des cartes déjà grisées -> on remplace l'ancienne carte du même produit (plus de doublons)
          unavailableCards.forEach(card => { const old = grayWrap.querySelector('.moood-product-card[data-product-id="' + card.dataset.productId + '"]'); if (old) old.remove(); grayWrap.appendChild(card); });
        } else {
          // Si plus aucune grisee (changement de poignee / couleur), on nettoie
          // le wrap dedie pour qu'il n'apparaisse pas vide.
          const grayWrap = document.getElementById('moood-grayed-' + col.handle);
          if (grayWrap) grayWrap.remove();
        }
      }).catch(e => console.warn('[renderCollection] prixConfBatch failed:', e));
    }

    // Etape F : pagination LEGACY (pageInfo.hasMore + chargerPageSuivante)
    // supprimee. Reste la pagination VISUELLE (hasMoreVisuel) : on charge
    // tous les produits d'un coup via Storefront (Etape A) mais on en affiche
    // PRODUITS_PAR_PAGE a la fois cote UI pour ne pas innerHTML 76 cartes
    // d'un seul tenant.
    let chargerPlusWrap = document.getElementById(`moood-charger-plus-${col.handle}`);
    if (!chargerPlusWrap) {
      chargerPlusWrap = document.createElement('div');
      chargerPlusWrap.id = `moood-charger-plus-${col.handle}`;
      chargerPlusWrap.style.cssText = 'text-align:center;margin-top:24px;';
      container.parentElement.appendChild(chargerPlusWrap);
    }
    if (hasMoreVisuel) {
      chargerPlusWrap.innerHTML = `<button class="moood-btn-charger-plus" id="btn-charger-plus-${col.handle}">Voir plus de produits</button>`;
      document.getElementById(`btn-charger-plus-${col.handle}`)?.addEventListener('click', () => {
        const btn = document.getElementById(`btn-charger-plus-${col.handle}`);
        if (btn) { btn.disabled = true; btn.textContent = 'Chargement…'; }
        state.pageVisuelle = state.pageVisuelle || {};
        state.pageVisuelle[col.handle] = pageVis + 1;
        renderCollection(col);
        renderFiltres(col);
      });
    } else {
      chargerPlusWrap.innerHTML = '';
    }
  }

  // ─── Panier ────────────────────────────────────────────────────────────────
  function getPanierQty(variantId) {
    return state.panier.filter(i => i.variantId === variantId).reduce((s, i) => s + i.qty, 0);
  }

  function getSensQty(variantId, sens) {
    return state.panier.find(i => i.variantId === variantId && i.sens === sens)?.qty || 0;
  }

  async function modifierPanier(produit, variantId, collection, delta, sens = null) {
    const colorName = collection === 'poignee-unit' ? '' : (state.couleurActive?.name || '');
    const poigneeItem = getPoigneeForCollection(collection);

    // [SOURCE UNIQUE PRIX] : pour les collections de SF_LIST_COLLECTIONS_NO_VARIANTS,
    // on resout prix + variantId + image via Storefront API (cache shared avec
    // le batch renderCollection, donc generalement instant). Fallback sur
    // l'ancien mecanisme (variant.price) si helper indispo ou produit hors
    // ces collections.
    let resolvedVariantId = variantId;
    let resolvedPriceCents = 0;
    let resolvedImageUrl = null;
    if (SF_LIST_COLLECTIONS_NO_VARIANTS.has(collection)) {
      try {
        const r = await prixConfLookup(produit, { collection });
        if (!r) {
          // Variant inexistant pour la combo (typiquement : Push pull pour un
          // produit qui n'a pas ce variant cote Shopify). On REFUSE l'ajout
          // pour eviter un /cart/add a variantId=0 -> line_price=0.
          // Cas normalement bloque cote UI par le grisage push-pull-unavailable
          // de renderCollection, mais on garde une seconde garde ici.
          console.warn('[modifierPanier] variant inexistant pour', produit.handle, 'combinaison actuelle - ajout refuse');
          if (delta > 0) {
            // Feedback visuel succinct (le grisage de la carte fait office d'explication)
            const card = document.querySelector('.moood-product-card[data-product-id="' + produit.id + '"]');
            if (card && !card.classList.contains('push-pull-unavailable')) {
              card.classList.add('push-pull-unavailable');
              const imgWrap = card.querySelector('.moood-product-img-wrap');
              if (imgWrap && !card.querySelector('.moood-product-pp-msg')) {
                const msg = document.createElement('div');
                msg.className = 'moood-product-pp-msg';
                // Meme logique adaptive que renderCollection
                let lbl = 'Combinaison indisponible';
                if (collection === 'meuble-haut-unit') {
                  if (state.poigneeHaut === 'Gorge') lbl = 'Non disponible en gorge';
                  else if (state.poigneeHaut === 'Push pull') lbl = 'Non disponible en push pull';
                } else if (state.poigneeBasColonne === 'Push pull') {
                  lbl = 'Non disponible en push pull';
                } else if (state.poigneeBasColonne === 'Gorge alu') {
                  lbl = 'Non disponible en gorge alu';
                }
                msg.textContent = lbl;
                imgWrap.appendChild(msg);
              }
            }
          }
          return;
        }
        if (r.variantId) resolvedVariantId = r.variantId;
        resolvedPriceCents = r.priceCents;
        resolvedImageUrl = r.imageUrl || null;
      } catch (e) { console.warn('[modifierPanier] prixConf failed:', e); }
    }
    const variant = produit.variants?.find(v => v.id === resolvedVariantId);
    // Image : priorite Storefront variantBySelectedOptions (vraie image du
    // variant avec la couleur active), fallback getVariantImage (legacy
    // filename match) qui sait gerer les produits hors collections SF.
    const img = resolvedImageUrl || getVariantImage(produit, variant, colorName);
    // price stocke en EUROS (float), pour matcher la convention historique du
    // panier : variant?.price vient de /collections/X/products.json qui renvoie
    // un STRING en euros (ex "91.83"), pas en cents. Tous les renderPanier/
    // formatPrice/totaux supposent euros. Si on stockait des cents (11190 pour
    // 111.90), formatPrice afficherait "11 190,00 €" au lieu de "111,90 €".
    const price = resolvedPriceCents > 0 ? resolvedPriceCents / 100 : parseFloat(variant?.price || 0);

    const idx = state.panier.findIndex(i => i.variantId === resolvedVariantId && i.sens === sens && i.poignee === poigneeItem);
    if (idx >= 0) {
      state.panier[idx].qty += delta;
      if (state.panier[idx].qty <= 0) state.panier.splice(idx, 1);
    } else if (delta > 0) {
      state.panier.push({ productId: produit.id, variantId: resolvedVariantId, name: produit.title, color: colorName, price, image: img, qty: 1, collection, sens, poignee: poigneeItem, caissonCouleur: state.caissonCouleur });
    }
    trackEvent('configurateur_ajout', { produit: produit.title, collection, prix: parseFloat(price) });
    // Query par productId (invariant), pas variantId (qui peut differer entre closure et state apres resolution helper)
    const card = document.querySelector(`.moood-product-card[data-product-id="${produit.id}"]`);
    if (card) {
      const totalQty = getPanierQty(resolvedVariantId);
      const badge = card.querySelector('.moood-qty-badge');
      if (badge) badge.textContent = totalQty;
      const gauEl = card.querySelector('.moood-qty-num-gauche');
      const droEl = card.querySelector('.moood-qty-num-droite');
      if (gauEl) gauEl.textContent = getSensQty(resolvedVariantId, 'gauche');
      if (droEl) droEl.textContent = getSensQty(resolvedVariantId, 'droite');
      const numEl = card.querySelector('.moood-qty-num');
      if (numEl) numEl.textContent = totalQty;
    }
    renderPanier(resolvedVariantId, sens);
  }

  function calcLineaireMeubles() {
    const meta = window.mooodMetafields || {};
    let bas = 0, haut = 0, colonne = 0;
    for (const item of state.panier) {
      if (item.collection === 'poignee-unit' || item.surMesure) continue;
      const pm = meta[item.productId] || meta[String(item.productId)] || {};
      const largeurRaw = Array.isArray(pm.largeur_de_caisson) ? pm.largeur_de_caisson[0] : pm.largeur_de_caisson;
      let cm = NaN;
      if (largeurRaw) {
        cm = parseFloat(largeurRaw.replace(/[^0-9.]/g, ''));
      } else if (item.name) {
        const m = item.name.match(/Largeur\s+(\d{3,4})/i) || item.name.match(/larg\.?\s*(\d{2,4})\s*cm/i);
        if (m) {
          const num = parseFloat(m[1]);
          cm = num > 100 ? num / 10 : num;
        }
      }
      if (isNaN(cm)) continue;
      cm = Math.ceil(cm / 10) * 10;
      // faible-profondeur compte comme meuble bas (variante avec profondeur reduite,
      // meme typologie pour le calcul de pose lineaire).
      if (item.collection === 'meuble-bas-unit' || item.collection === 'meuble-bas-faible-profondeur') bas += cm * item.qty;
      else if (item.collection === 'meuble-haut-unit') haut += cm * item.qty;
      else if (item.collection === 'colonne-unit') colonne += cm * item.qty;
    }
    return { bas: Math.round(bas), haut: Math.round(haut), colonne: Math.round(colonne) };
  }

  function buildCartHTML() {
    if (!state.panier.length && state.poigneeActive !== 'Poignée intégrée') return '<div class="moood-cart-empty">Aucun produit sélectionné</div>';
    const tunnel = getTunnel();
    const itemsPoignees = state.panier.filter(i => i.collection === 'poignee-unit');
    const itemsSurMesure = state.panier.filter(i => i.surMesure);
    const itemsCouleur = state.panier.filter(i => i.collection !== 'poignee-unit' && !i.surMesure);
    const couleursOrder = [];
    const byColor = {};
    for (const item of itemsCouleur) {
      const color = item.color || 'Sans couleur';
      if (!byColor[color]) { byColor[color] = {}; couleursOrder.push(color); }
      if (!byColor[color][item.collection]) byColor[color][item.collection] = [];
      byColor[color][item.collection].push(item);
    }
    let html = '';

    if (state.poigneeActive === 'Poignée intégrée') {
      html += `<div style="background:#f0f7f6;border-radius:10px;padding:8px 12px;margin-bottom:10px;font-size:12px;color:#12433D;font-weight:600;display:flex;align-items:center;gap:6px;">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 12h6"/></svg>
        Poignée intégrée sélectionnée
      </div>`;
    }
    if (itemsPoignees.length > 0) {
      const poigneeQty = itemsPoignees.reduce((s, i) => s + i.qty, 0);
      const poigneeTotal = itemsPoignees.reduce((s, i) => s + i.price * i.qty, 0);
      html += `<div class="moood-cart-section-divider" style="margin-top:0;"></div>`;
      html += `<div class="moood-cart-col-label" style="margin-top:6px;">Poignées <span style="color:#12433D;font-weight:700;">(${poigneeQty})</span></div>`;
      for (const item of itemsPoignees) {
        html += `<div class="moood-cart-item">
          <img class="moood-cart-item-img" src="${item.image}" alt="${item.name}" />
          <div class="moood-cart-item-info">
            <div class="moood-cart-item-name">${item.name}</div>
            <div style="display:flex;align-items:center;justify-content:space-between;margin-top:4px;">
              <div class="moood-cart-item-qty-controls">
                <button class="moood-cart-qty-btn moood-cart-qty-moins" data-variant-id="${item.variantId}" data-collection="${item.collection}">−</button>
                <span class="moood-cart-item-qty-num">${item.qty}</span>
                <button class="moood-cart-qty-btn moood-cart-qty-plus" data-variant-id="${item.variantId}" data-collection="${item.collection}">+</button>
              </div>
              <div class="moood-cart-item-price">${formatPrice(item.price * item.qty)}</div>
            </div>
          </div>
          <button class="moood-cart-item-remove" data-panier-idx="${state.panier.indexOf(item)}" aria-label="Supprimer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>
          </button>
        </div>`;
      }
      html += `<div class="moood-cart-section-subtotal"><span>Sous-total poignées <span style="background:#12433D;color:#fff;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;font-size:10px;font-weight:700;vertical-align:middle;">${poigneeQty}</span></span><span>${formatPrice(poigneeTotal)}</span></div>`;
      if (couleursOrder.length > 0) html += '<div class="moood-cart-section-divider"></div>';
    }
    const panierSansPoignees2 = state.panier.filter(i => i.collection !== 'poignee-unit' && !i.surMesure);
    const couleursResume = [...new Set(panierSansPoignees2.map(i => i.color).filter(Boolean))];
    if (couleursResume.length > 0) {
      html += `<div style="font-size:12px;color:#6b7280;margin:4px 0 12px;padding:6px 10px;background:#fff;border-radius:8px;">`;
      html += couleursResume.map(c => {
        const swatch = state.allCouleurs.find(s => s.name === c);
        const swatchStyle = swatch?.swatchImage ? `background-image:url(${swatch.swatchImage});background-size:cover;` : `background:${swatch?.swatchColor || '#e5e7eb'};`;
        const qty = panierSansPoignees2.filter(i => i.color === c).reduce((s, i) => s + i.qty, 0);
        return `<span data-color-goto="${c}" style="display:inline-flex;align-items:center;gap:6px;margin-right:12px;cursor:pointer;padding:4px 8px;border-radius:20px;transition:background 0.15s;" onmouseover="this.style.background='#e8f4f2'" onmouseout="this.style.background='transparent'">
          <span style="display:inline-block;width:14px;height:14px;border-radius:50%;${swatchStyle}flex-shrink:0;clip-path:circle(50%)"></span>
          <span style="font-weight:600;color:#111827;">${c}</span>
          <span style="color:#6b7280;font-size:11px;">${qty} produit${qty > 1 ? 's' : ''}</span>
        </span>`;
      }).join('');
      html += `</div>`;
    }
    let firstColor = true;
    for (const color of couleursOrder) {
      const swatch = state.allCouleurs.find(s => s.name === color);
      const swatchStyle = swatch?.swatchImage ? `background-image:url(${swatch.swatchImage});background-size:cover;` : `background:${swatch?.swatchColor || '#e5e7eb'};`;
      if (!firstColor) html += '<div class="moood-cart-section-divider"></div>';
      firstColor = false;
      html += `<div class="moood-cart-color-header" data-color-section="${color}">
        <span class="moood-cart-color-swatch" style="${swatchStyle}"></span>
        <span class="moood-cart-color-name">${color}</span>
      </div>`;
      let colorTotal = 0;
      for (const colHandle of Object.keys(byColor[color])) {
        const items = byColor[color][colHandle];
        const colObj = tunnel.find(c => c.handle === colHandle);
        const colQty = items.reduce((s, i) => s + i.qty, 0);
        if (colObj) html += `<div class="moood-cart-col-label">${colObj.title} <span style="color:#12433D;font-weight:700;">(${colQty})</span></div>`;
        const itemsTries = [...items].sort((a, b) => a.variantId - b.variantId);
        for (const item of itemsTries) {
          colorTotal += item.price * item.qty;
          html += `<div class="moood-cart-item" data-variant-id="${item.variantId}" data-sens="${item.sens || ''}">
            <img class="moood-cart-item-img" src="${item.image}" alt="${item.name}" />
            <div class="moood-cart-item-info">
              <div class="moood-cart-item-name">${item.name}</div>
              ${item.sens ? `<div style="font-size:11px;color:#12433D;font-weight:600;margin-top:2px;">↔ Ouverture ${item.sens}${item.poignee ? ' · ' + item.poignee : ''}</div>` : (item.poignee ? `<div style="font-size:11px;color:#12433D;font-weight:600;margin-top:2px;">${item.poignee}</div>` : '')}
              ${item.barreProps && item.barreProps.length ? `<div style="font-size:11px;color:#12433D;font-weight:600;margin-top:2px;">${item.barreProps.map(o => o.nom + ': ' + o.valeur).join(' · ')}</div>` : ''}
              ${!item.surMesure && item.collection !== 'poignee-unit' && item.caissonCouleur ? `<div style="font-size:11px;color:#6b7280;margin-top:2px;display:flex;align-items:center;gap:4px;"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;flex-shrink:0;${caissonPastilleBg(item.caissonCouleur)};"></span>Caisson ${item.caissonCouleur}</div>` : ''}
              <div style="display:flex;align-items:center;justify-content:space-between;margin-top:4px;">
                <div class="moood-cart-item-qty-controls">
                  <button class="moood-cart-qty-btn moood-cart-qty-moins" data-variant-id="${item.variantId}" data-collection="${item.collection}" data-sens="${item.sens || ''}">−</button>
                  <span class="moood-cart-item-qty-num">${item.qty}</span>
                  <button class="moood-cart-qty-btn moood-cart-qty-plus" data-variant-id="${item.variantId}" data-collection="${item.collection}" data-sens="${item.sens || ''}">+</button>
                </div>
                <div class="moood-cart-item-price">${formatPrice(item.price * item.qty)}</div>
              </div>
            </div>
            <button class="moood-cart-item-remove" data-panier-idx="${state.panier.indexOf(item)}" aria-label="Supprimer">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>
            </button>
          </div>`;
        }
      }
      const colorQty = Object.values(byColor[color]).flat().reduce((s, i) => s + i.qty, 0);
      html += `<div class="moood-cart-section-subtotal"><span>Sous-total <span style="background:#12433D;color:#fff;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;font-size:10px;font-weight:700;vertical-align:middle;">${colorQty}</span></span><span>${formatPrice(colorTotal)}</span></div>`;
    }
    if (itemsSurMesure.length > 0) {
      html += '<div class="moood-cart-section-divider"></div>';
      html += `<div class="moood-cart-color-header">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#12433D" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
        <span class="moood-cart-color-name">Sur-mesure</span>
      </div>`;
      for (const item of itemsSurMesure) {
        html += `<div class="moood-cart-item" data-variant-id="${item.variantId}">
          <img class="moood-cart-item-img" src="${item.image}" alt="${item.name}" />
          <div class="moood-cart-item-info">
            <div class="moood-cart-item-name">${item.name}</div>
            <div style="font-size:11px;color:#6b7280;margin-top:2px;">${item.color}</div>
            ${item.poignee ? `<div style="font-size:11px;color:#12433D;font-weight:600;margin-top:2px;">${item.poignee}</div>` : ''}
            ${item.caissonCouleur ? `<div style="font-size:11px;color:#6b7280;margin-top:2px;display:flex;align-items:center;gap:4px;"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;flex-shrink:0;${caissonPastilleBg(item.caissonCouleur)};"></span>Caisson ${item.caissonCouleur}</div>` : ''}
            ${(() => { const sensOpt = (item.surMesureProps?.options || []).find(o => o.nom === 'Sens ouverture' || o.nom === "Sens d'ouverture"); return sensOpt && sensOpt.valeur && sensOpt.valeur !== 'Non applicable' ? `<div style="font-size:11px;color:#12433D;font-weight:600;margin-top:2px;">↔ Ouverture ${sensOpt.valeur}</div>` : ''; })()}
            ${(() => {
              const compsLabels = ['Porte (dimensions)','Montant gauche (dimensions)','Montant droit (dimensions)','Traverse haute (dimensions)','Plinthe (dimensions)'];
              const opts = item.surMesureProps?.options || [];
              const comps = compsLabels.map(l => opts.find(o => o.nom === l)).filter(Boolean);
              if (!comps.length) return '';
              const short = {'Porte (dimensions)':'Porte','Montant gauche (dimensions)':'Mt. gauche','Montant droit (dimensions)':'Mt. droit','Traverse haute (dimensions)':'Traverse','Plinthe (dimensions)':'Plinthe'};
              return `<div style="margin-top:6px;padding:8px 10px;background:#fff8ed;border:1px solid #f0e5d4;border-radius:8px;font-size:10px;color:#12312b;line-height:1.5;">${comps.map(c=>`<div><span style="color:#6b7280;">${short[c.nom]||c.nom} :</span> <strong>${c.valeur}</strong></div>`).join('')}</div>`;
            })()}
            <div style="display:flex;align-items:center;justify-content:space-between;margin-top:4px;">
              <div style="font-size:13px;color:#6b7280;">qté : ${item.qty}</div>
              <div class="moood-cart-item-price">${formatPrice(item.price * item.qty)}</div>
            </div>
          </div>
          <button class="moood-cart-item-remove" data-panier-idx="${state.panier.indexOf(item)}" aria-label="Supprimer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>
          </button>
        </div>`;
      }
    }
    const lineaire = calcLineaireMeubles();
    if (lineaire.bas > 0 || lineaire.haut > 0 || lineaire.colonne > 0) {
      // Cout de pose estime : reutilise les metres lineaires deja calcules
      // (lineaire.X est en CENTIMETRES). Tarifs : 200 / 79 / 279 €/ml.
      // PUREMENT INDICATIF : jamais ajoute au total panier, jamais envoye
      // a Shopify. Chaque ligne est arrondie a l'euro, le total est la
      // somme des lignes arrondies (donc le client voit que ca colle).
      const basM = lineaire.bas / 100;
      const hautM = lineaire.haut / 100;
      const colonneM = lineaire.colonne / 100;
      const coutBas = Math.round(basM * 200);
      const coutHaut = Math.round(hautM * 79);
      const coutColonne = Math.round(colonneM * 279);
      const totalPose = coutBas + coutHaut + coutColonne;
      const fmtEur = n => n.toLocaleString('fr-FR') + ' €';
      // Lien CTA + style commun (souligne, cursor pointer, color brand)
      const ctaStyle = 'color:#12433D;font-weight:600;text-decoration:underline;cursor:pointer;background:none;border:0;padding:0;font-size:inherit;font-family:inherit;';
      html += `<div style="background:#e8f4f2;border-radius:12px;padding:12px 16px;margin-top:12px;font-size:12px;color:#12433D;">
        <div style="font-weight:700;margin-bottom:6px;">📏 Linéaire estimé</div>
        ${lineaire.bas > 0 ? `<div>Meubles bas : <strong>${(lineaire.bas/100).toFixed(2).replace('.',',')} m</strong></div>` : ''}
        ${lineaire.haut > 0 ? `<div>Meubles hauts : <strong>${(lineaire.haut/100).toFixed(2).replace('.',',')} m</strong></div>` : ''}
        ${lineaire.colonne > 0 ? `<div>Colonnes : <strong>${(lineaire.colonne/100).toFixed(2).replace('.',',')} m</strong></div>` : ''}
        <div data-pose-container data-pose-open="0" style="border-top:1px dashed #b8d3cf;margin-top:10px;padding-top:8px;">
          <div data-pose-summary>
            🔧 Total pose estimé : <strong>${fmtEur(totalPose)}</strong> · <button type="button" data-pose-toggle style="${ctaStyle}">Voir le détail ▾</button>
          </div>
          <div data-pose-detail style="display:none;">
            <div style="font-weight:700;margin-bottom:6px;">🔧 Coût de pose estimé</div>
            ${lineaire.bas > 0 ? `<div>Meubles bas : <strong>${fmtEur(coutBas)}</strong></div>` : ''}
            ${lineaire.haut > 0 ? `<div>Meubles hauts : <strong>${fmtEur(coutHaut)}</strong></div>` : ''}
            ${lineaire.colonne > 0 ? `<div>Colonnes : <strong>${fmtEur(coutColonne)}</strong></div>` : ''}
            <div style="margin-top:6px;padding-top:6px;border-top:1px solid #b8d3cf;font-weight:700;">Total pose estimé : ${fmtEur(totalPose)}</div>
            <div style="margin-top:6px;font-size:11px;opacity:0.75;font-style:italic;">Estimation indicative, non incluse dans le total.</div>
            <div style="margin-top:6px;"><button type="button" data-pose-toggle style="${ctaStyle}">Réduire ▴</button></div>
          </div>
        </div>
      </div>`;
    }
    if (!html) return '<div class="moood-cart-empty">Aucun produit sélectionné</div>';
    return html;
  }

  function renderPanier(variantIdToScroll, sensToScroll) {
    try {
      // BUG restauration : on sauve maintenant pid (productId), prix, nm, img
      // pour TOUS les items (pas seulement sur-mesure). Necessaire car le
      // variantId stocké peut etre >250e variant (helper Storefront resout n'importe
      // quel variant); products.json ne renvoie que les 250 premiers variants par
      // produit. Sans ces champs, la restauration ne retrouve pas l'item et le
      // panier reste vide. Compat retrocompat : les OLD configs sans ces champs
      // tombent sur le fallback variant.price/produit.featured_image dans la
      // boucle de restauration (cf. init()).
      const snap = { cl: state.couleurActive?.name || '', pg: state.poigneeActive || '', pgBas: state.poigneeBasColonne || '', pgHaut: state.poigneeHaut || '', cc: state.caissonCouleur || 'Blanc', p: state.panier.map(i => ({ v: i.variantId, pid: i.productId, q: i.qty, c: i.collection, col: i.color, sm: i.surMesure || false, prix: i.price, s: i.sens || null, nm: i.name, smp: i.surMesure ? i.surMesureProps : undefined, poig: i.poignee || undefined, caissc: i.caissonCouleur || undefined, img: i.image })), ts: Date.now() };
      localStorage.setItem('moood_config', JSON.stringify(snap));
      try {
        clearTimeout(window._mooodReplaceStateTimer);
        window._mooodReplaceStateTimer = setTimeout(() => {
          history.replaceState(null, '', '?config=' + encodeURIComponent(btoa(JSON.stringify(snap))));
        }, 800);
      } catch(e) {}
      if (state.panier.length > 0) {
        const hist = JSON.parse(localStorage.getItem('moood_historique') || '[]');
        const dejaIdx = hist.findIndex(h => h.cl === snap.cl && h.pg === snap.pg && JSON.stringify(h.p) === JSON.stringify(snap.p));
        if (dejaIdx >= 0) hist.splice(dejaIdx, 1);
        hist.unshift(snap);
        localStorage.setItem('moood_historique', JSON.stringify(hist.slice(0, 10)));
      }
    } catch(e) {}
    const total = state.panier.reduce((s, i) => s + i.price * i.qty, 0);
    const totalQty = state.panier.reduce((s, i) => s + i.qty, 0);
    const totalFmt = formatPrice(total);
    const cartItemsHTML = buildCartHTML();
    ['desktop', 'mobile'].forEach(type => {
      const items = document.getElementById(`moood-cart-items-${type}`);
      const totalEl = document.getElementById(`moood-cart-total-${type}`);
      const countEl = document.getElementById(`moood-cart-count-${type}`);
      const atcEl = document.getElementById(`moood-btn-atc-${type}`);
      if (items) {
        items.innerHTML = cartItemsHTML;
        if (variantIdToScroll) {
          const sensSelector = sensToScroll ? `[data-sens="${sensToScroll}"]` : '';
          const targetItem = items.querySelector(`.moood-cart-item[data-variant-id="${variantIdToScroll}"]${sensSelector}`);
          if (targetItem) {
            // Scroll précis via getBoundingClientRect (indépendant du DOM)
            const itemTop = targetItem.getBoundingClientRect().top;
            const containerTop = items.getBoundingClientRect().top;
            const scrollOffset = items.scrollTop + (itemTop - containerTop) - 8;
            items.scrollTo({ top: scrollOffset, behavior: 'smooth' });
            targetItem.classList.add('just-added');
            setTimeout(() => targetItem.classList.remove('just-added'), 600);
          }
        }
        // Suppression : pas de scroll automatique, on reste où on est
        items.querySelectorAll('[data-color-goto]').forEach(el => {
          el.addEventListener('click', () => {
            const section = items.querySelector(`[data-color-section="${el.dataset.colorGoto}"]`);
            if (section) items.scrollTo({ top: section.offsetTop - items.offsetTop - 8, behavior: 'smooth' });
          });
        });
        items.querySelectorAll('.moood-cart-item-remove').forEach(btn => {
          btn.addEventListener('click', () => {
            const idx = parseInt(btn.dataset.panierIdx);
            if (!isNaN(idx) && idx >= 0 && idx < state.panier.length) {
              const removed = state.panier[idx];
              state.panier.splice(idx, 1);
              if (removed) updateCardQty(removed.variantId, getPanierQty(removed.variantId));
            }
            renderPanier();
          });
        });
      }
      if (totalEl) totalEl.textContent = totalFmt;
      if (countEl) countEl.textContent = totalQty;
      if (atcEl) atcEl.disabled = totalQty === 0;
    });
    document.getElementById('moood-mobile-count') && (document.getElementById('moood-mobile-count').textContent = totalQty);
    document.getElementById('moood-mobile-total') && (document.getElementById('moood-mobile-total').textContent = totalFmt);
    if (state.poigneeChoisie) updateNavBar();
    ['desktop', 'mobile'].forEach(type => {
      const items = document.getElementById(`moood-cart-items-${type}`);
      if (!items) return;
      items.querySelectorAll('.moood-cart-qty-moins').forEach(btn => {
        btn.addEventListener('click', () => {
          const vId = parseInt(btn.dataset.variantId);
          const col = btn.dataset.collection;
          const sens = btn.dataset.sens || null;
          const produit = Object.values(state.produits).flat().find(p => p.variants?.some(v => v.id === vId));
          if (produit) modifierPanier(produit, vId, col, -1, sens);
        });
      });
      items.querySelectorAll('.moood-cart-qty-plus').forEach(btn => {
        btn.addEventListener('click', () => {
          const vId = parseInt(btn.dataset.variantId);
          const col = btn.dataset.collection;
          const sens = btn.dataset.sens || null;
          const produit = Object.values(state.produits).flat().find(p => p.variants?.some(v => v.id === vId));
          if (produit) modifierPanier(produit, vId, col, 1, sens);
        });
      });
    });
  }

  function updateCardQty(variantId, qty) {
    const card = document.querySelector(`.moood-product-card[data-variant-id="${variantId}"]`);
    if (card) { card.querySelector('.moood-qty-badge').textContent = qty; card.querySelector('.moood-qty-num').textContent = qty; }
  }

  function mooodAvertirIndispo(noms) {
  return new Promise(function (ok) {
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var o = document.createElement('div');
    o.style.cssText = 'position:fixed;inset:0;background:rgba(18,49,43,0.7);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;';
    o.innerHTML = '<div style="background:#fff8ed;border:1.5px solid #12312b;border-radius:18px;box-shadow:6px 6px 0 0 #DFAE3A;max-width:520px;padding:28px;font-family:Inter,-apple-system,sans-serif;color:#12312b;">' +
      '<h3 style="font-style:italic;font-weight:900;font-size:21px;margin:0 0 12px;line-height:1.2;">Produit' + (noms.length > 1 ? 's' : '') + ' indisponible' + (noms.length > 1 ? 's' : '') + '</h3>' +
      '<p style="font-size:15px;line-height:1.5;margin:0 0 10px;">' + (noms.length > 1 ? 'Ces produits ne sont plus disponibles et n\'ont pas été ajoutés' : 'Ce produit n\'est plus disponible et n\'a pas été ajouté') + ' à ton panier :</p>' +
      '<ul style="font-size:14px;line-height:1.5;margin:0 0 14px;padding-left:20px;">' + noms.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('') + '</ul>' +
      '<p style="font-size:15px;line-height:1.5;margin:0 0 20px;">Tous les autres produits de ton pack sont bien ajoutés.</p>' +
      '<button type="button" style="width:100%;background:#12312b;color:#fff3e4;border:1.5px solid #12312b;border-radius:60px;padding:12px 20px;font-weight:700;font-size:14px;cursor:pointer;box-shadow:3px 3px 0 0 #C4622A;">Continuer</button></div>';
    document.body.appendChild(o);
    o.querySelector('button').addEventListener('click', function () { o.remove(); ok(); });
  });
}
async function ajouterAuPanier() {
    if (!state.panier.length) return;
    async function _isSurMesureTag(handle) {

      try {
        const r = await fetch('/products/' + handle + '.js');
        const p = await r.json();
        return (p.tags || []).some(t => t.toLowerCase().trim() === 'produit-sur-mesure');
      } catch(e) { return false; }
    }
    const handlesPack = [...new Set(state.panier.map(i => {
      const sm = (window.mooodSurMesure || []).find(s => s.etapeHandle === i.collection);
      return sm ? sm.handle : null;
    }).filter(Boolean))];
    const smHandlesPack = {};
    await Promise.all(handlesPack.map(async h => { smHandlesPack[h] = await _isSurMesureTag(h); }));
    const smInPack = state.panier.reduce((s, i) => {
      const sm = (window.mooodSurMesure || []).find(x => x.etapeHandle === i.collection);
      const h = sm ? sm.handle : null;
      return s + (h && smHandlesPack[h] ? i.qty : 0);
    }, 0);
    let smInCart = 0;
    try {
      const cartResp = await fetch('/cart.js');
      const cart = await cartResp.json();
      const cartHandles = [...new Set((cart.items || []).map(ci => ci.handle))];
      const smCheck = {};
      await Promise.all(cartHandles.map(async h => { smCheck[h] = await _isSurMesureTag(h); }));
      for (const ci of (cart.items || [])) {
        if (smCheck[ci.handle]) smInCart += ci.quantity;
      }
    } catch(e) {}
    const _smMax = window.mooSurMesureMax || 7; // limite du thème (layout/theme.liquid, MAX_SUR_MESURE)
    if (smInPack + smInCart > _smMax) {
      if (typeof window.mooSurMesurePopup === 'function') {
        window.mooSurMesurePopup();
        setTimeout(function() {
          var msg;
          if (smInCart > 0 && smInPack > 0) {
            msg = 'Tu as déjà ' + smInCart + ' produit' + (smInCart > 1 ? 's' : '') + ' sur-mesure dans ton panier et tu veux en ajouter ' + smInPack + ' avec ce pack (' + (smInCart + smInPack) + ' au total).';
          } else if (smInPack > 0 && smInCart === 0) {
            msg = 'Ton pack contient ' + smInPack + ' produits sur-mesure (limite : ' + _smMax + ' par commande).';
          } else {
            msg = 'Tu as déjà ' + smInCart + ' produits sur-mesure dans ton panier.';
          }
          var nodes = document.querySelectorAll('p, div, span');
          for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (n.children.length === 0 && /Tu as déjà.*produits?\s*sur-mesure dans ton panier/i.test(n.textContent)) {
              n.textContent = msg;
              break;
            }
          }
        }, 50);
      } else {
        alert('Limite atteinte : maximum ' + _smMax + ' produits sur-mesure par commande. Tu as ' + (smInPack + smInCart) + ' produits sur-mesure.');
      }
      return;
    }
    ['desktop', 'mobile'].forEach(t => {
      const b = document.getElementById(`moood-btn-atc-${t}`);
      if (b) { b.disabled = true; b.textContent = 'Préparation du pack…'; }
    });
    try {
      const SUPPORTED_SM = ['plan-de-travail-sur-mesure', 'plan-de-travail-sur-mesure-pour-ilot', 'credence-surmesure', 'plinthe-sur-mesure', 'facade-joue-fileur-plinthe-sur-mesure', 'caisson-sur-mesure', 'niche-sur-mesure', 'credence-sur-mesure-grand-gabarit', 'etagere-sur-mesure', 'porte-derobee-sur-mesure', 'colonne-lave-vaisselle-sur-mesure', 'niche-refrigerateur-sur-mesure'];
      const itemsStandards = [];
      const itemsSurMesure = [];
      for (const i of state.panier) {
        const sm = (window.mooodSurMesure || []).find(s => s.etapeHandle === i.collection);
        const handle = sm ? sm.handle : null;
        if (i.surMesure && i.surMesureProps && handle && SUPPORTED_SM.indexOf(handle) > -1) {
          itemsSurMesure.push({ ...i, _handle: handle });
        } else {
          itemsStandards.push(i);
        }
      }
      // 1) Items standards (et sur-mesure non supportés en v1) en 1 fois
      if (itemsStandards.length) {
        const COLS_BARRE = ['plan-de-travail-barre', 'credence-barre'];
        const items = itemsStandards.map(i => {
          const item = { id: i.variantId, quantity: i.qty };
          const props = {};
          // BUG 1 fix : utiliser le caisson FROZEN par-item (i.caissonCouleur,
          // stocke au moment du add via modifierPanier) et non l'etat COURANT
          // (state.caissonCouleur). Sinon si le client mixe les caissons
          // (ex: meuble1 en Blanc, meuble2 en Gris fonce), tous les items
          // recoivent la property avec le caisson actuellement affiche dans
          // le configurateur, qui ecrasait/affichait le mauvais caisson dans
          // le panier Shopify final. Les variantIds sont deja per-item OK.
          const itemCaisson = i.caissonCouleur || state.caissonCouleur;
          if (itemCaisson && SF_LIST_COLLECTIONS_NO_VARIANTS.has(i.collection)) props['Couleur caisson'] = itemCaisson;
          if (i.sens) props["Sens d'ouverture"] = i.sens.charAt(0).toUpperCase() + i.sens.slice(1);
          if (i.barreProps && Array.isArray(i.barreProps) && COLS_BARRE.indexOf(i.collection) === -1) {
            i.barreProps.forEach(o => { if (o.nom && o.valeur) props[o.nom] = o.valeur; });
          }
          if (Object.keys(props).length) item.properties = props;
          return item;
        });
        const _rAll = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        // 2026-10-22 : un seul produit refusé (retiré du site, épuisé) faisait refuser TOUT l'envoi par Shopify,
        // sans message : seuls les sur-mesure (ajoutés ensuite) arrivaient au panier. On reprend alors un par un.
        if (!_rAll.ok) {
          const _ko = [];
          for (let k = 0; k < items.length; k++) {
            const _r1 = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [items[k]] }) });
            if (!_r1.ok) _ko.push(itemsStandards[k].name || ('Produit ' + items[k].id));
          }
          if (_ko.length) await mooodAvertirIndispo(_ko);
        }
      }
      // Effacer la config persistée pour ne pas restaurer le pack au prochain retour
      try {
        localStorage.removeItem('moood_config');
        clearTimeout(window._mooodReplaceStateTimer);
        history.replaceState(null, '', window.location.pathname);
      } catch(e) {}
      // Effacer la config persistée pour ne pas restaurer le pack au prochain retour
      try {
        localStorage.removeItem('moood_config');
        clearTimeout(window._mooodReplaceStateTimer);
        history.replaceState(null, '', window.location.pathname);
      } catch(e) {}
      // 2) Pas de sur-mesure : direct au panier
      if (!itemsSurMesure.length) {
        window.location.href = '/cart';
        return;
      }
      // 3) Construire la queue et lancer la chaîne
      const queue = itemsSurMesure.map(i => ({
        handle: i._handle,
        variantId: i.variantId,
        price: i.price,
        largeur: i.surMesureProps?.largeur || '',
        longueur: i.surMesureProps?.longueur || '',
        options: i.surMesureProps?.options || []
      }));
      sessionStorage.setItem('mooPackQueue', JSON.stringify(queue));
      sessionStorage.setItem('mooPackIndex', '0');
      sessionStorage.setItem('mooPackTotal', String(queue.length));
      window.location.href = window.mooPackBuildUrl(queue[0], 0, queue.length);
    } catch(e) {
      console.error('Erreur ajout panier:', e);
      ['desktop', 'mobile'].forEach(t => { const b = document.getElementById(`moood-btn-atc-${t}`); if (b) { b.disabled = false; b.textContent = 'Ajouter au panier'; } });
    }
  }

  // ─── Barre d'étapes ────────────────────────────────────────────────────────
  function updateEtapeBarre(handle) {
    const etape = document.querySelector(`.moood-etape[data-etape="${handle}"]`);
    if (etape) etape.classList.add('active');
    const etapes = Array.from(document.querySelectorAll('.moood-etape'));
    const fill = document.getElementById('moood-etapes-fill');
    if (fill && etapes.length > 1) {
      let lastActiveIdx = -1;
      etapes.forEach((el, i) => { if (el.classList.contains('active')) lastActiveIdx = i; });
      fill.style.width = lastActiveIdx <= 0 ? '0%' : (lastActiveIdx / (etapes.length - 1) * 100) + '%';
    }
    etapes.forEach(el => {
      const etapeHandle = el.dataset.etape;
      if (etapeHandle === 'personnalisation') {
        if (state.poigneeChoisie) {
          el.style.cursor = 'pointer';
          el.onclick = function() {
            document.querySelectorAll('.moood-etape').forEach(e => e.classList.remove('current'));
            el.classList.add('current');
            const coulSec = document.getElementById('moood-couleurs-section');
            const caissonSec = document.getElementById('moood-caisson-section');
            const poigSec = document.getElementById('moood-poignee-section');
            const prodSec = document.getElementById('moood-products-sections');
            if (coulSec) coulSec.style.display = '';
            if (caissonSec) caissonSec.style.display = 'block';
            if (poigSec) poigSec.style.display = 'block';
            if (prodSec) prodSec.innerHTML = '';
            const validBtn = document.getElementById('moood-valider-config');
            if (validBtn && state.poigneeChoisie) validBtn.style.display = 'block';
            document.querySelector('.moood-configurateur')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          };
        }
        return;
      }
      if (!state.poigneeChoisie) return;
      const tunnel = getTunnel();
      const idx = tunnel.findIndex(c => c.handle === etapeHandle);
      if (idx < 0) return;
      el.style.cursor = 'pointer';
      el.onclick = function() {
        if (idx !== state.etapeActuelle) {
          state.etapeActuelle = idx;
          renderEtapeProduit();
          document.querySelector('.moood-configurateur')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
    });
  }

  function calcDateLivraison() {
    const jours = 20;
    let date = new Date();
    let ajoutes = 0;
    while (ajoutes < jours) {
      date.setDate(date.getDate() + 1);
      const jour = date.getDay();
      if (jour !== 0 && jour !== 6) ajoutes++;
    }
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  function extraireLargeur(titre) {
    const match = titre.match(/(\d{2,3})\s*cm/i) || titre.match(/L[\s-]?(\d{2,3})/i) || titre.match(/(\d{2,3})\s*mm/i);
    if (!match) return null;
    if (titre.match(/\d{2,3}\s*mm/i)) return (parseInt(match[1]) / 10) + ' cm';
    return match[1] + ' cm';
  }

  function ouvrirHistorique() {
    const hist = JSON.parse(localStorage.getItem('moood_historique_nommé') || '[]');
    if (!hist.length) { alert('Aucune configuration sauvegardée. Utilisez "Sauvegarder" pour enregistrer.'); return; }
    let overlay = document.getElementById('moood-historique-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'moood-historique-overlay';
      overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:1002;align-items:center;justify-content:center;';
      overlay.innerHTML = `<div id="moood-historique-modal" style="background:#fff;border-radius:20px;padding:32px;width:90%;max-width:520px;max-height:80vh;overflow-y:auto;animation:moood-slideup 0.25s ease;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">
          <h3 style="font-size:20px;font-weight:700;color:#12433D;margin:0;">Historique des configurations</h3>
          <button id="moood-historique-close" style="background:none;border:none;cursor:pointer;color:#6b7280;font-size:24px;line-height:1;">×</button>
        </div>
        <div id="moood-historique-list"></div>
      </div>`;
      document.body.appendChild(overlay);
      overlay.addEventListener('click', e => { if (e.target === overlay) overlay.style.display = 'none'; });
      document.getElementById('moood-historique-close').addEventListener('click', () => overlay.style.display = 'none');
    }
    const list = document.getElementById('moood-historique-list');
    list.innerHTML = hist.map((h, i) => {
      const date = new Date(h.ts).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
      const nbProduits = (h.p || []).reduce((s, x) => s + x.q, 0);
      return `<div style="border:1.5px solid #e5e7eb;border-radius:14px;padding:14px 16px;margin-bottom:10px;display:flex;align-items:center;justify-content:space-between;gap:12px;">
        <div style="flex:1;min-width:0;">
          <div style="font-size:13px;font-weight:700;color:#12433D;margin-bottom:2px;">${h.nom || (h.cl + ' · ' + h.pg)}</div>
          <div style="font-size:12px;color:#6b7280;">${h.cl || '—'} · ${h.pg || '—'} · ${nbProduits} produit${nbProduits > 1 ? 's' : ''} · ${date}</div>
        </div>
        <button data-hist-idx="${i}" class="moood-hist-restore-btn" style="padding:8px 16px;border-radius:50px;border:1.5px solid #12433D;background:transparent;color:#12433D;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;">Restaurer</button>
      </div>`;
    }).join('');
    list.querySelectorAll('.moood-hist-restore-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const h = hist[parseInt(btn.dataset.histIdx)];
        overlay.style.display = 'none';
        history.replaceState(null, '', '?config=' + encodeURIComponent(btoa(JSON.stringify(h))));
        location.reload();
      });
    });
    overlay.style.display = 'flex';
  }

  function ouvrirPartager() {
    let overlay = document.getElementById('moood-partager-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'moood-partager-overlay';
      overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:1002;align-items:center;justify-content:center;';
      overlay.innerHTML = `
        <div style="background:#fff;border-radius:20px;padding:32px;width:90%;max-width:420px;animation:moood-slideup 0.25s ease;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;">
            <h3 style="font-size:20px;font-weight:700;color:#12433D;margin:0;">Partager ma configuration</h3>
            <button id="moood-partager-close" style="background:none;border:none;cursor:pointer;color:#6b7280;font-size:24px;line-height:1;">×</button>
          </div>
          <div style="display:flex;flex-direction:column;gap:10px;">
            <button id="moood-partager-lien" style="display:flex;align-items:center;gap:12px;padding:14px 18px;border:1.5px solid #e5e7eb;border-radius:12px;background:#fff;cursor:pointer;font-size:14px;font-weight:600;color:#111827;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#12433D" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
              Copier le lien
            </button>
            <button id="moood-partager-whatsapp" style="display:flex;align-items:center;gap:12px;padding:14px 18px;border:1.5px solid #e5e7eb;border-radius:12px;background:#fff;cursor:pointer;font-size:14px;font-weight:600;color:#111827;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp
            </button>
            <button id="moood-partager-pdf" style="display:flex;align-items:center;gap:12px;padding:14px 18px;border:1.5px solid #e5e7eb;border-radius:12px;background:#fff;cursor:pointer;font-size:14px;font-weight:600;color:#111827;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#12433D" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
              Télécharger le PDF
            </button>
            <button id="moood-partager-email" style="display:flex;align-items:center;gap:12px;padding:14px 18px;border:1.5px solid #e5e7eb;border-radius:12px;background:#fff;cursor:pointer;font-size:14px;font-weight:600;color:#111827;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#12433D" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              Recevoir par email
            </button>
          </div>
          <div id="moood-partager-feedback" style="font-size:13px;text-align:center;margin-top:12px;min-height:20px;"></div>
        </div>
      `;
      document.body.appendChild(overlay);
      overlay.addEventListener('click', e => { if (e.target === overlay) overlay.style.display = 'none'; });
      document.getElementById('moood-partager-close').addEventListener('click', () => overlay.style.display = 'none');
      document.getElementById('moood-partager-lien').addEventListener('click', async function() {
        const feedback = document.getElementById('moood-partager-feedback');
        this.textContent = '⏳ Génération du lien…';
        const config = { cl: state.couleurActive?.name || '', pg: state.poigneeActive || '', p: state.panier.map(i => ({ v: i.variantId, q: i.qty, c: i.collection, s: i.sens || null })) };
        const longUrl = window.location.origin + window.location.pathname + '?config=' + encodeURIComponent(btoa(JSON.stringify(config)));
        let urlToCopy = longUrl;
        try { const r = await fetch('https://is.gd/create.php?format=json&url=' + encodeURIComponent(longUrl)); const d = await r.json(); if (d.shorturl) urlToCopy = d.shorturl; } catch(e) {}
        navigator.clipboard.writeText(urlToCopy).then(() => {
          this.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#12433D" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Lien copié !';
          if (feedback) { feedback.style.color = '#12433D'; feedback.textContent = urlToCopy; }
          setTimeout(() => { this.innerHTML = 'Copier le lien'; if (feedback) feedback.textContent = ''; }, 3000);
        });
      });
      document.getElementById('moood-partager-whatsapp').addEventListener('click', async function() {
        const config = { cl: state.couleurActive?.name || '', pg: state.poigneeActive || '', p: state.panier.map(i => ({ v: i.variantId, q: i.qty, c: i.collection, s: i.sens || null })) };
        const longUrl = window.location.origin + window.location.pathname + '?config=' + encodeURIComponent(btoa(JSON.stringify(config)));
        const total = state.panier.reduce((s, i) => s + i.price * i.qty, 0);
        let urlWa = longUrl;
        try { const r = await fetch('https://is.gd/create.php?format=json&url=' + encodeURIComponent(longUrl)); const d = await r.json(); if (d.shorturl) urlWa = d.shorturl; } catch(e) {}
        const msg = 'Voici ma configuration cuisine moood' + (total > 0 ? ' (' + formatPrice(total) + ')' : '') + ' :\n' + urlWa;
        window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank');
        overlay.style.display = 'none';
      });
      document.getElementById('moood-partager-pdf').addEventListener('click', function() {
        if (typeof genererPDF === 'function') genererPDF();
        overlay.style.display = 'none';
      });
      document.getElementById('moood-partager-email').addEventListener('click', function() {
        overlay.style.display = 'none';
        ouvrirSave();
      });
    }
    overlay.style.display = 'flex';
  }

  function ouvrirSaveNom() {
    let overlay = document.getElementById('moood-savenom-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'moood-savenom-overlay';
      overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:1002;align-items:center;justify-content:center;';
      overlay.innerHTML = `
        <div style="background:#fff;border-radius:20px;padding:32px;width:90%;max-width:420px;animation:moood-slideup 0.25s ease;">
          <h3 style="font-size:20px;font-weight:700;color:#12433D;margin:0 0 8px;">Sauvegarder ma configuration</h3>
          <p style="font-size:14px;color:#6b7280;margin:0 0 20px;line-height:1.5;">Donnez un nom à cette configuration pour la retrouver facilement dans l'historique.</p>
          <input type="text" id="moood-savenom-input" placeholder="Ex : Ma cuisine blanche" style="width:100%;padding:14px 16px;border:1.5px solid #e5e7eb;border-radius:12px;font-size:15px;color:#111827;outline:none;margin-bottom:12px;box-sizing:border-box;" />
          <button id="moood-savenom-submit" style="width:100%;padding:14px;border-radius:50px;border:none;background:#12433D;color:#fff;font-size:15px;font-weight:700;cursor:pointer;margin-bottom:8px;">Sauvegarder</button>
          <button id="moood-savenom-cancel" style="width:100%;padding:12px;border-radius:50px;border:1.5px solid #e5e7eb;background:transparent;color:#6b7280;font-size:14px;font-weight:600;cursor:pointer;">Annuler</button>
          <div id="moood-savenom-feedback" style="font-size:13px;text-align:center;margin-top:8px;min-height:20px;"></div>
        </div>
      `;
      document.body.appendChild(overlay);
      overlay.addEventListener('click', e => { if (e.target === overlay) overlay.style.display = 'none'; });
      document.getElementById('moood-savenom-cancel').addEventListener('click', () => overlay.style.display = 'none');
      document.getElementById('moood-savenom-submit').addEventListener('click', function() {
        const nom = document.getElementById('moood-savenom-input').value.trim();
        const feedback = document.getElementById('moood-savenom-feedback');
        if (!nom) { feedback.style.color = '#ef4444'; feedback.textContent = 'Merci de saisir un nom.'; return; }
        const snap = { nom, cl: state.couleurActive?.name || '', pg: state.poigneeActive || '', p: state.panier.map(i => ({ v: i.variantId, q: i.qty, c: i.collection, col: i.color, s: i.sens || null, sm: i.surMesure || false, prix: i.surMesure ? i.price : undefined })), ts: Date.now() };
        try {
          const hist = JSON.parse(localStorage.getItem('moood_historique_nommé') || '[]');
          hist.unshift(snap);
          localStorage.setItem('moood_historique_nommé', JSON.stringify(hist.slice(0, 20)));
        } catch(e) {}
        feedback.style.color = '#12433D';
        feedback.textContent = '✓ Configuration sauvegardée !';
        document.getElementById('moood-savenom-input').value = '';
        setTimeout(() => { overlay.style.display = 'none'; feedback.textContent = ''; }, 1500);
      });
    }
    overlay.style.display = 'flex';
  }
// ─── Grille couleurs précises du caisson (Couleur au choix) ──────────────
  var _mooodCaissonColors = [];
  var RE_CAISSON_MEL = /deco/i;
  var RE_CAISSON_BOIS = /ch.ne|noyer|eb.ne|bois |textur|structur|stri|sculpt|bross/i;
  function renderCaissonColors() {
    var grid = document.getElementById('moood-caisson-colors-grid');
    if (!grid) return;
    function build() {
      if (grid.children.length) return;
      var mel = [], bois = [];
      for (var i = 0; i < _mooodCaissonColors.length; i++) {
        var n = _mooodCaissonColors[i].name;
        if (RE_CAISSON_MEL.test(n)) mel.push(_mooodCaissonColors[i]);
        else if (RE_CAISSON_BOIS.test(n)) bois.push(_mooodCaissonColors[i]);
      }
      function grp(title, arr) {
        if (!arr.length) return '';
        var h = '<div style="width:100%;"><span style="font-style:italic;font-weight:900;font-size:15px;color:#12312b;margin:8px 0 10px;display:block;">' + title + '</span><div style="display:flex;flex-wrap:wrap;gap:8px;">';
        for (var j = 0; j < arr.length; j++) {
          var col = arr[j];
          var sn = col.name.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
          h += '<button type="button" class="moood-caisson-swatch" data-caisson-color="' + sn + '" title="' + sn + '" style="width:48px;display:inline-flex;flex-direction:column;align-items:center;gap:4px;border:none;background:none;cursor:pointer;padding:0;"><span style="width:44px;height:44px;border-radius:50%;border:1.5px solid #12312b;overflow:hidden;display:block;background:#e0dbd3 center/cover no-repeat' + (col.img ? (' url(' + col.img + ')') : '') + ';"></span><span style="font-family:Caveat,cursive;font-size:12px;color:#6f7f7b;text-align:center;line-height:1.1;">' + col.name + '</span></button>';
        }
        h += '</div></div>';
        return h;
      }
      grid.innerHTML = grp('Mélaminé', mel) + grp('Bois texturé', bois);
      var sbtns = grid.querySelectorAll('[data-caisson-color]');
      for (var k = 0; k < sbtns.length; k++) {
        sbtns[k].addEventListener('click', (function(name) {
          return function() {
            state.caissonColorPrecise = name;
            state.caissonCouleur = name;
            for (var m = 0; m < sbtns.length; m++) {
              var sw = sbtns[m].querySelector('span');
              sw.style.boxShadow = sbtns[m].getAttribute('data-caisson-color') === name ? '0 0 0 2px #fff,0 0 0 4px #C4622A' : 'none';
            }
            var lbl = document.getElementById('moood-caisson-color-label');
            if (lbl) lbl.textContent = 'Caisson : ' + name;
            updateRappel();
            var tunnel = getTunnel();
            var col = tunnel[state.etapeActuelle];
            if (col && state.produits[col.handle]) renderCollection(col);
          };
        })(sbtns[k].getAttribute('data-caisson-color')));
      }
    }
    if (_mooodCaissonColors.length) { build(); return; }
    fetch('/products/facade-joue-fileur-plinthe-sur-mesure.js').then(function(r) { return r.json(); }).then(function(p) {
      var vs = p.variants || [], seen = {};
      for (var i = 0; i < vs.length; i++) {
        var cn = vs[i].option1 || vs[i].title;
        if (!seen[cn]) { seen[cn] = true; _mooodCaissonColors.push({ name: cn, img: vs[i].featured_image ? vs[i].featured_image.src : '' }); }
      }
      build();
    }).catch(function() {});
  }
  function ouvrirPopup() { document.getElementById('moood-popup-overlay')?.classList.add('open'); }
  function fermerPopup() { document.getElementById('moood-popup-overlay')?.classList.remove('open'); }
  function ouvrirSave() { document.getElementById('moood-save-overlay')?.classList.add('open'); }

  // ─── Init ──────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {

    document.getElementById('moood-popup-close')?.addEventListener('click', fermerPopup);
    document.getElementById('moood-popup-overlay')?.addEventListener('click', function(e) { if (e.target === this) fermerPopup(); });
    document.getElementById('moood-btn-atc-desktop')?.addEventListener('click', ajouterAuPanier);
    document.getElementById('moood-btn-atc-mobile')?.addEventListener('click', ajouterAuPanier);
    document.getElementById('moood-mobile-bar')?.addEventListener('click', () => document.getElementById('moood-mobile-cart-overlay')?.classList.add('open'));
    document.getElementById('moood-mobile-cart-close')?.addEventListener('click', () => document.getElementById('moood-mobile-cart-overlay')?.classList.remove('open'));
    document.getElementById('moood-mobile-partager-btn')?.addEventListener('click', () => { document.getElementById('moood-mobile-cart-overlay')?.classList.remove('open'); ouvrirPartager(); });
    document.getElementById('moood-mobile-save-btn')?.addEventListener('click', () => { document.getElementById('moood-mobile-cart-overlay')?.classList.remove('open'); ouvrirSaveNom(); });
    const livraisonDateMobileEl = document.getElementById('moood-cart-livraison-date-mobile');
    if (livraisonDateMobileEl) livraisonDateMobileEl.textContent = calcDateLivraison();
    document.getElementById('moood-mobile-cart-overlay')?.addEventListener('click', function(e) { if (e.target === this) this.classList.remove('open'); });
    document.getElementById('moood-btn-valider-config')?.addEventListener('click', () => {
      document.getElementById('moood-couleurs-section').style.display = 'none';
      document.getElementById('moood-caisson-section').style.display = 'none';
      document.getElementById('moood-poignee-section').style.display = 'none';
      document.getElementById('moood-valider-config').style.display = 'none';
      renderEtapeProduit();
    });

    document.querySelectorAll('.moood-caisson-btn').forEach(btn => btn.addEventListener('click', () => {
      const choix = btn.dataset.caisson;
      document.querySelectorAll('.moood-caisson-btn').forEach(b => {
        b.classList.toggle('active', b.dataset.caisson === choix);
      });
      const box = document.getElementById('moood-caisson-colors');
      if (choix === 'Couleur au choix') {
        renderCaissonColors();
        if (box) box.style.display = 'block';
        // tant qu'aucune couleur précise n'est choisie, on garde le libellé générique
        state.caissonCouleur = state.caissonColorPrecise || 'Couleur au choix';
      } else {
        if (box) box.style.display = 'none';
        state.caissonColorPrecise = '';
        state.caissonCouleur = choix;
      }
      updateRappel();
      // Re-render la collection courante pour mettre à jour les prix
      const tunnel = window.mooodGetTunnel ? window.mooodGetTunnel() : [];
      const col = tunnel[window.mooodState?.etapeActuelle || 0];
      if (col && window.mooodState?.produits?.[col.handle]) {
        const container = document.querySelector(`.moood-collection-section[data-collection="${col.handle}"] .moood-products-grid`);
        if (container) {
          // On réutilise renderCollection via mooodState
          const event = new CustomEvent('moood:caisson-change', { detail: { caissonCouleur: state.caissonCouleur } });
          document.dispatchEvent(event);
        }
      }
    }));
    document.querySelectorAll('.moood-poignee-btn').forEach(btn => btn.addEventListener('click', () => selectPoignee(btn.dataset.poignee, btn.dataset.poigneeType)));
    document.getElementById('moood-btn-wishlist-desktop')?.addEventListener('click', ajouterAuPanier);
    document.getElementById('moood-btn-pdf-cart')?.addEventListener('click', function() {
      this.style.borderColor = '#12433D'; this.style.color = '#12433D';
      this.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg> ⏳ Génération…';
      const self = this;
      setTimeout(() => {
        if (typeof genererPDF === 'function') genererPDF();
        setTimeout(() => {
          self.style.borderColor = ''; self.style.color = '';
          self.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg> Télécharger la fiche PDF';
        }, 2500);
      }, 100);
    });
    document.getElementById('moood-save-btn-cart')?.addEventListener('click', function() {
      this.style.borderColor = '#12433D'; this.style.color = '#12433D';
      const self = this;
      setTimeout(() => { self.style.borderColor = ''; self.style.color = ''; }, 300);
      ouvrirSave();
    });
    document.getElementById('moood-save-cancel')?.addEventListener('click', () => document.getElementById('moood-save-overlay')?.classList.remove('open'));
    document.getElementById('moood-save-overlay')?.addEventListener('click', function(e) { if (e.target === this) this.classList.remove('open'); });

    document.getElementById('moood-save-submit')?.addEventListener('click', async function() {
      const email = document.getElementById('moood-save-email')?.value?.trim();
      const feedback = document.getElementById('moood-save-feedback');
      if (!email || !email.includes('@')) {
        if (feedback) { feedback.style.color = '#ef4444'; feedback.textContent = 'Merci de saisir un email valide.'; }
        return;
      }
      this.disabled = true;
      this.textContent = 'Envoi en cours…';
      const config = { cl: state.couleurActive?.name || '', pg: state.poigneeActive || '', p: state.panier.map(i => ({ v: i.variantId, q: i.qty, c: i.collection, col: i.color, s: i.sens || null, sm: i.surMesure || false, prix: i.surMesure ? i.price : undefined })) };
      const configParam = encodeURIComponent(btoa(JSON.stringify(config)));
      const pageUrl = window.location.origin + window.location.pathname + '?config=' + configParam;
      const tunnel = getTunnel();
      let resume = 'Ma configuration moood :\n\n';
      if (state.couleurActive) resume += 'Coloris : ' + state.couleurActive.name + '\n';
      if (state.poigneeActive) resume += 'Poignée : ' + state.poigneeActive + '\n\n';
      const byCol = {};
      state.panier.forEach(item => {
        const colObj = tunnel.find(c => c.handle === item.collection);
        const colTitle = colObj?.title || item.collection;
        if (!byCol[colTitle]) byCol[colTitle] = [];
        byCol[colTitle].push(item.name + ' x' + item.qty + ' — ' + formatPrice(item.price * item.qty));
      });
      for (const [col, items] of Object.entries(byCol)) {
        resume += col + ' :\n' + items.map(i => '  · ' + i).join('\n') + '\n\n';
      }
      const total = state.panier.reduce((s, i) => s + i.price * i.qty, 0);
      resume += 'Total estimé : ' + formatPrice(total) + '\n\nLien : ' + pageUrl;
      try {
        const brevoKey = window.mooodConfig?.brevoKey || '';
        const emailDest = window.mooodConfig?.brevoEmailDest || 'contact@moood.fr';
        if (!brevoKey) throw new Error('Clé API Brevo manquante');
        let shortUrl = pageUrl;
        try { const sr = await fetch('https://is.gd/create.php?format=json&url=' + encodeURIComponent(pageUrl)); const sd = await sr.json(); if (sd.shorturl) shortUrl = sd.shorturl; } catch(e) {}
        const totalEmail = state.panier.reduce((s, i) => s + i.price * i.qty, 0);
        const totalQtyEmail = state.panier.reduce((s, i) => s + i.qty, 0);
        const clientPayload = {
          sender: { name: 'moood', email: emailDest },
          to: [{ email }],
          subject: 'Votre configuration cuisine moood',
          htmlContent: `<div style="font-family:sans-serif;max-width:600px;margin:0 auto;background:#fff;">
            <div style="background:#F5F0EA;padding:28px 32px;text-align:center;">
              <img src="https://moood.fr/cdn/shop/files/moood-logo-noir-fond-transparent.png?v=1764748700&width=4884" alt="moood" style="height:40px;width:auto;" />
            </div>
            <div style="padding:32px;">
              <h2 style="font-size:20px;font-weight:700;color:#12433D;margin:0 0 8px;">Votre configuration cuisine</h2>
              <p style="font-size:14px;color:#6b7280;margin:0 0 24px;">Retrouvez ci-dessous le récapitulatif de votre sélection.</p>
              <pre style="background:#f9fafb;border-radius:12px;padding:16px;font-size:13px;line-height:1.6;white-space:pre-wrap;">${resume}</pre>
              <div style="text-align:center;margin:24px 0;">
                <a href="${shortUrl}" style="display:inline-block;background:#12433D;color:#fff;padding:14px 32px;border-radius:50px;text-decoration:none;font-weight:700;font-size:15px;">Reprendre ma configuration</a>
              </div>
              <div style="background:#F5F0EA;border-radius:12px;padding:20px 24px;">
                <div style="font-size:15px;font-weight:700;color:#111827;margin-bottom:8px;">Besoin d'aide ?</div>
                <p style="font-size:13px;color:#6b7280;margin:0 0 10px;line-height:1.6;">Contactez-nous, nous nous ferons un plaisir de vous accompagner !</p>
                <div style="font-size:13px;color:#374151;line-height:2;">
                  <div><strong>moood</strong> — 23 rue de Chapeau rouge, 38070 Saint Quentin Fallavier</div>
                  <div>Tél : <a href="tel:0474946588" style="color:#12433D;font-weight:600;">04 74 94 65 88</a></div>
                  <div>Email : <a href="mailto:hello@moood.fr" style="color:#12433D;font-weight:600;">hello@moood.fr</a></div>
                </div>
              </div>
            </div>
            <div style="background:#f3f4f6;padding:16px 32px;text-align:center;">
              <p style="font-size:12px;color:#9ca3af;margin:0;">moood.fr — Cette fiche est une estimation non contractuelle.</p>
            </div>
          </div>`
        };
        const respClient = await fetch('https://api.brevo.com/v3/smtp/email', { method: 'POST', headers: { 'api-key': brevoKey, 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(clientPayload) });
        if (!respClient.ok) { const err = await respClient.json(); throw new Error('Brevo: ' + (err.message || respClient.status)); }
        // Ajout du contact à la liste séquence catalogue
        try {
          await fetch('https://api.brevo.com/v3/contacts', { method: 'POST', headers: { 'api-key': brevoKey, 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ email: email, listIds: [4], updateEnabled: true }) });
        } catch(e) { console.warn('Ajout liste Brevo:', e); }
        const adminPayload = {
          sender: { name: 'moood Configurateur', email: emailDest },
          to: [{ email: emailDest }],
          subject: 'Nouvelle configuration sauvegardée — ' + email,
          htmlContent: '<div style="font-family:sans-serif;padding:24px;"><h2 style="color:#12433D;">Nouvelle configuration de ' + email + '</h2><pre style="background:#f9fafb;border-radius:12px;padding:16px;font-size:13px;line-height:1.6;white-space:pre-wrap;">' + resume + '</pre></div>'
        };
        await fetch('https://api.brevo.com/v3/smtp/email', { method: 'POST', headers: { 'api-key': brevoKey, 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(adminPayload) });
        if (feedback) { feedback.style.color = '#12433D'; feedback.textContent = '✓ Email envoyé ! Vérifiez votre boîte mail.'; }
        this.textContent = '✓ Envoyé !';
        setTimeout(() => { document.getElementById('moood-save-overlay')?.classList.remove('open'); }, 2500);
      } catch(e) {
        if (feedback) { feedback.style.color = '#ef4444'; feedback.textContent = 'Erreur: ' + e.message; }
        this.disabled = false;
        this.textContent = 'Recevoir ma configuration par email';
        console.error('Save error:', e);
      }
    });

    const livraisonDateEl = document.getElementById('moood-cart-livraison-date');
    if (livraisonDateEl) livraisonDateEl.textContent = calcDateLivraison();

    async function init() {
      try {
        const params = new URLSearchParams(window.location.search);
        if (!params.get('config')) {
          const saved = localStorage.getItem('moood_config');
          if (saved) { const parsed = JSON.parse(saved); if (parsed.p?.length || parsed.cl || parsed.pg) { history.replaceState(null, '', '?config=' + encodeURIComponent(btoa(saved))); } }
        }
      } catch(e) {}

      let configARestaurer = null;
      try {
        const params = new URLSearchParams(window.location.search);
        const configParam = params.get('config');
        if (configParam) {
          configARestaurer = JSON.parse(atob(decodeURIComponent(configParam)));
          if (configARestaurer.couleur !== undefined) {
            configARestaurer.cl = configARestaurer.couleur;
            configARestaurer.pg = configARestaurer.poignee;
            configARestaurer.p = configARestaurer.panier;
          }
        }
      } catch(e) { console.warn('Config URL invalide', e); }

      if (configARestaurer?.cc) {
        state.caissonCouleur = configARestaurer.cc;
        // 2026-10-23 : teinte précise sauvegardée (cc = nom de la couleur) -> caisson « couleur au choix » à la restauration,
        // sinon les prix repartaient sur le caisson blanc
        if (['Blanc', 'Gris anthracite', 'Couleur au choix', 'Bois'].indexOf(configARestaurer.cc) === -1) state.caissonColorPrecise = configARestaurer.cc;
      }
      if (configARestaurer?.pgBas || configARestaurer?.pg || configARestaurer?.poignee) {
        const poigneeBasVal = configARestaurer.pgBas || configARestaurer.pg || configARestaurer.poignee;
        const poigneeHautVal = configARestaurer.pgHaut || configARestaurer.pg || configARestaurer.poignee;
        state.poigneeBasColonne = poigneeBasVal;
        state.poigneeHaut = poigneeHautVal;
        state.poigneeActive = poigneeBasVal;
        state.poigneeChoisie = true;
        document.querySelectorAll('.moood-poignee-btn[data-poignee-type="bas"]').forEach(btn => btn.classList.toggle('active', btn.dataset.poignee === poigneeBasVal));
        document.querySelectorAll('.moood-poignee-btn[data-poignee-type="haut"]').forEach(btn => btn.classList.toggle('active', btn.dataset.poignee === poigneeHautVal));
        updateEtapeBarre('poignee');
        document.getElementById('moood-couleur-required')?.classList.add('hidden');
        document.getElementById('moood-products-sections')?.classList.remove('moood-products-locked');
        document.getElementById('moood-poignee-section').style.display = 'block';
      }

      if (window.mooodConfig?.afficherCouleurs) {
        await chargerCouleurs();
        if (configARestaurer?.cl || configARestaurer?.couleur) {
          const c = state.allCouleurs.find(x => x.name === (configARestaurer.cl || configARestaurer.couleur));
          if (c) await selectCouleur(c, false);
        }
      } else {
        state.poigneeChoisie = true;
      }

      const panierARestaurer = configARestaurer?.p || configARestaurer?.panier || [];
      if (panierARestaurer.length && state.poigneeChoisie) {
        let restoreOverlay = document.getElementById('moood-restore-overlay');
        if (!restoreOverlay) {
          restoreOverlay = document.createElement('div');
          restoreOverlay.id = 'moood-restore-overlay';
          restoreOverlay.className = 'moood-restore-overlay';
          restoreOverlay.innerHTML = `<div class="moood-restore-spinner"></div><div class="moood-restore-text">Nous récupérons votre configuration…</div><div class="moood-restore-sub">Cela peut prendre quelques secondes</div>`;
          document.body.appendChild(restoreOverlay);
        }
        restoreOverlay.classList.add('open');
        const colsNeeded = [...new Set(panierARestaurer.map(i => i.c))];
        await Promise.all(colsNeeded.map(async (colHandle) => {
          if (!state.produits[colHandle]) {
            try {
              // Restore via loadCollectionData (Storefront API pour
              // collections whitelist, fallback products.json).
              const loaded = await loadCollectionData(colHandle);
              state.produits[colHandle] = loaded.products;
            } catch(e) { console.warn('Erreur chargement collection', colHandle, e); }
          }
        }));
        for (const item of panierARestaurer) {
          // Produits sur-mesure : productId synthetique ('surmesure-*') et
          // variant absent des collections chargees -> le lookup ci-dessous
          // echouerait toujours et l'item serait jete. Toutes les donnees
          // (nom, prix, dimensions, image) sont dans le snap, on reconstruit
          // directement sans lookup.
          if (item.sm) {
            let smImg = item.img || '';
            if (!smImg && item.col) {
              const sw = state.allCouleurs.find(c => c.name === item.col);
              if (sw && sw.swatchImage) smImg = sw.swatchImage;
            }
            state.panier.push({
              productId: item.pid || ('surmesure-' + (item.c || 'item')),
              variantId: item.v,
              name: item.nm || 'Produit sur mesure',
              color: item.col,
              price: (item.prix !== undefined && item.prix !== null && item.prix !== '') ? (parseFloat(item.prix) || 0) : 0,
              image: smImg,
              qty: item.q,
              collection: item.c,
              surMesure: true,
              sens: item.s || null,
              surMesureProps: item.smp || undefined,
              poignee: item.poig || undefined,
              caissonCouleur: item.caissc || undefined,
            });
            continue;
          }
          // Recherche du produit : d'abord par productId (nouveau format snap),
          // sinon fallback sur la recherche par variantId dans variants (ancien
          // format). Le fallback ne fonctionne QUE pour les variants 1..250e du
          // produit (limitation products.json) ; au-dela, productId est requis.
          let produit = null;
          if (item.pid && state.produits[item.c]) {
            produit = state.produits[item.c].find(p => p.id === item.pid);
          }
          if (!produit) {
            produit = state.produits[item.c]?.find(p => p.variants?.some(v => v.id === item.v));
          }
          if (!produit) {
            console.warn('[restore] produit introuvable pour item', item);
            continue;
          }
          // Le variant peut etre absent si l'item.v est au-dela des 250 premiers
          // variants du produit (cas Caisson couleur au choix + couleur lointaine).
          // On ne fait PLUS continue : on utilise les valeurs sauvegardees comme
          // fallback. Pour les OLD configs sans item.prix : on tombe sur 0 (panier
          // affiche le bon nom et qty, mais prix 0 — degradation acceptee).
          const variant = produit.variants?.find(v => v.id === item.v) || null;

          // Image : priorite item.img sauvegarde > swatch couleur (surMesure) >
          // getVariantImage > product.featured_image > 1ere image variant.
          let finalImg = '';
          if (item.img) {
            finalImg = item.img;
          } else if (item.sm && item.col) {
            const swatchMatch = state.allCouleurs.find(c => c.name === item.col);
            if (swatchMatch && swatchMatch.swatchImage) finalImg = swatchMatch.swatchImage;
          }
          if (!finalImg && variant) {
            finalImg = getVariantImage(produit, variant);
          }
          if (!finalImg) {
            finalImg = produit.featured_image || (produit.images && produit.images[0]) || '';
          }

          // Prix : item.prix (nouveau format, toujours sauve) > variant.price
          // > 0. parseFloat pour normaliser string -> number.
          let finalPrice;
          if (item.prix !== undefined && item.prix !== null && item.prix !== '') {
            finalPrice = parseFloat(item.prix) || 0;
          } else if (variant) {
            finalPrice = parseFloat(variant.price) || 0;
          } else {
            finalPrice = 0;
          }

          state.panier.push({
            productId: produit.id,
            variantId: item.v,
            name: item.nm || produit.title,
            color: item.col,
            price: finalPrice,
            image: finalImg,
            qty: item.q,
            collection: item.c,
            surMesure: item.sm || false,
            sens: item.s || null,
            surMesureProps: item.smp || undefined,
            poignee: item.poig || undefined,
            caissonCouleur: item.caissc || undefined,
          });
        }
        document.getElementById('moood-restore-overlay')?.classList.remove('open');
        renderPanier();
        colsNeeded.forEach(h => updateEtapeBarre(h));
        const tunnel = getTunnel();
        let dernierIdx = 0;
        tunnel.forEach((col, idx) => { if (colsNeeded.includes(col.handle)) dernierIdx = idx; });
        state.etapeActuelle = dernierIdx;
      }

      if (state.poigneeChoisie) renderEtapeProduit();

      try {
        const params = new URLSearchParams(window.location.search);
        if (params.get('pdf') === '1') { setTimeout(() => { if (typeof genererPDF === 'function') genererPDF(); }, 4000); }
      } catch(e) {}
    }

    init();
  });

  window.mooodState = state;
  window.mooodGetTunnel = getTunnel;
  window.mooodFormatPrice = formatPrice;
  window.mooodRenderPanier = renderPanier;

  document.addEventListener('moood:caisson-change', function() {
    const tunnel = getTunnel();
    const col = tunnel[state.etapeActuelle];
    if (col && state.produits[col.handle]) renderCollection(col);
  });

})();
/* anim pose 1780997000 - accordeon detail pose animation + scrollIntoView */

